webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
__webpack_require__(73);
__webpack_require__(72);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*---------------------------------------*

	API HANDLER

----------------------------------------*/

window.apiHandler = {

	/*---------------------------------------*
 	BASE URL
 ----------------------------------------*/

	url: false,

	getUrl: function getUrl() {
		return window.appSettings.getUrl();
	},

	getWGUrl: function getWGUrl() {
		return window.appSettings.getWGUrl();
	},

	getImageCloudUrl: function getImageCloudUrl() {
		var url = "//res.cloudinary.com/desenio/image/upload/"; // The default url for local development
		return url;
	},

	/*---------------------------------------*
 	GETTER
 ----------------------------------------*/

	get: function get(postData, returnFunction, forceLive, dataType) {
		var fetchArticles = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

		var self = this;

		var isFetchingArticles = null;

		// Prevent any duplicate requests
		if (window.vueInstance && fetchArticles) {

			isFetchingArticles = window.vueInstance.$store.state.isFetchingArticles;

			if (isFetchingArticles) {
				isFetchingArticles.abort();
			}
		}

		// Force live version
		if (typeof forceLive == 'undefined') var forceLive = false;

		// Datatype that will be used
		if (typeof dataType == 'undefined') var dataType = 'json';

		// If using local enviroment
		if (window.localEnviroment && !forceLive) {
			$.ajax({
				type: "post",
				url: "https://desenio.se/includes/backend/apiTaker.php",
				async: true,
				dataType: dataType,
				data: postData,
				beforeSend: function beforeSend(data) {
					if (fetchArticles) window.vueInstance.$store.commit('sendingApiRequest', data);
				},
				success: function success(data) {
					if (fetchArticles) window.vueInstance.$store.commit('sendingApiRequest', null);

					data = self.convertData(data);
					returnFunction(data);
				},
				error: function error(e) {
					if (fetchArticles) {
						window.vueInstance.$store.commit('sendingApiRequest', null);
						return false;
					}

					if (e.status == 200) {
						data = self.convertData(e.responseText);
						returnFunction(data);
					} else {
						window.eventHub.$emit('promptError');
						return false;
					}
				}
			});
		}
		// If using live enviroment
		else {

				$.ajax({
					type: "get",
					url: postData.url,
					dataType: dataType,
					async: true,
					beforeSend: function beforeSend(data) {
						if (fetchArticles) window.vueInstance.$store.commit('sendingApiRequest', data);
					},
					success: function success(data) {
						if (fetchArticles) window.vueInstance.$store.commit('sendingApiRequest', null);

						data = self.convertData(data);
						returnFunction(data);
					},
					error: function error(e) {
						if (fetchArticles) {
							window.vueInstance.$store.commit('sendingApiRequest', null);
							return false;
						}
						if (e.status == 200) {
							data = self.convertData(e.responseText);
							returnFunction(data);
						} else {
							window.eventHub.$emit('promptError');
							return false;
						}
					}
				});
			}
	},

	/*---------------------------------------*
 POSTER
 ----------------------------------------*/

	post: function post(postData, returnFunction) {

		var self = this;

		$.ajax({
			type: "post",
			url: postData.url,
			dataType: 'json',
			async: true,
			data: postData.data,
			success: function success(data) {

				data = self.convertData(data);
				returnFunction(data);
			},
			error: function error(e) {
				if (e.status == 200) {
					data = self.convertData(e.responseText);
					returnFunction(data);
				} else {
					window.eventHub.$emit('promptError');
					return false;
				}
			}
		});
	},

	/*-------------------------------------------------*
 DATA
 -------------------------------------------------*/

	getSiteCart: function getSiteCart(returnFunction) {

		var basketID = window.vueInstance.$store.state.basketID;

		if (!basketID) {
			returnFunction(false);
			return;
		}

		var postData = {
			url: this.getWGUrl() + '/api/cart/get?locale=' + window.currentLangCodeExternal + '&id=' + basketID
		};

		this.get(postData, function (data) {
			returnFunction(data);
		}, true);
	},
	changeSiteCartQty: function changeSiteCartQty(returnFunction, failFunction, params) {

		var postData = {
			data: {
				id: window.vueInstance.$store.state.basketID,
				item: params.item,
				rowIndex: params.rowIndex,
				quantity: params.qty
			},
			url: this.getWGUrl() + '/api/cart/update?locale=' + window.currentLangCodeExternal + ''
		};

		this.post(postData, function (data) {
			returnFunction(data);
		});
	},


	getSavedWalls: function getSavedWalls(returnFunction, wallData) {

		var postData = {
			url: this.getWGUrl() + '/api/getSavedWalls?session=' + window.vueInstance.$localStorage.get('sessionID')
		};

		this.get(postData, function (data) {
			returnFunction(data);
		}, true);
	},

	pictureWalls: function pictureWalls(returnFunction) {

		var postData = {
			url: this.getWGUrl() + '/api/walls'
		};

		this.get(postData, function (data) {
			returnFunction(data);
		}, true);
	},

	pictureWall: function pictureWall(id, returnFunction) {

		var postData = {
			url: this.getUrl() + '/shop?funk=get_article_configurator_ajax&format=json&configurator_id=' + id
		};

		this.get(postData, function (data) {
			returnFunction(data);
		});
	},

	articlesWGR: function articlesWGR(returnFunction, queryData) {

		var self = this;

		// Get variables
		var fieldID = window.vueInstance.$store.state.currentWallField;
		var currentField = window.vueInstance.$store.state.pictureWall['articles'][fieldID - 1];
		var sorting = window.vueInstance.$store.state.currentArticleSorting;

		var format = 'portrait';

		// If not default format
		if (typeof currentField.format != 'undefined') format = currentField.format;

		// Get chosen filter items to use in url
		var filterItems = window.filterMappingHandler.getCurrentFilterOptions();

		// Append the ones that belong to the current chosen slot (size and format)
		filterItems.push(window.filterMappingHandler.getIDFromSize(currentField.size));
		filterItems.push(window.filterMappingHandler.getIDFromFormat(format));

		// Method
		var method = "articles";
		var searchQuery = "";

		// Search
		if (window.vueInstance.$store.state.searchQuery) {
			method = 'articles/search';
			searchQuery = "&searchQuery=" + window.vueInstance.$store.state.searchQuery;
		}

		// Build url
		var url = this.getWGUrl() + '/api/' + method + '?locale=' + window.currentLangCodeExternal + '&page=' + queryData.page + searchQuery;

		if (filterItems.length) url += "&filterItems=" + filterItems.toString();

		var postData = {
			url: url
		};

		self.get(postData, function (data) {
			self.commitArticleGet(data, queryData, returnFunction);
		}, true, 'json', true);
	},

	specificArticles: function specificArticles(returnFunction, queryData) {

		var self = this;

		// Combinations	
		var postData = {
			url: this.getWGUrl() + '/api/articlesExtended?locale=' + window.currentLangCodeExternal + '&productIDs=' + queryData.articles.toString()
		};

		self.get(postData, function (data) {
			returnFunction(data);
		}, true, 'json', true);
	},

	commitArticleGet: function commitArticleGet(data, queryData, returnFunction) {
		window.vueInstance.$store.commit('articleFilter', data.filters);
		returnFunction(data);
	},
	frameswG: function frameswG(returnFunction, queryData) {

		var self = this;

		// Combinations	
		var postData = {
			url: this.getWGUrl() + '/api/frames?locale=' + window.currentLangCodeExternal
		};

		self.get(postData, function (data) {
			returnFunction(data);
		}, true, 'json', true);
	},
	frames: function frames(returnFunction) {

		var postData = {
			url: "https://desenio-ecommerce.com/pictureWall/frames/" + window.vueInstance.$t('countryCode')
		};

		this.get(postData, function (data) {
			returnFunction(data);
		}, true);
	},
	campaignArticles: function campaignArticles(returnFunction) {

		var postData = {
			url: 'https://desenio-ecommerce.com/pictureWall/campaignArticles'
		};

		this.get(postData, function (data) {
			returnFunction(data);
		});
	},


	backgrounds: function backgrounds(returnFunction) {

		var self = this;

		var postData = {
			url: self.getWGUrl() + '/api/backgrounds'
		};

		self.get(postData, function (data) {

			// All our images are named in order for us to categorise them
			// Format: "id-color.jpg"

			// Background object
			var backgrounds = {};

			// Group into a associative structure
			$.each(data, function () {

				// Remove data
				var file = this.split('\\').pop().split('/').pop();
				var fileNoExt = file.replace(/\.[^/.]+$/, "");

				// Get id and color
				var id = fileNoExt.substr(0, fileNoExt.indexOf('-'));
				var color = fileNoExt.substr(fileNoExt.indexOf("-") + 1);

				// Add background to object if not exists
				if (typeof backgrounds[id] == 'undefined') {
					backgrounds[id] = {
						'id': id,
						'preview': id + "-" + window.appSettings.defaultBackground.key + ".jpg",
						colors: {}
					};
				}

				// Add color to background
				backgrounds[id].colors[color] = file;
			});

			returnFunction(backgrounds);
		}, true);
	},

	colors: function colors(returnFunction) {
		var colors = __webpack_require__(23);
		returnFunction(colors);
	},

	/*---------------------------------------*
 	FUNCTIONS
 ----------------------------------------*/

	buildChosenArticles: function buildChosenArticles(settings) {

		var articles = [];
		var outOfStock = [];
		var checkStock = false;
		var includeFrames = true;

		if (typeof settings != 'undefined') {
			if (settings.checkStock) checkStock = true;

			if (typeof settings.includeFrames != 'undefined' && !settings.includeFrames) includeFrames = false;
		}

		// Build array with current articles
		$.each(window.vueInstance.$store.state.chosenArticles, function () {

			if (typeof settings != 'undefined' && settings.checkStock) if (this.stock == 0) outOfStock.push(this);

			if (typeof this.id !== "undefined") articles.push(this.id);
		});

		// Frames
		if (includeFrames) $.each(window.vueInstance.$store.state.pictureWall.articles, function (index, article) {

			// Check if article and frame is chosen for this field
			var chosenFrame = window.vueInstance.$store.state.chosenFrames[index + 1];

			// Check if article has required data
			if (article && typeof chosenFrame != 'undefined' && typeof chosenFrame.combinationID != 'undefined') articles.push(chosenFrame.combinationID);

			if (checkStock && chosenFrame && typeof chosenFrame['combinations'] != 'undefined') if (chosenFrame['combinations'][0].stock == 0) outOfStock.push(chosenFrame['combinations'][0]);
		});

		$.each(outOfStock, function (index, value) {

			var cartNoStock = window.vueInstance.$store.state.cartNoStock;
			cartNoStock.push(value);
			window.vueInstance.$store.commit('cartNoStock', cartNoStock);
		});

		if (outOfStock && typeof outOfStock[0] != 'undefined') {
			// Tell user that some products failed to add to cart
			window.eventHub.$emit('openModal', {
				modal: 'noStock'
			});
		}

		return articles;
	},

	buy: function buy(returnFunction) {

		var self = this;

		// Clear out of stock messages
		window.vueInstance.$store.commit('cartNoStock', []);

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'buyButton');

		// Get articles
		var articles = this.buildChosenArticles({
			checkStock: true
		});

		// Check if there are any articles
		if (articles.length) {

			// Basket ID
			var basketID = window.vueInstance.$store.state.basketID;

			// Postdata
			var postData = {
				items: articles.toString()
			};

			if (basketID) {
				postData['id'] = basketID;
			}

			this.post({
				url: self.getWGUrl() + '/api/cart/add?locale=' + window.currentLangCodeExternal + '',
				data: postData
			}, function (data) {

				if (typeof data.cart != 'undefined' && data.cart) window.vueInstance.$store.commit('basketID', data.cart);

				returnFunction(data);
			});
		}
		// If there are no articles, open modal telling the person to add some
		else {
				window.vueInstance.$store.commit('stopLoading', 'buyButton');
				window.eventHub.$emit('promptError', window.vueInstance.$t("noProductsInBasket"));
			}
	},

	generateSaveData: function generateSaveData(data) {

		// Get articles
		var articles = this.buildChosenArticles({ frames: false });

		// Set article to each field
		var skus = [];
		$.each(window.vueInstance.$store.state.pictureWall.articles, function (index, value) {

			if (typeof window.vueInstance.$store.state.chosenArticles[index + 1] != 'undefined') skus.push(window.vueInstance.$store.state.chosenArticles[index + 1].productID);else skus.push("");
		});

		// Get frames
		var framesToParse = window.vueInstance.$store.state.chosenFrames;
		var frames = [];

		$.each(framesToParse, function (index, value) {
			frames.push(value.id);
		});

		// Information
		var information = {
			name: data.name,
			picture: data.picture,
			skus: skus,
			articles: window.vueInstance.$store.state.pictureWall.articles,
			frames: frames,
			pictureWallColor: window.vueInstance.$store.state.pictureWallColor,
			background: window.vueInstance.$store.state.background
		};

		// Save data to post
		var saveData = JSON.stringify(information);

		return saveData;
	},

	save: function save(returnFunction, data) {

		var self = this;

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'save');

		// Get basic save data
		var saveData = this.generateSaveData(data);
		var name = data.name;
		var sessionID = window.vueInstance.$localStorage.get('sessionID');
		var info = JSON.parse(saveData);

		// Post
		var postData = {
			url: this.getWGUrl() + '/api/saveWall',
			data: {
				'settings': saveData,
				'session': sessionID
			}
		};

		this.post(postData, function (data) {

			window.vueInstance.$store.commit('currentWallID', {
				id: data.savedWall.id,
				identifier: data.savedWall.identifier
			});
			window.vueInstance.$store.commit('stopLoading', 'save');
			window.vueInstance.$store.commit('updated', 0);
			window.vueInstance.$store.commit('wallPicture', info.picture);
			window.vueInstance.$store.commit('currentWallName', name);

			returnFunction(data);
		});
	},

	updateSave: function updateSave(returnFunction, data) {

		var self = this;

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'save');

		// Get basic save data
		var saveData = this.generateSaveData(data);
		var name = data.name;
		var info = JSON.parse(saveData);

		// Set new data
		var identifiers = window.vueInstance.$store.state.currentWallID;

		var postData = {
			url: this.getWGUrl() + '/api/updateWall',
			data: {
				'settings': saveData,
				'id': identifiers.id,
				'identifier': identifiers.identifier
			}
		};

		this.post(postData, function (data) {
			window.vueInstance.$store.commit('stopLoading', 'save');
			window.vueInstance.$store.commit('wallPicture', info.picture);
			window.vueInstance.$store.commit('currentWallName', name);
			returnFunction(data);
		});
	},

	removeSave: function removeSave(returnFunction, data) {

		var self = this;

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'deleteSave' + data.id);

		var postData = {
			url: self.getUrl() + '/shop?funk=remove_article_configurator&id=' + data.id
		};

		self.get(postData, function (data) {
			window.vueInstance.$store.commit('stopLoading', 'deleteSave' + data.id);
			returnFunction(data);
		});
	},

	convertData: function convertData(badstring) {
		return badstring;
	}
};

window.apiHandler.getUrl();

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language__ = __webpack_require__(24);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* unused harmony export language */
/* unused harmony export eventHub */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

var Cookies = __webpack_require__(1);

var localEnviroment = window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("dev.desenio") > -1;

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](_extends({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_5__language__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__components_App___default.a));



/***/ }),
/* 13 */
/***/ (function(module, exports) {

/*---------------------------------------*

	FILTER MAPPING HANDLER

----------------------------------------*/

window.filterMappingHandler = {
    getCurrentFilterOptions: function getCurrentFilterOptions() {

        if (!window.vueInstance.$store.state.chosenArticleFilter.length) return [];

        var filterList = [];
        $.each(window.vueInstance.$store.state.chosenArticleFilter, function (index, value) {
            filterList.push(value.id);
        });

        return filterList;
    },
    getIDFromSize: function getIDFromSize(size) {

        switch (size) {
            case '13x18':
                return 24;
                break;
            case '21x30':
                return 15;
                break;
            case '30x40':
                return 4;
                break;
            case '40x50':
                return 32;
                break;
            case '50x50':
                return 43;
                break;
            case '50x70':
                return 8;
                break;
            case '70x100':
                return 28;
                break;
        }
    },
    getIDFromFormat: function getIDFromFormat(format) {
        switch (format) {
            case 'portrait':
                return 3;
                break;
            case 'landscape':
                return 26;
                break;
            case 'square':
                return 42;
                break;
        }
    }
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// Wait 1 milisec before proceeding
window.vueRender = function (toDo) {
    setTimeout(function () {
        toDo();
    }, 1);
};

// Finds the right index by key and value
window.findIndex = function (array, attr, value) {
    for (var i = 0; i < array.length; i++) {
        if (array[i].hasOwnProperty(attr) && array[i][attr] === value) {
            return i;
        }
    }
    return -1;
};

window.replaceAll = function (str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/*---------------------------------------------------------
	Define mixins here
------------------------------------------------------------*/

var mixins = [

/*---------------------------------
	Mixin for handling clearing
----------------------------------*/

{
	mixin: __webpack_require__(27)
},

/*---------------------------------
	Mixin for handling save promt
----------------------------------*/

{
	mixin: __webpack_require__(36)
},

/*---------------------------------
	Mixin for handling error promt
----------------------------------*/

{
	mixin: __webpack_require__(30)
},

/*---------------------------------
	Mixin for handling encodings
----------------------------------*/

{
	mixin: __webpack_require__(29)
},

/*---------------------------------
	Mixin for checks
----------------------------------*/

{
	mixin: __webpack_require__(26)
},

/*---------------------------------
	Mixin for pickers
----------------------------------*/

{
	mixin: __webpack_require__(34)
},

/*---------------------------------
	Mixin for settings
----------------------------------*/

{
	mixin: __webpack_require__(38)
},

/*---------------------------------
	Mixin for saving articles
----------------------------------*/

{
	mixin: __webpack_require__(35)
},

/*---------------------------------
	Images
----------------------------------*/

{
	mixin: __webpack_require__(33)
},

/*---------------------------------
	Filter
----------------------------------*/

{
	mixin: __webpack_require__(32)
},

/*---------------------------------
	Mixin for miscs
----------------------------------*/

{
	mixin: __webpack_require__(37)
}, {
	mixin: __webpack_require__(28)
}, {
	mixin: __webpack_require__(31)
},

/*---------------------------------
	Checkout
----------------------------------*/

{
	mixin: __webpack_require__(25)
}];

/*---------------------------------------------------------*/

// Build modules export
var out = [];
for (var i in mixins) {

	out.push(mixins[i].mixin);
}

// Routes
module.exports = out;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);

window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var settings = {

	// Default color for background images
	defaultBackground: {
		"key": "grey",
		"preview": "grey",
		"border": "1px solid rgba(0, 0, 0, 0.1)"
	},

	standardApiUrl: "",

	wgURL: '', // Change to local url if dev localy, leave empty in production

	// Image url
	productImageUrl: 'https://images.desenio.com',

	// Image cloud upload url (standard)
	imageCloudUrl: "//res.cloudinary.com/desenio/image/upload/",

	// Image cloud backgrounds url
	imageCloudBackgroundUrl: "//res.cloudinary.com/desenio/image/upload/v1502888905/backgrounds/",

	getResizedImageFromCloud: function getResizedImageFromCloud(width, file, folder) {

		if (typeof folder == 'undefined') var folder = "";

		return this.imageCloudUrl + "w_" + width + "/" + folder + file;
	},


	getWGUrl: function getWGUrl() {
		return this.wgURL;
	},

	getUrl: function getUrl() {

		var url = this.standardApiUrl;

		if (typeof window.appApi != 'undefined' && window.appApi != '<apiURL>') {
			url = window.appApi;
		}

		if (typeof window.enviroment != 'undefined' && window.enviroment == 'production') {
			url = "";
		}

		this.url = url;

		return url;
	},

	getImageCloudUrl: function getImageCloudUrl() {

		var url = this.imageCloudUrl; // The default url for local development
		return url;
	}

};

module.exports = settings;

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(84)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = [{"key":"grey","preview":"#b5b5b5","border":"0"},{"key":"dark","preview":"#6d6b6b","border":"0"},{"key":"white","preview":"white","border":"1px solid rgba(0, 0, 0, 0.1)"},{"key":"blue","preview":"rgb(156, 205, 216)","border":"0"},{"key":"green","preview":"rgb(174, 199, 187)","border":"0"},{"key":"pink","preview":"rgb(224, 195, 195)","border":"0"}]

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(117);
var _sv, _no, _dk, _en, _nl, _fr, _es, _de, _it, _pt, _pl, _cs, _sk, _el;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var Cookies = __webpack_require__(1);

// Ready translated locale messages
var messages = {
    sv: (_sv = {

        countryCode: 'SV',
        yes: 'ja',
        no: 'nej',
        abort: 'avbryt',
        my: 'mina',
        done: 'klar',
        pick: 'välj',
        save: 'spara',
        share: 'dela',
        buy: 'köp',
        addToCart: 'Lägg i',
        name: 'Namn',
        currencySuffix: ' kr',
        currencySuffixBuy: ':-',
        currencyPrefix: '',
        frameYourMotifs: 'Rama in dina motiv',

        background: 'miljöbild | miljöbilder',
        picturewall: 'tavelvägg | tavelväggar',
        backgroundColor: 'bakgrundsfärg | bakgrundsfärger',
        color: 'färg | färger',
        motifs: 'motiv | motiv',

        clear: 'Rensa',

        filter: 'Filter',
        showFilter: 'Visa filter',
        hideFilter: 'Dölj filter',
        clearFilter: 'Rensa filter',
        category: 'Kategori',

        allArticles: 'Alla',
        articles: 'artiklar',

        clickToPickMotif: 'Klicka på en tavla i tavelväggen för att välja motiv.',
        clickToPickWall: 'Välj en tavelvägg innan du väljer motiv',

        turnDevice: 'Vänd på din enhet',
        swipeUp: 'Swipa uppåt',

        waresAddedToCart: 'Dina varor har lagts i varukorgen',
        proceedingToCheckout: 'Tar dig vidare till kassan',
        saveBasket: 'Spara tavelväggen',
        noSavedWalls: 'Inga sparade tavelväggar',
        updateOrnew: 'Du har valt en sparad tavelvägg som heter {name}, vill du uppdatera befintlig eller skapa en ny sparning? ',
        createNew: 'skapa ny',
        update: 'uppdatera',

        shareTitle: 'Dela din tavelvägg',

        shareSaveTitle: 'Du måste spara först',
        shareSaveText: 'Du måste spara din tavelvägg innan du kan dela den, vill du spara tavelväggen nu?',

        errorTitle: 'Något gick fel.',
        errorMessage: 'Ett tekniskt fel uppstod, var god försök igen eller kontakta support.',
        showMore: 'Visa fler',
        showLess: 'Visa mindre',
        noProductsInBasket: 'Var god välj minst en produkt att lägga i varukorgen.',
        removeTitle: 'Ta bort tavelvägg',
        removePromt: 'Är du säker på att du vill ta bort tavelväggen?',
        couldNotRemove: 'Kunde inte ta bort, var god försök igen eller kontakta support.',
        remove: 'Ta bort',
        removeFrame: 'Ta bort ram',
        close: 'Stäng',
        wantToContinue: 'Vill du fortsätta?',
        unsavedChanges: 'Du har osparade ändringar som går förlorade om du fortsätter, vill du spara din tavelvägg nu?',

        needsArticlesShare: 'Var god lägg till minst en artikel innan du delar.',
        needsArticlesSave: 'Var god lägg till minst en artikel innan du sparar.',
        needsPictureWall: 'Var god välj en tavelvägg innan du väljer artiklar.',

        menu: 'Meny',

        noMotivs: 'Du har inte valt några motiv',

        leavingSave: 'Du har inte sparat din tavelvägg, vill du lämna?',

        addedToCartDate: 'Lagd i varukorg {date}',

        saveAndMoveOn: 'Nästa',
        moveOn: 'Nästa',
        saveAndClose: 'Spara och stäng',

        backgrounds: '1. Välj miljöbild',
        pictureWalls: '2. Välj tavelvägg',
        yourMotifs: '3. Välj motiv',
        frames: '4. Rama in dina motiv',

        leftToFreeShipping: 'Kvar till fri frakt',
        checkout: 'Kassan',
        total: 'totalsumma',

        emptyBasket: 'Du har inte lagt några produkter i varukorgen.',
        allProducts: 'Alla produkter',
        lastViewed: 'Senast visade',
        myFavorites: 'Mina favoriter',
        lastChosen: 'Senast valda',
        choosePictureWallBeforeFrames: 'Var god välj en tavelvägg innan du väljer ram.',

        dontSave: "spara inte",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Använd hjärtsymbolen för att spara dina favoriter. <br/> Visa favoriter i rullistan uppe till vänster.',
        purchaseNowTitle: 'Vad fint det blev!',
        purchaseNow: 'Du kan lägga hela din tavelvägg i varukorgen här.'
    }, _defineProperty(_sv, 'addToCart', 'Lägg i'), _defineProperty(_sv, 'addToCartSmall', 'Lägg i'), _defineProperty(_sv, 'toCheckout', 'Till kassan'), _defineProperty(_sv, 'savedWalls', 'Sparade tavelväggar'), _defineProperty(_sv, 'goBackToStep', 'Föregående'), _defineProperty(_sv, 'favoritesThatMatch', 'Favoriter som finns i vald storlek'), _defineProperty(_sv, 'favoritesThatMatchMobile', 'Favoriter i vald storlek'), _defineProperty(_sv, 'noStock', 'Några varor är slut i lager.'), _defineProperty(_sv, 'startTop', 'Steg-för-steg'), _defineProperty(_sv, 'startTitle', 'Skapa den perfekta tavelväggen'), _defineProperty(_sv, 'startText', 'Använd vårt nya verktyg för att hitta motiv och ramar som matchar med varandra.'), _defineProperty(_sv, 'startButton', 'BÖRJA HÄR'), _defineProperty(_sv, 'clickFullscreen', 'Klicka för att starta fullskärm'), _defineProperty(_sv, 'noArticlesMatched', 'Tyvärr finns inte några artiklar i storleken  <b> {size} </b> som matchar dina val'), _defineProperty(_sv, 'breadcrumbPrints', 'Tavlor'), _defineProperty(_sv, 'breadcrumbInsp', 'Inspiration'), _defineProperty(_sv, 'breadcrumbInspLink', 'https://desenio.se/g/tavelvaggar/'), _defineProperty(_sv, 'breadcrumbGw', 'Bygg din tavelvägg'), _defineProperty(_sv, 'breadcrumbGwLink', 'https://gwt.desenio.se/#/'), _defineProperty(_sv, 'linkToWall', 'Länk till din tavelvägg'), _defineProperty(_sv, 'copy', 'Kopiera'), _defineProperty(_sv, 'outOfStock', 'Slut i lager'), _defineProperty(_sv, 'outOfStockText', 'Artiklarna nedan är slut i lager, du kan bevaka artiklarna för att bli notifierad när de återkommer i lager. '), _defineProperty(_sv, 'checkoutUrl', 'https://checkout.desenio.se'), _defineProperty(_sv, 'pageUrl', 'https://desenio.se'), _sv),

    no: (_no = {
        countryCode: 'NO',
        yes: 'ja',
        no: 'nei',
        abort: 'avbryt',
        my: 'mine',
        done: 'ferdig',
        pick: 'velg',
        save: 'lagre',
        share: 'del',
        buy: 'kjøp',
        addToCart: 'Legg til',
        name: 'Navn',
        currencySuffix: ' ,-',
        currencySuffixBuy: ',-',
        currencyPrefix: '',
        frameYourMotifs: 'Ram inn motivene dine',
        background: 'miljøbilde | miljøbilder',
        picturewall: 'bildevegg | bildevegger',
        backgroundColor: 'bakgrunnsfarge | bakgrunnsfarger',
        color: 'farge | farger',
        motifs: 'motiv | motiver',
        clear: 'Tøm',
        filter: 'Filter',
        showFilter: 'Vis filter',
        hideFilter: 'Skjul filter',
        clearFilter: 'Tøm filter',
        category: 'Kategori',
        allArticles: 'Alle',
        articles: 'artikler',
        clickToPickMotif: 'Klikk på et bilde på bildeveggen for å velge motiv.',
        clickToPickWall: 'Velg en bildevegg før du velger motiv',
        turnDevice: 'Snu enheten din',
        swipeUp: 'Sveip opp',
        waresAddedToCart: 'Varene er lagt i handlekurven',
        proceedingToCheckout: 'Tar deg videre til kassen',
        saveBasket: 'Lagre bildeveggen',
        noSavedWalls: 'Ingen lagrede bildevegger',
        updateOrnew: 'Du har valgt en lagret bildevegg som heter {name}. Vil du oppdatere eksisterende eller opprette en ny utgave? ',
        createNew: 'opprett ny',
        update: 'oppdater',
        shareTitle: 'Del bildeveggen din',
        shareSaveTitle: 'Du må lagre først',
        shareSaveText: 'Du må lagre bildeveggen før du kan dele den. Vil du lagre bildeveggen nå?',
        errorTitle: 'Noe gikk galt.',
        errorMessage: 'Det oppstod en teknisk feil. Prøv på nytt, eller kontakt kundestøtte.',
        showMore: 'Vis flere',
        showLess: 'Vis færre',
        noProductsInBasket: 'Velg minst ett produkt som skal legges i handlekurven.',
        removeTitle: 'Slett bildevegg',
        removePromt: 'Vil du slette bildeveggen?',
        couldNotRemove: 'Kunne ikke slette. Prøv på nytt, eller kontakt brukerstøtte.',
        remove: 'Fjern',
        removeFrame: 'Fjern ramme',
        close: 'Lukk',
        wantToContinue: 'Vil du fortsette?',
        unsavedChanges: 'Du har endringer som ikke er lagret. Disse går tapt hvis du fortsetter. Vil du lagre bildeveggen nå?',
        needsArticlesShare: 'Legg til minst én artikkel før du deler.',
        needsArticlesSave: 'Legg til minst én artikkel før du lagrer.',
        needsPictureWall: 'Velg en bildevegg før du velger artikler.',
        menu: 'Meny',
        noMotivs: 'Du har ikke valgt noen motiver',
        leavingSave: 'Du har ikke lagret bildeveggen din. Vil du avslutte?',
        addedToCartDate: 'Lagt i handlekurv {date}',
        saveAndMoveOn: 'Neste',
        moveOn: 'Neste',
        saveAndClose: 'Lagre og lukk',
        backgrounds: '1. Velg miljøbilde',
        pictureWalls: '2. Velg bildevegg',
        yourMotifs: '3. Velg motiv',
        frames: '4. Ram inn motivene dine',
        leftToFreeShipping: 'Unna gratis frakt',
        checkout: 'Kassen',
        total: 'sum',
        emptyBasket: 'Du har ikke lagt noen produkter i handlekurven.',
        allProducts: 'Alle produkter',
        lastViewed: 'Sist vist',
        myFavorites: 'Mine favoritter',
        lastChosen: 'Sist valgt',
        choosePictureWallBeforeFrames: 'Velg en bildevegg før du velger ramme.',
        dontSave: "ikke lagre",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Bruk hjertesymbolet til å lagre favorittene dine. <br/> Vis favoritter i rullelisten øverst til venstre.',
        purchaseNowTitle: 'Så fint det ble!',
        purchaseNow: 'Du kan legge hele bildeveggen i handlekurven her.'
    }, _defineProperty(_no, 'addToCart', 'Legg til'), _defineProperty(_no, 'addToCartSmall', 'Legg til'), _defineProperty(_no, 'toCheckout', 'Kassen'), _defineProperty(_no, 'savedWalls', 'Lagrede bildevegger'), _defineProperty(_no, 'goBackToStep', 'Forrige'), _defineProperty(_no, 'favoritesThatMatch', 'Favoritter som finnes i valgt størrelse'), _defineProperty(_no, 'favoritesThatMatchMobile', 'Favoritter i valgt størrelse'), _defineProperty(_no, 'noStock', 'Noen varer er utsolgt.'), _defineProperty(_no, 'startTop', 'Steg-för-steg'), _defineProperty(_no, 'startTitle', 'Skap den perfekte bildeveggen'), _defineProperty(_no, 'startText', 'Bruk det nye verktøyet vårt for å finne motiver og rammer som passer sammen.'), _defineProperty(_no, 'startButton', 'START HER'), _defineProperty(_no, 'clickFullscreen', 'Klikk for fullskjerm'), _defineProperty(_no, 'noArticlesMatched', 'Vi kan dessverre ikke finne et produkt som matcher din søkning'), _defineProperty(_no, 'breadcrumbPrints', 'Plakater'), _defineProperty(_no, 'breadcrumbInsp', 'Inspirasjon '), _defineProperty(_no, 'breadcrumbInspLink', 'https://desenio.no/g/bildevegger/'), _defineProperty(_no, 'breadcrumbGw', 'Lag din bildevegg'), _defineProperty(_no, 'breadcrumbGwLink', 'https://gwt.desenio.no/'), _defineProperty(_no, 'linkToWall', 'LINK TIL DIN BILDEVEGG'), _defineProperty(_no, 'copy', 'Kopier'), _defineProperty(_no, 'outOfStock', 'Utsolgt'), _defineProperty(_no, 'outOfStockText', 'Varene nedenfor er utsolgt, du kan overvåke varene som skal varsles når de kommer tilbake på lager.'), _defineProperty(_no, 'checkoutUrl', 'https://checkout.desenio.no'), _defineProperty(_no, 'pageUrl', 'https://desenio.no'), _no),
    fi: {
        countryCode: 'FI',
        yes: 'kyllä',
        no: 'ei',
        abort: 'keskeytä',
        my: 'minun',
        done: 'valmis',
        pick: 'valitse',
        save: 'tallenna',
        share: 'jaa',
        buy: 'osta',
        addToCart: 'Lisää',
        name: 'Nimi',
        currencySuffix: ' &euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Kehystä aiheesi',
        background: 'ympäristökuva | ympäristökuvat',
        picturewall: 'tauluseinä | tauluseinät',
        backgroundColor: 'taustaväri | taustavärit',
        color: 'väri | värit',
        motifs: 'aihe | aiheet',
        clear: 'Poista',
        filter: 'Suodatin',
        showFilter: 'Näytä suodatin',
        hideFilter: 'Piilota suodatin',
        clearFilter: 'Poista suodatin',
        category: 'Luokka',
        allArticles: 'Kaikki',
        articles: 'tuotteet',
        clickToPickMotif: 'Napsauta taulua tauluseinällä valitaksesi aiheen.',
        clickToPickWall: 'Valitse tauluseinä ennen aiheen valintaa',
        turnDevice: 'Käännä yksikköä',
        swipeUp: 'Pyyhkäise ylös',
        waresAddedToCart: 'Tuotteesi on lisätty ostoskoriin',
        proceedingToCheckout: 'Jatka kassalle',
        saveBasket: 'Tallenna tauluseinä',
        noSavedWalls: 'Ei tallennettuja tauluseiniä',
        updateOrnew: 'Olet valinnut tauluseinän {nimi}. Haluatko päivittää nykyistä vai luoda uuden tallennettavaksi? ',
        createNew: 'luo uusi',
        update: 'päivitä',
        shareTitle: 'Jaa tauluseinäsi',
        shareSaveTitle: 'Tallenna ensin',
        shareSaveText: 'Sinun on tallennettava tauluseinäsi voidaksesi jakaa sen. Haluatko tallentaa tauluseinän nyt?',
        errorTitle: 'Jokin meni vikaan.',
        errorMessage: 'Tapahtui tekninen virhe. Yritä uudelleen tai ota yhteys tukeen.',
        showMore: 'Näytä lisää',
        showLess: 'Näytä vähemmän',
        noProductsInBasket: 'Valitse vähintään yksi tuote lisättäväksi ostoskoriin.',
        removeTitle: 'Poista tauluseinä',
        removePromt: 'Haluatko varmasti poistaa tauluseinän?',
        couldNotRemove: 'Poistaminen ei onnistunut. Yritä uudelleen tai ota yhteys tukeen.',
        remove: 'Poista',
        removeFrame: 'Poista kehys',
        close: 'Sulje',
        wantToContinue: 'Haluatko jatkaa?',
        unsavedChanges: 'Jos jatkat tallentamatta, muutokset poistetaan. Haluatko tallentaa tauluseinäsi nyt?',
        needsArticlesShare: 'Lisää ainakin yksi tuote, ennen kuin voit jakaa.',
        needsArticlesSave: 'Lisää ainakin yksi tuote, ennen kuin voit tallentaa.',
        needsPictureWall: 'Valitse tauluseinä ennen tuotteiden valintaa,',
        menu: 'Valikko',
        noMotivs: 'Et ole valinnut aiheita',
        leavingSave: 'Et ole tallentanut tauluseinääsi, haluatko silti poistua?',
        addedToCartDate: 'Lisätty ostoskoriin {date}',
        saveAndMoveOn: 'Seuraava vaihe',
        moveOn: 'Seuraava vaihe',
        saveAndClose: 'Tallenna ja sulje',
        backgrounds: '1. Valitse ympäristökuva',
        pictureWalls: '2. Valitse tauluseinä',
        yourMotifs: '3. Valitse aihe',
        frames: '4. Kehystä aiheesi',
        leftToFreeShipping: 'Jäljellä ilmaiseen kuljetukseen',
        checkout: 'Kassa',
        total: 'kokonaissumma',
        emptyBasket: 'Ostoskorisi on tyhjä.',
        allProducts: 'Kaikki tuotteet',
        lastViewed: 'Viimeksi katsellut',
        myFavorites: 'Omat suosikkini',
        lastChosen: 'Viimeksi valitut',
        choosePictureWallBeforeFrames: 'Valitse tauluseinä ennen kehysten valintaa,',
        dontSave: "älä tallenna",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Vinkkejä ',
        heartInfo: 'Tallenna sydänkuvakkeella suosikkisi. <br/> Näytä suosikit vieritysvalikossa vasemmalla ylhäällä.',
        purchaseNowTitle: 'Tulipa siitä hieno!',
        purchaseNow: 'Voit lisätä koko tauluseinäsi ostoskoriin tästä.',
        addToCartSmall: 'Lisää',
        toCheckout: 'Kassa',
        savedWalls: 'Tallennetut tauluseinät',
        goBackToStep: 'Edellinen vaihe',
        favoritesThatMatch: 'Suosikit, joita on saatavana valittuna kokona',
        favoritesThatMatchMobile: 'Suosikit valittuna kokona',
        noStock: 'Jotkin tuotteet ovat loppuneet varastosta.',

        startTop: 'Askel askeleelta',
        startTitle: 'Luo täydellinen tauluseinä',
        startText: 'Käytä uutta työkaluamme löytääksesi yhteensopivat aiheet ja kehykset',
        startButton: 'ALOITA TÄSTÄ',
        clickFullscreen: 'Klikkaa tästä',

        noArticlesMatched: 'Pahoittelut, emme löydä tuotteita koossa (size), jotka vastaavat hakuasi',
        breadcrumbPrints: 'Tauluja',
        breadcrumbInsp: 'Inspiraatiojulisteet',
        breadcrumbInspLink: 'https://desenio.fi/g/tauluseinat/',
        breadcrumbGw: 'Rakenna tauluseinäsi',
        breadcrumbGwLink: 'https://gwt.desenio.fi/',

        linkToWall: 'LINKKI TAULUSEINÄÄSI',
        copy: 'Kopioi',

        outOfStock: 'Ei varastossa',
        outOfStockText: 'Alla olevat tuotteet ovat loppu, voit seurata tuotteita ja saada ilmoituksen, kun ne tulevat takaisin varastoon.',

        checkoutUrl: 'https://checkout.desenio.fi',
        pageUrl: 'https://desenio.fi'

    },
    dk: (_dk = {
        countryCode: 'DK',
        yes: 'ja',
        no: 'nej',
        abort: 'afbryd',
        my: 'mine',
        done: 'udført',
        pick: 'vælg',
        save: 'gem',
        share: 'del',
        buy: 'køb',
        addToCart: 'Læg til',
        name: 'Navn',
        currencySuffix: ' kr.',
        currencySuffixBuy: ':-',
        currencyPrefix: '',
        frameYourMotifs: 'Indram dine motiver',
        background: 'miljøbillede | miljøbilleder',
        picturewall: 'billedvæg | billedvægge',
        backgroundColor: 'baggrundsfarve | baggrundsfarver',
        color: 'farve | farver',
        motifs: 'motiv | motiver',
        clear: 'Ryd',
        filter: 'Filter',
        showFilter: 'Vis filter',
        hideFilter: 'Skjul filter',
        clearFilter: 'Ryd filter',
        category: 'Kategori',
        allArticles: 'Alle',
        articles: 'varer',
        clickToPickMotif: 'Klik på et billede på billedvæggen for at vælge motiv.',
        clickToPickWall: 'Vælg en billedvæg, inden du vælger motiv',
        turnDevice: 'Vend din enhed',
        swipeUp: 'Swipe opad',
        waresAddedToCart: 'Dine varer er lagt i indkøbsvognen',
        proceedingToCheckout: 'Gå videre til kassen',
        saveBasket: 'Gem billedvæggen',
        noSavedWalls: 'Der er ingen gemte billedvægge',
        updateOrnew: 'Du har valgt en gemt billedvæg kaldet {name}. Vil du opdatere den eksisterende eller oprette en ny, der skal gemmes? ',
        createNew: 'opret ny',
        update: 'opdater',
        shareTitle: 'Del din billedvæg',
        shareSaveTitle: 'Du skal gemme først',
        shareSaveText: 'Du skal gemme din billedvæg, før du kan dele den. Vil du gemme billedvæggen nu?',
        errorTitle: 'Der gik noget galt.',
        errorMessage: 'Der opstod en teknisk fejl. Prøv igen, eller kontakt support.',
        showMore: 'Vis flere',
        showLess: 'Vis mindre',
        noProductsInBasket: 'Du skal vælge mindst ét produkt, der skal lægges i indkøbsvognen.',
        removeTitle: 'Slet billedvæg',
        removePromt: 'Er du sikker på, at du vil slette billedvæggen?',
        couldNotRemove: 'Det var ikke muligt at slette. Prøv igen, eller kontakt support.',
        remove: 'Slet',
        removeFrame: 'Slet ramme',
        close: 'Luk',
        wantToContinue: 'Vil du fortsætte?',
        unsavedChanges: 'Der er ændringer, der ikke er gemt. De går tabt, hvis du fortsætter. Vil du gemme billedvægen nu?',
        needsArticlesShare: 'Tilføj mindst én vare, før du deler.',
        needsArticlesSave: 'Tilføj mindst én vare, før du gemmer.',
        needsPictureWall: 'Vælg en billedvæg, inden du vælger varer.',
        menu: 'Menu',
        noMotivs: 'Du har ikke valgt nogen motiver',
        leavingSave: 'Du har ikke gemt billedvæggen. Vil du afslutte?',
        addedToCartDate: 'Lagt i indkøbsvogn {date}',
        saveAndMoveOn: 'Næste',
        moveOn: 'Næste',
        saveAndClose: 'Gem og luk',
        backgrounds: '1. Vælg miljøbillede',
        pictureWalls: '2. Vælg billedvæg',
        yourMotifs: '3. Vælg motiv',
        frames: '4. Indram dine motiver',
        leftToFreeShipping: 'Tilbage indtil gratis fragt',
        checkout: 'Til kassen',
        total: 'i alt',
        emptyBasket: 'Du har ikke lagt nogen produkter i indkøbsvognen.',
        allProducts: 'Alle produkter',
        lastViewed: 'Sidst viste',
        myFavorites: 'Mine favoritter',
        lastChosen: 'Sidst valgte',
        choosePictureWallBeforeFrames: 'Vælg en billedvæg, inden du vælger ramme.',
        dontSave: "gem ikke",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Brug hjerteikonet til at gemme dine favoritter. <br/> Få vist favoritter i rullelisten øverst til venstre.',
        purchaseNowTitle: 'Hvor er det flot!',
        purchaseNow: 'Du kan lægge hele din billedvæg i indkøbsvognen her.'
    }, _defineProperty(_dk, 'addToCart', 'Læg til'), _defineProperty(_dk, 'addToCartSmall', 'Læg til'), _defineProperty(_dk, 'toCheckout', 'Til kassen'), _defineProperty(_dk, 'savedWalls', 'Gemte billedvægge'), _defineProperty(_dk, 'goBackToStep', 'Forrige'), _defineProperty(_dk, 'favoritesThatMatch', 'Favoritter, der findes i den valgte størrelse'), _defineProperty(_dk, 'favoritesThatMatchMobile', 'Favoritter i valgt størrelse'), _defineProperty(_dk, 'noStock', 'Nogle af varerne er ikke på lager.'), _defineProperty(_dk, 'startTop', 'Trin for trin'), _defineProperty(_dk, 'startTitle', 'Skab den perfekte billedvæg'), _defineProperty(_dk, 'startText', 'Brug vores nye værktøj til at finde motiver og rammer, der passer sammen.'), _defineProperty(_dk, 'startButton', 'BEGYND HER'), _defineProperty(_dk, 'clickFullscreen', 'Klik for fuldskærm'), _defineProperty(_dk, 'noArticlesMatched', 'Vi kan desværre ikke finde et produkt i (størrelse) som matcher din søgning.'), _defineProperty(_dk, 'breadcrumbPrints', 'Posters'), _defineProperty(_dk, 'breadcrumbInsp', 'Inspiration'), _defineProperty(_dk, 'breadcrumbInspLink', 'https://desenio.dk/g/billedvaeg/'), _defineProperty(_dk, 'breadcrumbGw', 'Byg din billedvæg'), _defineProperty(_dk, 'breadcrumbGwLink', 'https://gwt.desenio.dk/'), _defineProperty(_dk, 'linkToWall', 'Link til dit væg galleri'), _defineProperty(_dk, 'copy', 'Kopier'), _defineProperty(_dk, 'outOfStock', 'Ikke på lager'), _defineProperty(_dk, 'outOfStockText', 'Nedenstående varer er ikke på lager, du kan overvåge varerne for at få besked, når de kommer på lager igen.'), _defineProperty(_dk, 'checkoutUrl', 'https://checkout.desenio.dk'), _defineProperty(_dk, 'pageUrl', 'https://desenio.dk'), _dk),
    en: (_en = {
        countryCode: 'EN',
        yes: 'yes',
        no: 'no',
        abort: 'cancel',
        my: 'my',
        done: 'done',
        pick: 'select',
        save: 'save',
        share: 'share',
        buy: 'buy',
        addToCart: 'Add to',
        name: 'Name',
        currencySuffix: '',
        currencySuffixBuy: '',
        currencyPrefix: '£',
        frameYourMotifs: 'Frame your designs',
        background: 'background | backgrounds',
        picturewall: 'picture wall | picture walls',
        backgroundColor: 'background colour | background colours',
        color: 'colour | colours',
        motifs: 'design | designs',
        clear: 'Clear',
        filter: 'Filter',
        showFilter: 'Show filter',
        hideFilter: 'Hide filter',
        clearFilter: 'Clear filter',
        category: 'Category',
        allArticles: 'All',
        articles: 'articles',
        clickToPickMotif: 'Click on a picture on the picture wall to select a design.',
        clickToPickWall: 'Select a picture wall before selecting designs',
        turnDevice: 'Turn your device',
        swipeUp: 'Swipe up',
        waresAddedToCart: 'Your items have been added to the cart',
        proceedingToCheckout: 'Proceed to checkout',
        saveBasket: 'Save picture wall',
        noSavedWalls: 'No saved picture walls',
        updateOrnew: 'You have selected a saved picture wall {name}. Would you like to update your wall or create a new one? ',
        createNew: 'create new',
        update: 'update',
        shareTitle: 'Share your picture wall',
        shareSaveTitle: 'Please save first',
        shareSaveText: 'You must save your picture wall before you can share it. Would you like to save your picture wall now?',
        errorTitle: 'Something went wrong.',
        errorMessage: 'A technical problem has occurred. Please try again or contact our support service.',
        showMore: 'Show more',
        showLess: 'Show less',
        noProductsInBasket: 'Please select at least one product to add to your cart.',
        removeTitle: 'Delete picture wall',
        removePromt: 'Are you sure you want to delete your picture wall?',
        couldNotRemove: 'Unable to delete. Please try again or contact our support service.',
        remove: 'Delete',
        removeFrame: 'Delete frame',
        close: 'Close',
        wantToContinue: 'Would you like to continue?',
        unsavedChanges: 'You have made changes that have not been saved. Would you like to save your picture wall now?',
        needsArticlesShare: 'Please add at least one item before sharing.',
        needsArticlesSave: 'Please add at least one item before saving.',
        needsPictureWall: 'Please select a picture wall before selecting items.',
        menu: 'Menu',
        noMotivs: 'You have not selected any designs',
        leavingSave: 'You have not saved your picture wall. Are you sure you want to leave?',
        addedToCartDate: 'Added to cart {date}',
        saveAndMoveOn: 'Next',
        moveOn: 'Next',
        saveAndClose: 'Save and close',
        backgrounds: '1. Select background',
        pictureWalls: '2. Select picture wall',
        yourMotifs: '3. Select designs',
        frames: '4. Frame your designs',
        leftToFreeShipping: 'Needed for free shipping',
        checkout: 'Checkout',
        total: 'total amount',
        emptyBasket: 'You have not added any products to your cart.',
        allProducts: 'All products',
        lastViewed: 'Last viewed',
        myFavorites: 'My favourites',
        lastChosen: 'Last selected',
        choosePictureWallBeforeFrames: 'Please select a picture wall before selecting frames.',
        dontSave: "don't save",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Click the heart symbol to save your favourites. <br/> Show favourites in the drop-down list to the left.',
        purchaseNowTitle: 'That looks great!',
        purchaseNow: 'You can add your whole picture wall to your cart here.'
    }, _defineProperty(_en, 'addToCart', 'Add to'), _defineProperty(_en, 'addToCartSmall', 'Add to'), _defineProperty(_en, 'toCheckout', 'Checkout'), _defineProperty(_en, 'savedWalls', 'Saved gallery walls'), _defineProperty(_en, 'goBackToStep', 'Previous'), _defineProperty(_en, 'favoritesThatMatch', 'Favourites available in the selected size'), _defineProperty(_en, 'favoritesThatMatchMobile', 'Favourites in the selected size'), _defineProperty(_en, 'noStock', 'Some items are out of stock.'), _defineProperty(_en, 'startTop', 'Step-by-step'), _defineProperty(_en, 'startTitle', 'Create the perfect gallery wall'), _defineProperty(_en, 'startText', 'Use our new tool to find designs and frames that match each other'), _defineProperty(_en, 'startButton', 'START HERE'), _defineProperty(_en, 'clickFullscreen', 'Click for fullscreen'), _defineProperty(_en, 'noArticlesMatched', "Sorry, we can't find any products in (size) that match your search."), _defineProperty(_en, 'breadcrumbPrints', 'Wall art'), _defineProperty(_en, 'breadcrumbInsp', 'Inspiration'), _defineProperty(_en, 'breadcrumbInspLink', 'https://desenio.co.uk/g/gallery-walls/'), _defineProperty(_en, 'breadcrumbGw', 'Create your gallery wall'), _defineProperty(_en, 'breadcrumbGwLink', 'https://gwt.desenio.co.uk/#/'), _defineProperty(_en, 'linkToWall', 'YOUR GALLERY WALL LINK'), _defineProperty(_en, 'copy', 'Copy'), _defineProperty(_en, 'outOfStock', 'Out of stock'), _defineProperty(_en, 'outOfStockText', 'The items below are out of stock, you can monitor the items to be notified when they are back in stock.'), _defineProperty(_en, 'checkoutUrl', 'https://checkout.desenio.co.uk'), _defineProperty(_en, 'pageUrl', 'https://desenio.co.uk'), _en),
    nl: (_nl = {
        countryCode: 'NL',
        yes: 'ja',
        no: 'nee',
        abort: 'annuleren',
        my: 'mijn',
        done: 'klaar',
        pick: 'selecteren',
        save: 'opslaan',
        share: 'delen',
        buy: 'kopen',
        addToCart: 'In',
        name: 'Naam',
        currencySuffix: ' ',
        currencySuffixBuy: '',
        currencyPrefix: '&euro;',
        frameYourMotifs: 'Lijst uw motieven in',
        background: 'contextuele foto | contextuele foto‘s',
        picturewall: 'fotowand | fotowanden',
        backgroundColor: 'achtergrondkleur | achtergrondkleuren',
        color: 'kleur | kleuren',
        motifs: 'motief | motieven',
        clear: 'Wissen',
        filter: 'Filter',
        showFilter: 'Filter weergeven',
        hideFilter: 'Filter verbergen',
        clearFilter: 'Filter wissen',
        category: 'Categorie',
        allArticles: 'Alle',
        articles: 'artikelen',
        clickToPickMotif: 'Klik op een foto in de fotowand om een motief te kiezen.',
        clickToPickWall: 'Kies een fotowand voordat u een motief kiest',
        turnDevice: 'Draai uw apparaat om',
        swipeUp: 'Veeg omhoog',
        waresAddedToCart: 'Uw artikelen zijn in het winkelmandje geplaatst',
        proceedingToCheckout: 'Ga verder naar de kassa',
        saveBasket: 'Sla de fotowand op',
        noSavedWalls: 'Geen opgeslagen fotowanden',
        updateOrnew: 'U heeft een opgeslagen fotowand gekozen, die {name} heet, wilt u deze bijwerken of een opslaan als een nieuwe fotowand? ',
        createNew: 'nieuwe maken',
        update: 'bijwerken',
        shareTitle: 'Uw fotowand delen',
        shareSaveTitle: 'U moet eerst opslaan',
        shareSaveText: 'U moet uw fotowand opslaan voordat u hem kunt delen. Wilt u de fotowand nu opslaan?',
        errorTitle: 'Er is iets misgegaan.',
        errorMessage: 'Er is een technische storing opgetreden. Probeer het opnieuw of neem contact op met support.',
        showMore: 'Meer weergeven',
        showLess: 'Minder weergeven',
        noProductsInBasket: 'Selecteer ten minste één product om aan uw winkelmandje toe te voegen.',
        removeTitle: 'Fotowand verwijderen',
        removePromt: 'Weet u zeker dat u de fotowand wilt verwijderen?',
        couldNotRemove: 'Kon niet verwijderen, probeer het opnieuw of neem contact op met support.',
        remove: 'Verwijderen',
        removeFrame: 'Lijst verwijderen',
        close: 'Sluiten',
        wantToContinue: 'Wilt u verdergaan?',
        unsavedChanges: 'U heeft nog niet opgeslagen wijzigingen die verloren gaan als u verdergaat. Wilt u uw fotowand nu opslaan?',
        needsArticlesShare: 'Er moet ten minste een artikel zijn toegevoegd voordat u kunt delen.',
        needsArticlesSave: 'Er moet ten minste een artikel zijn toegevoegd voordat u kunt opslaan.',
        needsPictureWall: 'Kies een fotowand voordat u artikelen kiest.',
        menu: 'Menu',
        noMotivs: 'U heeft geen motieven geselecteerd',
        leavingSave: 'U heeft uw fotowand niet opgeslagen, wilt u stoppen?',
        addedToCartDate: 'Aan winkelmandje toegevoegd {date}',
        saveAndMoveOn: 'Volgende',
        moveOn: 'Volgende',
        saveAndClose: 'Opslaan en sluiten',
        achtergronden: '1. Selecteer contextuele foto',
        pictureWalls: '2. Selecteer fotowand',
        yourMotifs: '3. Selecteer motieven',
        frames: '4. Lijst uw motieven in',
        leftToFreeShipping: 'Nog te gaan tot gratis verzending',
        checkout: 'Kassa',
        total: 'totaal bedrag',
        emptyBasket: 'U heeft geen producten in het winkelmandje gelegd.',
        allProducts: 'Alle producten',
        lastViewed: 'Laatst bekeken',
        myFavorites: 'Mijn favorieten',
        lastChosen: 'Laatst geselecteerd',
        choosePictureWallBeforeFrames: 'Selecteer een fotowand voordat u lijsten kiest.',
        dontSave: "niet opslaan",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tip ',
        heartInfo: 'Gebruik het hart-pictogram om uw favorieten op te slaan. <br/> Geef uw favorieten weer in de drop-downlijst in de linker bovenhoek.',
        purchaseNowTitle: 'O, wat mooi!',
        purchaseNow: 'U kunt uw complete fotowand hier in het winkelmandje plaatsen.'
    }, _defineProperty(_nl, 'addToCart', 'In'), _defineProperty(_nl, 'addToCartSmall', 'In'), _defineProperty(_nl, 'toCheckout', 'Kassa'), _defineProperty(_nl, 'savedWalls', 'Bewaarde posterwanden'), _defineProperty(_nl, 'goBackToStep', 'Vorige'), _defineProperty(_nl, 'favoritesThatMatch', 'Favorieten die verkrijgbaar zijn in de geselecteerde grootte'), _defineProperty(_nl, 'favoritesThatMatchMobile', 'Favorieten in geselecteerde grootte'), _defineProperty(_nl, 'noStock', 'Enkele artikelen zijn niet op voorraad.'), _defineProperty(_nl, 'startTop', 'Stap-voor-stap'), _defineProperty(_nl, 'startTitle', 'Maak de perfecte fotowand'), _defineProperty(_nl, 'startText', 'Gebruik onze nieuwe tool om motieven en lijsten te vinden die bij elkaar passen'), _defineProperty(_nl, 'startButton', 'START HIER'), _defineProperty(_nl, 'clickFullscreen', 'Klik voor volledig scherm'), _defineProperty(_nl, 'noArticlesMatched', 'Er zijn helaas geen artikelen in formaat (size) die overeenkomen met jouw zoekopdracht.'), _defineProperty(_nl, 'breadcrumbPrints', 'Posters'), _defineProperty(_nl, 'breadcrumbInsp', 'INSPIRATIE'), _defineProperty(_nl, 'breadcrumbInspLink', 'https://desenio.nl/g/fotowanden/'), _defineProperty(_nl, 'breadcrumbGw', 'Stel uw fotowand samen'), _defineProperty(_nl, 'breadcrumbGwLink', 'https://gwt.desenio.nl/'), _defineProperty(_nl, 'linkToWall', 'LINK NAAR JE FOTOWAND'), _defineProperty(_nl, 'copy', 'Kopieer'), _defineProperty(_nl, 'outOfStock', 'Niet op voorraad'), _defineProperty(_nl, 'outOfStockText', 'De onderstaande artikelen zijn niet op voorraad, u kunt de artikelen volgen om een bericht te krijgen wanneer ze weer op voorraad zijn.'), _defineProperty(_nl, 'checkoutUrl', 'https://checkout.desenio.nl'), _defineProperty(_nl, 'pageUrl', 'https://desenio.nl'), _nl),
    fr: (_fr = {
        countryCode: 'FR',
        yes: 'oui',
        no: 'non',
        abort: 'annuler',
        my: 'mes',
        done: 'terminé',
        pick: 'CHOISISSEZ',
        save: 'enregistrer',
        share: 'partager',
        buy: 'acheter',
        addToCart: 'AJOUTER AU',
        name: 'Nom',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Encadrez vos affiches',
        background: "un fond | des fonds",
        picturewall: 'UN MUR DE CADRES| DES MURS DE CADRES',
        backgroundColor: 'couleur de fond | couleurs de fond',
        color: 'couleur | couleurs',
        motifs: 'UNE AFFICHE | DES AFFICHES',
        clear: 'Vider',
        filter: 'Filtre',
        showFilter: 'Montrer le filtre',
        hideFilter: 'Cacher le filtre',
        clearFilter: 'Vider le filtre',
        category: 'Catégorie',
        allArticles: 'Tous les articles',
        articles: 'articles',
        clickToPickMotif: 'Cliquez sur un tableau dans le mur de tableaux pour sélectionner un motif.',
        clickToPickWall: 'Sélectionnez un mur de tableaux avant de sélectionner un motif',
        turnDevice: 'Tournez votre appareil',
        swipeUp: "Balayez l'écran vers le haut",
        waresAddedToCart: "Vos articles ont été mis dans le panier",
        proceedingToCheckout: 'Allez à la caisse',
        saveBasket: 'Enregistrer le mur de tableaux',
        noSavedWalls: "Aucun mur de tableaux n'est enregistré",
        updateOrnew: "Vous avez choisi un mur de tableaux enregistré qui s'appelle {name}. Voulez-vous le mettre à jour ou en créer un nouveau ?",
        createNew: 'Créer un nouveau',
        update: 'mettre à jour',
        shareTitle: 'Partagez votre mur de tableaux',
        shareSaveTitle: "Vous devez d'abord enregistrer",
        shareSaveText: "Vous devez enregistrer votre mur de tableaux avant de le partager. Voulez-vous l'enregistrer maintenant ?",
        errorTitle: "Une erreur s'est produite.",
        errorMessage: "Une erreur technique s'est produite, essayez de nouveau ou contactez le service d'assistance.",
        showMore: 'Montrer plus',
        showLess: 'Montrer moins',
        noProductsInBasket: 'Veuillez sélectionner au moins un produit à ajouter dans le panier.',
        removetitle: 'Supprimer le mur de tableaux',
        removePromt: 'Êtes-vous certain de vouloir supprimer le mur de tableaux ?',
        couldNotRemove: "Suppression impossible, essayez de nouveau ou contactez le service d'assistance.",
        remove: 'Supprimer',
        removeFrame: 'Supprimer le cadre',
        close: 'Fermer',
        wantToContinue: 'Voulez-vous continuer ?',
        unsavedChanges: 'Vous avez des modifications non enregistrées qui seront perdues si vous continuez. Voulez-vous enregistrer votre mur de tableaux maintenant ?',
        needsArticlesShare: 'Veuillez ajouter au moins un article avant de partager.',
        needsArticlesSave: 'Veuillez ajouter au moins un article avant de sauvegarder.',
        needsPictureWall: 'Sélectionnez un mur de tableaux avant de sélectionner des articles.',
        menu: 'Menu',
        noMotivs: 'Vous n’avez sélectionné aucun motif',
        leavingSave: 'Vous n’avez pas enregistré votre mur de tableaux ; voulez-vous quitter?',
        addedToCartDate: 'Ajouté au panier {date}',
        saveAndMoveOn: 'suivant',
        moveOn: 'suivant',
        saveAndClose: 'Enregistrer et fermer',
        backgrounds: '1. Choisissez un fond',
        pictureWalls: '2. Choisissez un mur de cadres',
        yourMotifs: '3. Choisissez une affiche',
        frames: '4. Encadrez vos affiches',
        leftToFreeShipping: 'Ce qui manque pour bénéficier de la livraison gratuite',
        checkout: 'PANIER',
        total: 'total',
        emptyBasket: 'Vous n’avez ajouté aucun produit à votre panier.',
        allProducts: 'Tous les produits',
        lastViewed: 'Derniers regardés',
        myFavorites: 'Mes favoris',
        lastChosen: 'Derniers sélectionnés',
        choosePictureWallBeforeFrames: 'Sélectionnez un mur de tableaux avant de choisir les cadres.',
        dontSave: 'ne pas enregistrer',
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Conseils ',
        heartInfo: 'Utilisez le symbole de c&#x153;ur pour sauvegarder vos favoris. <Br/> Affichez les favoris dans la liste déroulante dans le coin supérieur gauche.',
        purchaseNowTitle: 'Comme c&#x2019;est beau !',
        purchaseNow: 'Vous pouvez mettre tout votre mur de tableaux dans le panier ici.'
    }, _defineProperty(_fr, 'addToCart', 'Ajouter au'), _defineProperty(_fr, 'addToCartSmall', 'Ajouter au'), _defineProperty(_fr, 'toCheckout', 'PANIER'), _defineProperty(_fr, 'savedWalls', 'MURS DE CADRES SAUVEGARDÉS'), _defineProperty(_fr, 'goBackToStep', 'PRÉCÉDENT'), _defineProperty(_fr, 'favoritesThatMatch', 'Favoris disponibles dans la taille sélectionnée'), _defineProperty(_fr, 'favoritesThatMatchMobile', 'Favoris dans la taille sélectionnée'), _defineProperty(_fr, 'noStock', 'Certains articles sont en rupture de stock.'), _defineProperty(_fr, 'startTop', "Étape par étape"), _defineProperty(_fr, 'startTitle', 'Créez le mur de tableaux parfait'), _defineProperty(_fr, 'startText', 'Utilisez notre nouvel outil pour trouver des affiches et des cadres qui vont bien ensemble'), _defineProperty(_fr, 'startButton', 'COMMENCEZ ICI'), _defineProperty(_fr, 'clickFullscreen', 'Klik voor volledig scherm'), _defineProperty(_fr, 'noArticlesMatched', 'Désolé, nous ne trouvons pas de produits en (taille) correspondant à vos critères de recherche'), _defineProperty(_fr, 'breadcrumbPrints', 'Tableaux'), _defineProperty(_fr, 'breadcrumbInsp', 'INSPIRATION'), _defineProperty(_fr, 'breadcrumbInspLink', 'https://desenio.fr/g/decoration-murale/'), _defineProperty(_fr, 'breadcrumbGw', 'Créez votre mur de cadres'), _defineProperty(_fr, 'breadcrumbGwLink', 'https://gwt.desenio.fr/#/'), _defineProperty(_fr, 'linkToWall', 'LIEN DE VOTRE MUR DE CADRES'), _defineProperty(_fr, 'copy', 'Copier'), _defineProperty(_fr, 'outOfStock', 'En rupture de stock'), _defineProperty(_fr, 'outOfStockText', 'Les articles ci-dessous sont en rupture de stock, vous pouvez surveiller les articles pour être informé de leur retour en stock.'), _defineProperty(_fr, 'checkoutUrl', 'https://checkout.desenio.fr'), _defineProperty(_fr, 'pageUrl', 'https://desenio.fr'), _fr),
    es: (_es = {
        countryCode: 'ES',
        yes: 'si',
        no: 'no',
        abort: 'cancelar',
        my: 'mis',
        done: 'listo',
        pick: 'elegir',
        save: 'guardar',
        share: 'compartir',
        buy: 'comprar',
        addToCart: 'Añadir a',
        name: 'Nombre',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Enmarca tus motivos',
        background: 'entorno | entornos',
        picturewall: 'decoración de pared | decoración de pared',
        backgroundColor: 'color de fondo | colores de fondo',
        color: 'color | colores',
        motifs: 'póster | pósters',
        clear: 'Eliminar',
        filter: 'Filtros',
        showFilter: 'Mostrar filtro',
        hideFilter: 'Ocultar filtro',
        clearFilter: 'Eliminar filtro',
        category: 'Categoría',
        allArticles: 'Todos',
        articles: 'artículos',
        clickToPickMotif: 'Haz clic en un cuadro de la pared de decoración para elegir el motivo.',
        clickToPickWall: 'Elige una decoración de pared antes de elegir el motivo',
        turnDevice: 'Dale la vuelta a tu dispositivo',
        swipeUp: 'Desplázate hacia arriba',
        waresAddedToCart: 'Hemos añadido tus productos a la cesta de la compra',
        proceedingToCheckout: 'Te lleva a la caja',
        saveBasket: 'Guardar la decoración de pared',
        noSavedWalls: 'No hay decoraciones de pared guardadas',
        updateOrnew: 'Has elegido una decoración de pared guardada que se llama {name}, ¿quieres actualizar la existente o crear una nueva?',
        createNew: 'crear nueva',
        update: 'actualizar',
        shareTitle: 'Comparte tu decoración de pared',
        shareSaveTitle: 'Debes guardarla primero',
        shareSaveText: 'Debes guardar tu decoración de pared antes de poder compartirla. ¿Deseas guardar la decoración de pared ahora?',
        errorTitle: 'Se ha producido un error.',
        errorMessage: 'Se ha producido un error técnico. Inténtalo de nuevo o ponte en contacto con el servicio técnico.',
        showMore: 'Mostrar más',
        showLess: 'Mostrar menos',
        noProductsInBasket: 'Por favor selecciona al menos un producto para añadir a la cesta de la compra.',
        removeTitle: 'Eliminar la decoración de pared',
        removePromt: '¿Estás seguro de querer eliminar la decoración de pared?',
        couldNotRemove: 'No se ha podido eliminar. Inténtalo de nuevo o ponte en contacto con el servicio técnico.',
        remove: 'Eliminar',
        removeFrame: 'Eliminar marco',
        close: 'Cerrar',
        wantToContinue: '¿Deseas continuar?',
        unsavedChanges: 'Has hecho cambios que no has guardado y que se perderán si continúas. ¿Deseas guardar tu decoración de pared ahora?',
        needsArticlesShare: 'Añade al menos un artículo antes de compartir',
        needsArticlesSave: 'Añade al menos un artículo antes de guardar.',
        needsPictureWall: 'Selecciona una decoración de pared antes de elegir artículos',
        menu: 'Menú',
        noMotivs: 'No has seleccionado ningún motivo',
        leavingSave: 'No has guardado tu decoración de pared.¿Deseas salir?',
        addedToCartDate: 'Añadido a la cesta de la compra {fecha}',
        saveAndMoveOn: 'Siguiente',
        moveOn: 'Siguiente',
        saveAndClose: 'Guardar y cerrar',
        backgrounds: "1 'Elige foto de la naturaleza",
        pictureWalls: "2 'Elige decoración de pared",
        yourMotifs: '3. Elige motivo',
        frames: '4. Enmarca tus pósters',
        leftToFreeShipping: 'Importe restante para que los portes sean gratuitos',
        checkout: 'Ir a la caja',
        total: 'Importe total',
        emptyBasket: 'No has añadido ningún producto a la cesta de la compra.',
        allProducts: 'Todos los productos',
        lastViewed: 'Último producto visto',
        myFavorites: 'Mis favoritos',
        lastChosen: 'Última selección',
        choosePictureWallBeforeFrames: 'Selecciona una decoración de pared antes de elegir el marco.',
        dontSave: "no guardar",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Consejos ',
        heartInfo: 'Utiliza el icono del corazón para guardar tus favoritos. <br/> Muestra los favoritos en la barra de desplazamiento en la parte superior izquierda.',
        purchaseNowTitle: '¡Qué bonito te ha quedado!',
        purchaseNow: 'Añade toda tu decoración de pared a la cesta de la compra aquí'
    }, _defineProperty(_es, 'addToCart', 'Añadir a'), _defineProperty(_es, 'addToCartSmall', 'Añadir a'), _defineProperty(_es, 'toCheckout', 'Ir a la caja'), _defineProperty(_es, 'savedWalls', 'Galerías guardadas'), _defineProperty(_es, 'goBackToStep', 'Anterior'), _defineProperty(_es, 'favoritesThatMatch', 'Favoritos que encontrarás en el tamaño elegido'), _defineProperty(_es, 'favoritesThatMatchMobile', 'Favoritos en el tamaño elegido'), _defineProperty(_es, 'noStock', 'Algunos artículos están agotados.'), _defineProperty(_es, 'startTop', "Paso-a-paso"), _defineProperty(_es, 'startTitle', 'Crea la decoración de pared perfecta'), _defineProperty(_es, 'startText', 'Utiliza nuestra nueva herramienta para encontrar motivos y marcos que combinen entre sí'), _defineProperty(_es, 'startButton', 'EMPIEZA AQUÍ'), _defineProperty(_es, 'clickFullscreen', 'Haga clic para pantalla completa'), _defineProperty(_es, 'noArticlesMatched', 'Lo sentimos, no podemos encontrar ningún producto en el (tamaño) que coincida con sus criterios de búsqueda'), _defineProperty(_es, 'breadcrumbPrints', 'Cuadros'), _defineProperty(_es, 'breadcrumbInsp', 'INSPIRACIÓN'), _defineProperty(_es, 'breadcrumbInspLink', 'https://desenio.es/g/galerias-de-pared/'), _defineProperty(_es, 'breadcrumbGw', 'Crea tu decoración de pared'), _defineProperty(_es, 'breadcrumbGwLink', 'https://gwt.desenio.es/#/'), _defineProperty(_es, 'linkToWall', 'ENLACE PARA SU MURAL DE CUADROS'), _defineProperty(_es, 'copy', 'Copiar'), _defineProperty(_es, 'outOfStock', 'Agotado'), _defineProperty(_es, 'outOfStockText', 'Los artículos que aparecen a continuación están agotados, puede ver los artículos para que se le informe cuando vuelvan a estar en stock.'), _defineProperty(_es, 'checkoutUrl', 'https://checkout.desenio.es'), _defineProperty(_es, 'pageUrl', 'https://desenio.es'), _es),
    us: window.localeUS,
    de: (_de = {
        countryCode: 'DE',
        yes: 'Ja',
        no: 'Nein',
        abort: 'Abbrechen',
        my: 'meine',
        done: 'fertig',
        pick: 'auswählen',
        save: 'speichern',
        share: 'teilen',
        buy: 'kaufen',
        addToCart: 'In den',
        name: 'Name',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Rahme deine Motive ein',
        background: 'Umgebungsbild | Umgebungsbilder',
        picturewall: 'Bilderwand | Bilderwände',
        backgroundColor: 'Hintergrundfarbe | Hintergrundfarben',
        color: 'Farbe | Farben',
        motifs: 'Motiv | Motive',
        clear: 'Löschen',
        filter: 'Filter',
        showFilter: 'Filter einblenden',
        hideFilter: 'Filter ausblenden',
        clearFilter: 'Filter aufheben',
        category: 'Kategorie',
        allArticles: 'Alle',
        articles: 'Artikel',
        clickToPickMotif: 'Klicke auf ein Bild in der Bilderwand, um ein Motiv auszuwählen.',
        clickToPickWall: 'Vor der Auswahl von Motiven eine Bilderwand auswählen',
        turnDevice: 'Das Gerät drehen',
        swipeUp: 'Nach oben wischen',
        waresAddedToCart: 'Deine Artikel wurden dem Warenkorb hinzugefügt',
        proceedingToCheckout: 'Zur Kasse gehen',
        saveBasket: 'Bilderwand speichern',
        noSavedWalls: 'Keine gespeicherten Bilderwände',
        updateOrnew: 'Du hast bereits eine Bilderwand, die unter dem Namen {name} gespeichert ist, möchtest du die vorhandene Bilderwand aktualisieren oder eine neue anlegen?',
        createNew: 'neu erstellen',
        update: 'aktualisieren',
        shareTitle: 'Deine Bilderwand teilen',
        shareSaveTitle: 'Du musst zuerst speichern',
        shareSaveText: 'Vor dem Teilen musst du deine Bilderwand speichern. Möchtest du die Bilderwand jetzt teilen?',
        errorTitle: 'Ein Fehler ist aufgetreten.',
        errorMessage: 'Ein Fehler ist aufgetreten, bitte versuche es erneut oder wende dich an den Support.',
        showMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        noProductsInBasket: 'Bitte wähle mindestens einen Artikel für den Warenkorb aus.',
        removeTitle: 'Bilderwand entfernen',
        removePromt: 'Möchtest du die Bilderwand wirklich entfernen?',
        couldNotRemove: 'Entfernen fehlgeschlagen, bitte versuche es erneut oder wende dich an den Support.',
        remove: 'Entfernen',
        removeFrame: 'Rahmen entfernen',
        close: 'Schließen',
        wantToContinue: 'Möchtest du fortfahren?',
        unsavedChanges: 'Es gibt Änderungen, die nicht gespeichert wurden und verloren gehen, wenn du fortfährst. Möchtest du deine Bilderwand jetzt speichern?',
        needsArticlesShare: 'Vor dem Teilen bitte mindestens einen Artikel hinzufügen.',
        needsArticlesSave: 'Vor dem Speichern bitte mindestens einen Artikel hinzufügen.',
        needsPictureWall: 'Vor der Auswahl von Artikeln bitte eine Bilderwand auswählen.',
        menu: 'Menü',
        noMotivs: 'Du hast keine Motive ausgewählt',
        leavingSave: 'Du hast deine Bilderwand nicht gespeichert, möchtest du die Seite wirklich verlassen?',
        addedToCartDate: 'Dem Warenkorb hinzugefügt am {date}',
        saveAndMoveOn: 'Weiter',
        moveOn: 'Weiter',
        saveAndClose: 'Speichern und schließen',
        backgrounds: '1. Umgebungsbild auswählen',
        pictureWalls: '2. Bilderwand auswählen',
        yourMotifs: '3. Motiv auswählen',
        frames: '4. Rahme deine Motive ein',
        leftToFreeShipping: 'bis zum kostenlosen Versand',
        checkout: 'Zur Kasse',
        total: 'Gesamt',
        emptyBasket: 'Du hast keine Artikel zum Warenkorb hinzugefügt.',
        allProducts: 'Alle Produkte',
        lastViewed: 'Zuletzt angesehen',
        myFavorites: 'Meine Favoriten',
        lastChosen: 'Zuletzt ausgewählt',
        choosePictureWallBeforeFrames: 'Vor der Auswahl von Rahmen bitte eine Bilderwand auswählen.',
        dontSave: "nicht speichern",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tipp',
        heartInfo: 'Mit dem Herzsymbol kannst du deine Favoriten speichern. <br/>Favoriten in der Dropdown-Liste oben links anzeigen.',
        purchaseNowTitle: 'Gratuliere, toll geworden!',
        purchaseNow: 'Hier kannst du deine komplette Bilderwand zum Warenkorb hinzufügen.'
    }, _defineProperty(_de, 'addToCart', 'In den'), _defineProperty(_de, 'addToCartSmall', 'In den'), _defineProperty(_de, 'toCheckout', 'Zur Kasse'), _defineProperty(_de, 'savedWalls', 'Gespeicherte Bilderwände'), _defineProperty(_de, 'goBackToStep', 'Zurück'), _defineProperty(_de, 'favoritesThatMatch', 'In der ausgewählten Größe verfügbare Favoriten'), _defineProperty(_de, 'favoritesThatMatchMobile', 'Favoriten in der ausgewählten Größe'), _defineProperty(_de, 'noStock', 'Einige Artikel sind ausverkauft.'), _defineProperty(_de, 'startTop', "Schritt-für-Schritt"), _defineProperty(_de, 'startTitle', 'Komponiere die perfekte Bilderwand'), _defineProperty(_de, 'startText', 'Verwende unser neues Tool, um Motive und Rahmen zu finden, die zueinander passen'), _defineProperty(_de, 'startButton', 'HIER STARTEN'), _defineProperty(_de, 'clickFullscreen', 'Klick für Vollbild'), _defineProperty(_de, 'noArticlesMatched', 'Leider können wir keine Produkte in der Größe (size) finden, die deinen Suchkriterien entsprechen.'), _defineProperty(_de, 'breadcrumbPrints', 'Wandbilder'), _defineProperty(_de, 'breadcrumbInsp', 'INSPIRATION'), _defineProperty(_de, 'breadcrumbInspLink', 'https://desenio.de/g/bilderwande/'), _defineProperty(_de, 'breadcrumbGw', 'Komponiere deine Bilderwand'), _defineProperty(_de, 'breadcrumbGwLink', 'https://gwt.desenio.de/#/'), _defineProperty(_de, 'linkToWall', 'LINK ZU DEINER POSTERWAND'), _defineProperty(_de, 'copy', 'Kopieren'), _defineProperty(_de, 'checkoutUrl', 'https://checkout.desenio.de'), _defineProperty(_de, 'pageUrl', 'https://desenio.de'), _de),
    it: (_it = {
        countryCode: 'IT',
        yes: 'sì',
        no: 'no',
        abort: 'annulla',
        my: 'mio',
        done: 'fatto',
        pick: 'seleziona',
        save: 'salva',
        share: 'condividi',
        buy: 'acquista',
        addToCart: 'Aggiungi al',
        name: 'Nome',
        currencySuffix: ' &euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Incornicia i tuoi poster',
        background: 'soggetto naturale | soggetti naturali',
        picturewall: 'galleria | gallerie',
        backgroundColor: 'colore di sfondo | colori di sfondo',
        color: 'colore | colori',
        motifs: 'soggetto | soggetti',
        clear: 'Cancella',
        filter: 'Filtro',
        showFilter: 'mostra filtro',
        hideFilter: 'Nascondi filtro',
        clearFilter: 'Elimina filtro',
        category: 'Categoria',
        allArticles: 'Tutti',
        articles: 'articoli',
        clickToPickMotif: 'Clicca su un poster della galleria per selezionare il soggetto.',
        clickToPickWall: 'Seleziona una galleria prima di scegliere un soggetto',
        turnDevice: 'Gira il dispositivo',
        swipeUp: 'Scorri in alto',
        waresAddedToCart: 'I tuoi articoli sono stati aggiunti al carrello',
        proceedingToCheckout: 'Procedi alla cassa',
        saveBasket: 'Salva la galleria',
        noSavedWalls: 'Nessuna galleria salvata',
        updateOrnew: 'È stata selezionata una galleria salvata di nome {name}, si desidera aggiornare la galleria esistente o crearne una nuova? ',
        createNew: 'crea nuova',
        update: 'aggiorna',
        shareTitle: 'Condividi la galleria',
        shareSaveTitle: 'È necessario salvare prima',
        shareSaveText: 'È necessario salvare la galleria prima di condividerla. Desideri salvare la galleria ora?',
        errorTitle: 'Si è verificato un errore. ',
        errorMessage: 'Si è verificato un errore tecnico. Riprovare o contattare l’assistenza.',
        showMore: 'Mostra altri',
        showLess: 'Mostra meno',
        noProductsInBasket: 'Selezionare almeno un articolo da aggiungere al carrello.',
        removeTitle: 'Rimuovi la galleria',
        removePromt: 'Sei sicuro di che voler rimuovere la galleria?',
        couldNotRemove: 'Non è stato possibile rimuovere. Riprovare o contattare l’assistenza.',
        remove: 'Rimuovi',
        removeFrame: 'Rimuovi la cornice',
        close: 'Chiudi',
        wantToContinue: 'Si desidera continuare?',
        unsavedChanges: 'Sono state apportate modifiche non salvate che andranno perse se si continua. Salvare la galleria adesso? ',
        needsArticlesShare: 'Aggiungere almeno un articolo prima di condividere.',
        needsArticlesSave: 'Aggiungere almeno un articolo prima di salvare.',
        needsPictureWall: 'Selezionare una galleria prima di scegliere un articolo',
        menu: 'Menu',
        noMotivs: 'Non è stato selezionato alcun soggetto',
        leavingSave: 'La galleria non è stata salvata. Vuoi uscire? ',
        addedToCartDate: 'Aggiunto al carrello {data}',
        saveAndMoveOn: 'PROSSIMO STEP',
        moveOn: 'PROSSIMO STEP',
        saveAndClose: 'Salva e chiudi',
        backgrounds: '1. Selezionare un soggetto naturale',
        pictureWalls: '2. Selezionare una galleria di immagini',
        yourMotifs: '3. Selezionare un soggetto',
        frames: '4. Incorniciare i poster',
        leftToFreeShipping: 'Manca alla spedizione gratuita',
        checkout: 'VAI ALLA CASSA',
        total: 'totale',
        emptyBasket: 'Il carrello non contiene articoli.',
        allProducts: 'Tutti i prodotti',
        lastViewed: 'Ultimi visualizzati',
        myFavorites: 'I miei preferiti',
        lastChosen: 'Ultime scelte',
        choosePictureWallBeforeFrames: 'Selezionare una galleria prima di scegliere una cornice',
        dontSave: "non salvare",
        heartInfoTitle: '<a class="fa fa-heart-o"></i> Suggerimenti </a>',
        heartInfo: "Selezionare l'icona a forma di cuore per salvare i preferiti. <br/> Visualizzare i preferiti nell'elenco a discesa in alto a sinistra.",
        purchaseNowTitle: 'Che bello!',
        purchaseNow: 'Qui è possibile aggiungere l’intera galleria al carrello.'
    }, _defineProperty(_it, 'addToCart', 'Aggiungi al'), _defineProperty(_it, 'addToCartSmall', 'Aggiungi al'), _defineProperty(_it, 'toCheckout', 'VAI ALLA CASSA'), _defineProperty(_it, 'savedWalls', 'GALLERIE A PARETE SALVATE'), _defineProperty(_it, 'goBackToStep', 'PRECEDENTE STEP'), _defineProperty(_it, 'favoritesThatMatch', 'Preferiti disponibili nel formato selezionato'), _defineProperty(_it, 'favoritesThatMatchMobile', 'Preferiti nel formato selezionato'), _defineProperty(_it, 'noStock', 'Alcuni articoli sono esauriti.'), _defineProperty(_it, 'startTop', "Passo-per-passo"), _defineProperty(_it, 'startTitle', 'Crea una perfetta galleria di immagini'), _defineProperty(_it, 'startText', 'Usa il nostro nuovo strumento per trovare soggetti e cornici che stanno bene insieme'), _defineProperty(_it, 'startButton', 'INIZIA QUI'), _defineProperty(_it, 'clickFullscreen', 'Clicca per schermo intero'), _defineProperty(_it, 'noArticlesMatched', 'Scusaci, non troviamo i prodotti della( misura) che hai selezionato'), _defineProperty(_it, 'breadcrumbPrints', 'Quadri'), _defineProperty(_it, 'breadcrumbInsp', 'ISPIRAZIONE'), _defineProperty(_it, 'breadcrumbInspLink', 'https://desenio.it/g/gallerie-a-parete/'), _defineProperty(_it, 'breadcrumbGw', 'Crea la tua galleria a parete'), _defineProperty(_it, 'breadcrumbGwLink', 'https://gwt.desenio.it/#/'), _defineProperty(_it, 'linkToWall', 'IL LINK DELLA TUA GALLERIA A PARETE'), _defineProperty(_it, 'copy', 'Copia'), _defineProperty(_it, 'outOfStock', 'Nicht mehr auf Lager'), _defineProperty(_it, 'outOfStockText', 'Die folgenden Artikel sind nicht mehr auf Lager, Sie können die Artikel beobachten, um informiert zu werden, wenn sie wieder auf Lager sind.'), _defineProperty(_it, 'checkoutUrl', 'https://checkout.desenio.it'), _defineProperty(_it, 'pageUrl', 'https://desenio.it'), _it),
    pt: (_pt = {
        countryCode: 'PT',
        yes: 'sim',
        no: 'não',
        abort: 'cancelar',
        my: 'meu/minha',
        done: 'concluído',
        pick: 'escolha',
        save: 'guardar',
        share: 'partilhar',
        buy: 'comprar',
        addToCart: 'Adicionar a',
        name: 'Nome',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Emoldure os seus temas',
        background: 'imagem do ambiente | imagens do ambiente',
        picturewall: ' parede de quadros | paredes de quadros',
        backgroundColor: 'cor de fundo | cores de fundo',
        color: 'cor | cores',
        motifs: 'tema | temas',
        clear: 'Apagar',
        filter: 'Filtro',
        showFilter: 'Mostrar filtro',
        hideFilter: 'Ocultar filtro',
        clearFilter: 'Limpar filtro',
        category: 'Categoria',
        allArticles: 'Todos',
        articles: 'artigos',
        clickToPickMotif: 'Clique num quadro da parede de quadros para escolher o tema.',
        clickToPickWall: 'Escolha a parede de quadros antes de escolher o tema',
        turnDevice: 'Vire a sua unidade ao contrário',
        swipeUp: 'Passe o dedo e faça um swipe para cima',
        waresAddedToCart: 'Os seus artigos foram adicionados ao carrinho de compras',
        proceedingToCheckout: 'Vai levá-lo até à caixa',
        saveBasket: 'Guardar a parede de quadros',
        noSavedWalls: 'Não tem paredes de quadros guardadas',
        updateOrnew: 'Escolheu uma parede de quadros guardada designada {name}; quer atualizar esta ou criar uma nova para guardar?',
        createNew: 'criar nova',
        update: 'atualizar',
        shareTitle: 'Partilhe a sua parede de quadros',
        shareSaveTitle: 'Deve primeiro guardar',
        shareSaveText: 'É necessário guardar a sua parede de quadros antes de a poder partilhar; quer guardar agora a sua parede de quadros?',
        errorTitle: 'Ocorreu algum erro',
        errorMessage: 'Ocorreu um erro técnico, por favor tente novamente ou entre em contacto com os serviços de apoio.',
        showMore: 'Mostrar mais',
        showLess: 'Mostrar menos',
        noProductsInBasket: 'Por favor escolha pelo menos um produto para adicionar ao carrinho de compras.',
        removeTitle: 'Remover a parede de quadros',
        removePromt: 'Tem a certeza que pretende remover a parede de quadros?',
        couldNotRemove: 'Não foi possível remover, por favor tente novamente ou entre em contacto com os serviços de apoio.',
        remove: 'Remover',
        removeFrame: 'Remover moldura',
        close: 'Fechar',
        wantToContinue: 'Gostaria de continuar?',
        unsavedChanges: 'Tem alterações não guardadas que vai perder se continuar; quer guardar agora a sua parede de quadros?',
        needsArticlesShare: 'Por favor adicione pelo menos um artigo antes de partilhar.',
        needsArticlesSave: 'Por favor adicione pelo menos um artigo antes de guardar.',
        needsPictureWall: 'Por favor escolha uma parede de quadros antes de escolher os artigos',
        menu: 'Menu',
        noMotivs: 'Não escolheu um tema',
        leavingSave: 'Não guardou a sua parede de quadros; quer sair? ',
        addedToCartDate: 'Adicionado ao carrinho {date}',
        saveAndMoveOn: 'Passo seguinte',
        MoveOn: 'Passo seguinte',
        saveandclose: 'Guardar e fechar',
        backgrounds: '1. Escolha a imagem de ambiente',
        pictureWalls: '2. Selecione a parede de quadros',
        yourMotifs: '3. Escolha o tema',
        frames: '4. Emoldure os seus temas',
        leftToFreeShipping: 'Restante que falta até ter o transporte gratuito',
        checkout: 'Para a caixa',
        total: 'soma total',
        emptyBasket: 'Não adicionou produtos ao seu carrinho.',
        allProducts: 'Todos os produtos',
        lastViewed: 'Últimos visualizados',
        myFavorites: 'Os meus favoritos',
        lastChosen: 'Últimos selecionados',
        choosePictureWallBeforeFrames: 'Por favor escolha a parede de quadros antes de escolher a moldura',
        dontSave: "não guardar",
        heartInfoTitle: '<na classe="fa fa-heart-o"></i> Sugestões ',
        heartInfo: 'Usar o símbolo do coração para guardar os seus favoritos. <br/> Ver os favoritos na lista drop-down no canto superior esquerdo.',
        purchaseNowTitle: 'Que bem que ficou!',
        purchaseNow: 'Pode adicionar ao carrinho toda a sua parede de quadros aqui.'
    }, _defineProperty(_pt, 'addToCart', 'Adicionar a'), _defineProperty(_pt, 'addToCartSmall', 'Adicionar a'), _defineProperty(_pt, 'toCheckout', 'Para a caixa'), _defineProperty(_pt, 'savedWalls', 'Paredes de quadros guardadas'), _defineProperty(_pt, 'goBackToStep', 'Passo anterior'), _defineProperty(_pt, 'favoritesThatMatch', 'Favoritos disponíveis no tamanho selecionado'), _defineProperty(_pt, 'favoritesThatMatchMobile', 'Favoritos no tamanho selecionado'), _defineProperty(_pt, 'noStock', 'Alguns dos artigos estão esgotados.'), _defineProperty(_pt, 'startTop', "Passo-a-passo"), _defineProperty(_pt, 'startTitle', 'Crie a parede de quadros perfeita'), _defineProperty(_pt, 'startText', 'Use a nossa nova ferramenta para encontrar os temas e molduras que ficam bem'), _defineProperty(_pt, 'startButton', 'INICIAR AQUI'), _defineProperty(_pt, 'clickFullscreen', 'Clique para tela cheia'), _defineProperty(_pt, 'noArticlesMatched', 'Lamentamos mas não encontramos produtos do (tamanho) que correspondam à sua busca.'), _defineProperty(_pt, 'breadcrumbPrints', 'Quadros'), _defineProperty(_pt, 'breadcrumbInsp', 'INSPIRAÇÃO'), _defineProperty(_pt, 'breadcrumbInspLink', 'https://desenio.pt/g/paredes-de-quadros/'), _defineProperty(_pt, 'breadcrumbGw', 'Crie a sua parede de quadros'), _defineProperty(_pt, 'breadcrumbGwLink', 'https://gwt.desenio.pt/#/'), _defineProperty(_pt, 'linkToWall', 'LINK PARA A SUA PAREDE DE QUADROS'), _defineProperty(_pt, 'copy', 'Copiar'), _defineProperty(_pt, 'outOfStock', 'Out of stock'), _defineProperty(_pt, 'outOfStockText', 'The items below are out of stock, you can watch the items to be informed when they are back in stock'), _defineProperty(_pt, 'checkoutUrl', 'https://checkout.desenio.pt'), _defineProperty(_pt, 'pageUrl', 'https://desenio.pt'), _pt),
    pl: (_pl = {
        countryCode: 'PL',
        yes: 'tak',
        no: 'nie',
        abort: 'anuluj',
        my: 'moje',
        done: 'koniec',
        pick: 'wybierz',
        save: 'zachowaj',
        share: 'udostępnij',
        buy: 'kup',
        addToCart: 'Dodaj do',
        name: 'Imię',
        currencySuffix: 'zł',
        currencySuffixBuy: 'zł',
        currencyPrefix: '',
        frameYourMotifs: 'Opraw swoje grafiki',
        background: 'tło | tła',
        picturewall: 'galeria domowa | galerie domowe',
        backgroundColor: 'kolor tła | kolory tła',
        color: 'kolor| kolory',
        motifs: 'projekt| projekty',
        clear: 'wyczyść',
        filter: 'filtry',
        showFilter: 'pokaż filtry',
        hideFilter: 'Ukryj filtry',
        clearFilter: 'Wyczyść filtry',
        category: 'Kategoria',
        allArticles: 'Wszystko',
        articles: 'produkty',
        clickToPickMotif: 'Kliknij na print w galerii ściennej żeby wybrać design.',
        clickToPickWall: 'Wybierz galerię przed wybraniem printu',
        turnDevice: 'Odwróć swoje urządzenie',
        swipeUp: 'Przesuń do góry',
        waresAddedToCart: 'Twoje produkty zostały dodane do koszyka',
        proceedingToCheckout: 'Przejdź do płatności',
        saveBasket: 'Zachowaj galerię',
        noSavedWalls: 'Brak zachowanych galerii',
        updateOrnew: 'Wybrałeś zachowaną galerię {nazwa}. Chcesz zmienić projekt, lub stworzyć nową galerię?  ',
        createNew: 'Stwórz nową',
        update: 'Zmień',
        shareTitle: 'Udostępnij swoją galerię plakatów',
        shareSaveTitle: 'Najpierw zachowaj projekt',
        shareSaveText: 'Musisz zachować projekt galerii przed udostępnieniem. Chcesz zachować galerię?',
        errorTitle: 'Coś poszło nie tak.',
        errorMessage: 'Przepraszamy, problem techniczny. Spróbuj jeszcze raz, lub skontaktuj się z nami.',
        showMore: 'Więcej',
        showLess: 'Mniej',
        noProductsInBasket: 'Wybierz przynajmniej jeden produkt do koszyka',
        removeTitle: 'Wymaż projekt galerii',
        removePromt: 'Na pewno chcesz wymazać projekt galerii plakatów?',
        couldNotRemove: 'Nie można wymazać. Spróbuj jeszcze raz, lub skontaktuj się z nami.',
        remove: 'Wymaż',
        removeFrame: 'Wymaż ramkę',
        close: 'Zamknij',
        wantToContinue: 'Chcesz kontynuować?',
        unsavedChanges: 'Twoje zmiany nie zostały zapisane. Chcesz zapisać swój projekt galeri ściennej?',
        needsArticlesShare: 'Dodaj przynajmniej jeden element przed udostępnieniem.',
        needsArticlesSave: 'Dodaj przynajmniej jeden element przed zapisaniem.',
        needsPictureWall: 'Wybierz projekt galerii zanim wybierzesz produkty',
        menu: 'Menu',
        noMotivs: 'Nie wybrano żadnych projektów',
        leavingSave: 'Twój projekt galerii nie został zapisany, czy chcesz zamknąć bez zapisywania?',
        addedToCartDate: 'Dodane do koszyka {data}',
        saveAndMoveOn: 'Dalej',
        moveOn: 'Dalej',
        saveAndClose: 'Zapisz i zamknij',
        backgrounds: '1. Wybierz tło',
        pictureWalls: '2. Wybierz galerię',
        yourMotifs: '3. Wybierz grafiki',
        frames: '4. Opraw swoje plakaty',
        leftToFreeShipping: 'Do darmowej przesyłki brakuje',
        checkout: 'Koszyk',
        total: 'Cena całkowita',
        emptyBasket: 'Żadne produkty nie zostały wybrane do koszyka.',
        allProducts: 'Wszystkie produkty',
        lastViewed: 'Ostatnio oglądane',
        myFavorites: 'Moje ulubione',
        lastChosen: 'Ostatnio wybrane',
        choosePictureWallBeforeFrames: 'Wybierz projekt galerii przed wybraniem ramek.',
        dontSave: "nie zapisuj",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Wskazówki',
        heartInfo: 'Kliknij na ikonkę serca, żeby zapisać artykuły do ulubionych. <br/> Wyświetl swoje ulubione produkty rozwijając listę po lewej stronie',
        purchaseNowTitle: 'Wygląda wspaniale!',
        purchaseNow: 'Tutaj dodasz cały Twój projekt galerii z plakatami do koszyka'
    }, _defineProperty(_pl, 'addToCart', 'Dodaj do'), _defineProperty(_pl, 'addToCartSmall', 'Dodaj do'), _defineProperty(_pl, 'toCheckout', 'Koszyk'), _defineProperty(_pl, 'savedWalls', 'Zapisane projekty galerii'), _defineProperty(_pl, 'goBackToStep', 'Wstecz'), _defineProperty(_pl, 'favoritesThatMatch', 'Ulubione dostępne są w wybranych rozmiarach'), _defineProperty(_pl, 'favoritesThatMatchMobile', 'Ulubione w wybranych rozmiarach'), _defineProperty(_pl, 'noStock', 'Niektóre produkty są wyprzedane.'), _defineProperty(_pl, 'startTop', 'Krok po kroku'), _defineProperty(_pl, 'startTitle', 'Stwórz perfekcyjną domową galerię'), _defineProperty(_pl, 'startText', 'Skorzystaj z naszego nowego narzędzia, aby znaleźć pasujące grafiki i ramki'), _defineProperty(_pl, 'startButton', 'ZACZNIJ TUTAJ'), _defineProperty(_pl, 'clickFullscreen', 'Pełny ekran'), _defineProperty(_pl, 'noArticlesMatched', 'Przepraszamy, niestety nie znaleźliśmy żadnych produktów w tym (rozmiarze)'), _defineProperty(_pl, 'breadcrumbPrints', 'Plakaty'), _defineProperty(_pl, 'breadcrumbInsp', 'INSPIRACJE'), _defineProperty(_pl, 'breadcrumbInspLink', 'https://desenio.pl/g/galeria-obrazow/'), _defineProperty(_pl, 'breadcrumbGw', 'Stwórz swoją domową galerię'), _defineProperty(_pl, 'breadcrumbGwLink', 'https://gwt.desenio.pl/#/'), _defineProperty(_pl, 'linkToWall', 'LINK DO TWOJEJ GALERII'), _defineProperty(_pl, 'copy', 'Kopiuj'), _defineProperty(_pl, 'outOfStock', 'Na wyczerpaniu zapasów'), _defineProperty(_pl, 'outOfStockText', 'Poniższe produkty są niedostępne w magazynie, możesz je obserwować, aby być informowanym o ich dostępności.'), _defineProperty(_pl, 'checkoutUrl', 'https://checkout.desenio.pl'), _defineProperty(_pl, 'pageUrl', 'https://desenio.pl'), _pl),
    cs: (_cs = {
        countryCode: 'CS',
        yes: 'ano',
        no: 'ne',
        abort: 'zrušit',
        my: 'můj',
        done: 'hotovo',
        pick: 'vybrat',
        save: 'uložit',
        share: 'sdílet',
        buy: 'koupit',
        addToCart: 'Přidat do',
        name: 'Jméno',
        currencySuffix: ' Kč',
        currencySuffixBuy: ' Kč',
        currencyPrefix: '',
        frameYourMotifs: 'Orámuj si svůj design',
        background: 'pozadí | pozadí',
        picturewall: 'koláž | koláže',
        backgroundColor: 'barva pozadí | barvy pozadí',
        color: 'barva | barvy',
        motifs: 'návrh | návrhy',
        clear: 'Vymazat',
        filter: 'Filtr',
        showFilter: 'Zobrazit filtr',
        hideFilter: 'Skrýt filtr',
        clearFilter: 'Vymazat filtr',
        category: 'Kategorie',
        allArticles: 'Všechny',
        articles: 'položky',
        clickToPickMotif: 'Pro výběr designu klikněte na obrázek na koláži.',
        clickToPickWall: 'Vyberte koláž, než vyberete návrhy.',
        turnDevice: 'Otočte zařízení',
        swipeUp: 'Posuňte nahoru',
        waresAddedToCart: 'Vaše položky byly přidány do košíku',
        proceedingToCheckout: 'Přejít k pokladně',
        saveBasket: 'Uložit koláž.',
        noSavedWalls: 'Žádné uložené koláže.',
        updateOrnew: 'Vybrali jste uloženou koláž {název}. Chcete aktualizovat svou koláž nebo vytvořit novou? ',
        createNew: 'vytvořit novou',
        update: 'aktualizovat',
        shareTitle: 'Sdílet svou koláž.',
        shareSaveTitle: 'Nejprve uložte.',
        shareSaveText: 'Před sdílením je třeba koláž uložit. Chcete nyní koláž uložit?',
        errorTitle: 'Něco se pokazilo.',
        errorMessage: 'Došlo k technickému problému. Opakujte akci nebo se obraťte na naši službu podpory.',
        showMore: 'Zobrazit více',
        showLess: 'Zobrazit méně',
        noProductsInBasket: 'Vyberte alespoň jeden výrobek, který přidáte do košíku.',
        removeTitle: 'Smazat koláž.',
        removePromt: 'Opravdu chcete koláž smazat?',
        couldNotRemove: 'Nelze odstranit. Opakujte akci nebo se obraťte na naši službu podpory.',
        remove: 'Odstranit',
        removeFrame: 'Smazat rám',
        close: 'Zavřít',
        wantToContinue: 'Chcete pokračovat?',
        unsavedChanges: 'Provedli jste změny, které nebyly uloženy. Chcete nyní koláž uložit?',
        needsArticlesShare: 'Před sdílením přidejte alespoň jednu položku.',
        needsArticlesSave: 'Před uložením přidejte alespoň jednu položku.',
        needsPictureWall: 'Vyberte koláž, než vyberete položky.',
        menu: 'Nabídka',
        noMotivs: 'Nevybrali jste žádné návrhy.',
        leavingSave: 'Koláž jste neuložili. Opravdu chcete odejít?',
        addedToCartDate: 'Přidáno do košíku {datum}',
        saveAndMoveOn: 'Další krok',
        moveOn: 'Další krok',
        saveAndClose: 'Uložit a zavřít',
        backgrounds: '1. Vybrat pozadí',
        pictureWalls: '2. Vybrat koláž',
        yourMotifs: '3. Vybrat návrhy',
        frames: '4. Orámuj si svůj design',
        leftToFreeShipping: 'Potřebné pro dopravu zdarma',
        checkout: 'Pokladna',
        total: 'Celková částka',
        emptyBasket: 'Do košíku jste nepřidali žádné produkty.',
        allProducts: 'Všechny produkty',
        lastViewed: 'Naposledy zobrazeno',
        myFavorites: 'Oblíbené položky',
        lastChosen: 'Naposledy vybrané',
        choosePictureWallBeforeFrames: 'Vyberte koláž, než vyberete rámečky.',
        dontSave: "neukládat",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tipy ',
        heartInfo: 'Klepnutím na symbol srdce uložte oblíbené položky. <br/> Zobrazí oblíbené položky v rozevíracím seznamu vlevo.',
        purchaseNowTitle: 'To vypadá skvěle!',
        purchaseNow: 'Do košíku můžete přidat celou svou koláž.'
    }, _defineProperty(_cs, 'addToCart', 'Přidat do'), _defineProperty(_cs, 'addToCartSmall', 'Přidat do'), _defineProperty(_cs, 'toCheckout', 'Pokladna'), _defineProperty(_cs, 'savedWalls', 'Uložit koláže.'), _defineProperty(_cs, 'goBackToStep', 'Předchozí krok'), _defineProperty(_cs, 'favoritesThatMatch', 'Dostupné oblíbené položky ve vybrané velikosti'), _defineProperty(_cs, 'favoritesThatMatchMobile', 'Oblíbené položky ve vybrané velikosti'), _defineProperty(_cs, 'noStock', 'Některé položky nejsou na skladě.'), _defineProperty(_cs, 'startTop', 'Krok za krokem'), _defineProperty(_cs, 'startTitle', 'Vytvoření perfektní nástěnné galerie.'), _defineProperty(_cs, 'startText', 'Použijte náš nový nástroj k vyhledání návrhů a rámů, které k sobě ladí.'), _defineProperty(_cs, 'startButton', 'ZAČNĚTE ZDE'), _defineProperty(_cs, 'clickFullscreen', 'Kliknutím zobrazíte celou obrazovku.'), _defineProperty(_cs, 'noArticlesMatched', 'Lituji, ale nemůžeme najít žádné produkty (o velikosti), které by odpovídaly vašemu vyhledávání.'), _defineProperty(_cs, 'breadcrumbPrints', 'PLAKÁTECH'), _defineProperty(_cs, 'breadcrumbInsp', 'INSPIRACE'), _defineProperty(_cs, 'breadcrumbInspLink', 'https://desenio.cz/g/nastenne-galerie/'), _defineProperty(_cs, 'breadcrumbGw', 'Vytvořte si vlastní nástěnnou galerii'), _defineProperty(_cs, 'breadcrumbGwLink', 'https://gwt.desenio.cz/#/'), _defineProperty(_cs, 'linkToWall', 'ODKAZ NA VAŠÍ NÁSTĚNNOU GALERII'), _defineProperty(_cs, 'copy', 'Kopírovat'), _defineProperty(_cs, 'outOfStock', 'Není skladem'), _defineProperty(_cs, 'outOfStockText', 'Níže uvedené položky nejsou skladem, můžete je sledovat, abyste byli informováni, až budou opět skladem.'), _defineProperty(_cs, 'checkoutUrl', 'https://checkout.desenio.cz'), _defineProperty(_cs, 'pageUrl', 'https://desenio.cz'), _cs),
    sk: (_sk = {
        countryCode: 'SK',
        yes: 'áno',
        no: 'nie',
        abort: 'zrušiť',
        my: 'môj',
        done: 'hotovo',
        pick: 'vybrať',
        save: 'uložiť',
        share: 'zdieľať',
        buy: 'kúpiť',
        addToCart: 'Pridať do',
        name: 'Názov',
        currencySuffix: ' ',
        currencySuffixBuy: ' €',
        currencyPrefix: '',
        frameYourMotifs: 'Zarámujte si motívy',
        background: 'pozadie | pozadia',
        picturewall: 'obrazová stena | obrazové steny',
        backgroundColor: 'farba pozadia | farby pozadia',
        color: 'farba | farby',
        motifs: 'dizajn | dizajny',
        clear: 'Vymazať',
        filter: 'Filter',
        showFilter: 'Zobraziť filter',
        hideFilter: 'Skryť filter',
        clearFilter: 'Vymazať filter',
        category: 'Kategória',
        allArticles: 'Všetko',
        articles: 'Položky',
        clickToPickMotif: 'Kliknite na obrázok z obrazovej steny, aby ste si vybrali motív.',
        clickToPickWall: 'Vyberte si obrazovú stenu predtým, ako si vyberiete motívy',
        turnDevice: 'Zapnite zariadenie',
        swipeUp: 'Potiahnite nahor',
        waresAddedToCart: 'Položky, ktoré ste si vybrali, boli pridané do košíka',
        proceedingToCheckout: 'Prejsť k platbe',
        saveBasket: 'Uložiť obrazovú stenu',
        noSavedWalls: 'Neuložili ste  žiadnu obrazovú stenu',
        updateOrnew: 'Vybrali ste si uloženú obrazovú stenu {názov}. Chceli by ste aktualizovať stenu alebo vytvoriť novú? ',
        createNew: 'vytvoriť novú',
        update: 'aktualizovať',
        shareTitle: 'Zdieľať obrazovú stenu',
        shareSaveTitle: 'Najprv ju, prosím, uložte',
        shareSaveText: 'Pred zdieľaním obrazovej steny ju musíte najprv uložiť. Chcete ju uložiť teraz?',
        errorTitle: 'Chyba.',
        errorMessage: 'Vyskytol sa technický problém. Skúste to znova alebo kontaktujte našu technickú podporu.',
        showMore: 'Zobraziť viac',
        showLess: 'Zobraziť menej',
        noProductsInBasket: 'Vyberte, prosím, aspoň jeden produkt do košíka.',
        removeTitle: 'Odstrániť obrazovú stenu',
        removePromt: 'Ste si istý, že chcete odstrániť obrazovú stenu?',
        couldNotRemove: 'Odstránenie nebolo možné. Vyskúšajte to, prosím, znova, alebo kontaktujte našu technickú podporu.',
        remove: 'Odstrániť',
        removeFrame: 'Odstrániť rám',
        close: 'Zatvoriť',
        wantToContinue: 'Chcete pokračovať?',
        unsavedChanges: 'Urobili ste zmeny, ktoré neboli uložené. Chcete uložiť obrazovú stenu teraz?',
        needsArticlesShare: 'Pred zdieľaním pridajte, prosím, aspoň jednu položku.',
        needsArticlesSave: 'Pred uložením pridajte, prosím, aspoň jednu položku.',
        needsPictureWall: 'Pred vybraním položiek, prosím, vyberte obrazovú stenu.',
        menu: 'Menu',
        noMotivs: 'Nevybrali ste žiadny motív',
        leavingSave: 'Neuložili ste obrazovú stenu. Ste si istý, že chcete odísť?',
        addedToCartDate: 'Pridané do košíka {dátum}',
        saveAndMoveOn: 'Ďalší krok',
        moveOn: 'Ďalší krok',
        saveAndClose: 'Uložiť a zavrieť',
        backgrounds: '1. Zvoliť pozadie',
        pictureWalls: '2. Zvoliť obrazovú stenu',
        yourMotifs: '3. Zvoliť motívy',
        frames: '4. Zarámovať motívy',
        leftToFreeShipping: 'Pre poštovné zdarma',
        checkout: 'K platbe',
        total: 'celková suma',
        emptyBasket: 'Nepridali ste žiadne položky do košíka.',
        allProducts: 'Všetky produkty',
        lastViewed: 'Posledné zobrazené',
        myFavorites: 'Moje obľúbené',
        lastChosen: 'Posledné vybrané',
        choosePictureWallBeforeFrames: 'Pred výberom rámov si, prosím, vyberte obrazovú stenu.',
        dontSave: "neukladať",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tipy ',
        heartInfo: 'Kliknite na srdce, aby ste uložili svoje obľúbené kúsky. <br/> Zobraziť obľúbené kúsky v rozbaľovacom zozname vľavo.',
        purchaseNowTitle: 'Toto vyzerá skvele!',
        purchaseNow: 'Tu môžete pridať celú obrazovú stenu do košíka.'
    }, _defineProperty(_sk, 'addToCart', 'Pridať do'), _defineProperty(_sk, 'addToCartSmall', 'Pridať do'), _defineProperty(_sk, 'toCheckout', 'K platbe'), _defineProperty(_sk, 'savedWalls', 'Uložiť obrazové steny'), _defineProperty(_sk, 'goBackToStep', 'Predošlý krok'), _defineProperty(_sk, 'favoritesThatMatch', 'Obľúbené kúsky k dispozícii vo vybranej veľkosti'), _defineProperty(_sk, 'favoritesThatMatchMobile', 'Obľúbené kúsky vo vybranej veľkosti'), _defineProperty(_sk, 'noStock', 'Niektoré položky nie sú na sklade.'), _defineProperty(_sk, 'startTop', 'Krok za krokom'), _defineProperty(_sk, 'startTitle', 'Vytvorte dokonalú obrazovú stenu'), _defineProperty(_sk, 'startText', 'Použite náš nový nástroj na vyhľadanie motívov a rámov, ktoré sa k sebe hodia'), _defineProperty(_sk, 'startButton', 'ZAČNITE TU'), _defineProperty(_sk, 'clickFullscreen', 'Kliknite na zobrazenie celej obrazovky'), _defineProperty(_sk, 'noArticlesMatched', 'Ľutujeme, nepodarilo sa nájsť žiadne produkty vo veľkosti (veľkosť), ktoré zodpovedajú vášmu vyhľadávaniu.'), _defineProperty(_sk, 'breadcrumbPrints', 'PLAGÁTY'), _defineProperty(_sk, 'breadcrumbInsp', 'INŠPIRÁCIA'), _defineProperty(_sk, 'breadcrumbInspLink', 'https://desenio.sk/g/zostavy-obrazov/'), _defineProperty(_sk, 'breadcrumbGw', 'Vytvorte si obrazovú stenu'), _defineProperty(_sk, 'breadcrumbGwLink', 'https://gwt.desenio.sk/'), _defineProperty(_sk, 'linkToWall', 'ODKAZ NA VAŠU ZOSTAVU OBRAZOV'), _defineProperty(_sk, 'copy', 'Kopírovať'), _defineProperty(_sk, 'outOfStock', 'Ni na zalogi'), _defineProperty(_sk, 'outOfStockText', 'Spodnjih izdelkov ni na zalogi, lahko jih spremljate in boste obveščeni, ko bodo spet na zalogi.'), _defineProperty(_sk, 'checkoutUrl', 'https://checkout.desenio.sk'), _defineProperty(_sk, 'pageUrl', 'https://desenio.sk'), _sk),
    el: (_el = {
        countryCode: 'EL',
        yes: 'ναι',
        no: 'όχι',
        abort: 'ακύρωση',
        my: 'τα',
        done: 'ολοκληρώθηκε',
        pick: 'επιλογή',
        save: 'αποθήκευση',
        share: 'μοιραστείτε',
        buy: 'αγορά',
        addToCart: 'προσθήκη σε',
        name: 'Όνομα',
        currencySuffix: '',
        currencySuffixBuy: '',
        currencyPrefix: '€',
        frameYourMotifs: 'Καδράρετε τα poster σας',
        background: 'φόντου | φόντα',
        picturewall: 'σύνθεσης gallery wall | συνθέσεις gallery wall',
        backgroundColor: 'χρώμα φόντου | χρώματα φόντου',
        color: 'χρώμα | χρώματα',
        motifs: 'poster | poster',
        clear: 'Εκκαθάριση',
        filter: 'Φίλτρο',
        showFilter: 'Εμφάνιση φίλτρου',
        hideFilter: 'Απόκρυψη φίλτρου',
        clearFilter: 'Απαλοιφή φίλτρου',
        category: 'Κατηγορία',
        allArticles: 'Όλα',
        articles: 'προϊόντα',
        clickToPickMotif: 'Κάντε κλικ σε μια εικόνα στο gallery wall για να επιλέξετε ένα poster.',
        clickToPickWall: 'Επιλέξτε μία σύνθεση gallery wall πριν επιλέξετε σχέδια',
        turnDevice: 'Περιστρέψτε τη συσκευή σας',
        swipeUp: 'Swipe up',
        waresAddedToCart: 'Τα προϊόντα έχουν προστεθεί στο καλάθι σας',
        proceedingToCheckout: 'Προχωρήστε στην ολοκλήρωση της αγοράς',
        saveBasket: 'Αποθήκευση gallery wall',
        noSavedWalls: 'Δεν υπάρχουν αποθηκευμένα gallery wall',
        updateOrnew: 'Επιλέξατε ένα αποθηκευμένο gallery wall {name}. Θέλετε να ενημερώσετε τον τοίχο σας ή να δημιουργήσετε έναν νέο; ',
        createNew: 'δημιουργία νέου',
        update: 'ενημέρωση',
        shareTitle: 'Μοιραστείτε το gallery wall',
        shareSaveTitle: 'Παρακαλούμε αποθηκεύστε πρώτα',
        shareSaveText: 'Πρέπει να αποθηκεύσετε το gallery wall για να μπορέσετε να το μοιραστείτε. Θέλετε να αποθηκεύσετε το gallery wall σας τώρα;',
        errorTitle: 'Κάτι πήγε στραβά.',
        errorMessage: 'Παρουσιάστηκε ένα τεχνικό πρόβλημα. Προσπαθήστε ξανά ή επικοινωνήστε με την υπηρεσία υποστήριξης.',
        showMore: 'Εμφάνιση περισσότερων',
        showLess: 'Εμφάνιση λιγότερων',
        noProductsInBasket: 'Επιλέξτε τουλάχιστον ένα προϊόν για προσθήκη στο καλάθι σας.',
        removeTitle: 'Διαγραφή gallery wall',
        removePromt: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το gallery wall;',
        couldNotRemove: 'Δεν είναι δυνατή η διαγραφή. Προσπαθήστε ξανά ή επικοινωνήστε με την υπηρεσία υποστήριξης.',
        remove: 'Διαγραφή',
        removeFrame: 'Διαγραφή κορνίζας',
        close: 'Κλείσιμο',
        wantToContinue: 'Θέλετε να συνεχίσετε;',
        unsavedChanges: 'Έχετε κάνει αλλαγές που δεν έχουν αποθηκευτεί. Θέλετε να αποθηκεύσετε το gallery wall σας τώρα;',
        needsArticlesShare: 'Προσθέστε τουλάχιστον ένα προϊόν πριν το μοιραστείτε.',
        needsArticlesSave: 'Προσθέστε τουλάχιστον ένα προϊόν πριν την αποθήκευση.',
        needsPictureWall: 'Επιλέξτε ένα gallery wall πριν επιλέξετε προϊόντα.',
        menu: 'Μενού',
        noMotivs: 'Δεν έχετε επιλέξει poster',
        leavingSave: 'Δεν αποθηκεύσατε το gallery wall σας. Είστε σίγουροι ότι θέλετε να φύγετε;',
        addedToCartDate: 'Προστέθηκε στο καλάθι {date}',
        saveAndMoveOn: 'Επόμενο',
        moveOn: 'Επόμενο',
        saveAndClose: 'Αποθήκευση και κλείσιμο',
        backgrounds: '1. Επιλογή φόντου',
        pictureWalls: '2. Επιλογή gallery wall',
        yourMotifs: '3. Επιλογή poster',
        frames: '4. Καδράρετε τα poster σας',
        leftToFreeShipping: 'Απαιτείται για δωρεάν αποστολή',
        checkout: 'Πληρωμή',
        total: 'συνολικό ποσό',
        emptyBasket: 'Δεν έχετε προσθέσει προϊόντα στο καλάθι σας.',
        allProducts: 'Όλα τα προϊόντα',
        lastViewed: 'Τελευταία προβολή',
        myFavorites: 'Τα αγαπημένα μου',
        lastChosen: 'Τελευταίες επιλογές',
        choosePictureWallBeforeFrames: 'Επιλέξτε ένα gallery wall πριν επιλέξετε κορνίζες.',
        dontSave: "Χωρίς αποθήκευση",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Κάντε κλικ στο σύμβολο της καρδιάς για να αποθηκεύσετε τα αγαπημένα σας.<br/> Εμφάνιση αγαπημένων στην αναπτυσσόμενη λίστα στα αριστερά.',
        purchaseNowTitle: 'Αυτό φαίνεται υπέροχο!',
        purchaseNow: 'Μπορείτε να προσθέσετε ολόκληρο το gallery wall στο καλάθι σας εδώ.'
    }, _defineProperty(_el, 'addToCart', 'Προσθήκη σε'), _defineProperty(_el, 'addToCartSmall', 'Προσθήκη σε'), _defineProperty(_el, 'toCheckout', 'Πληρωμή'), _defineProperty(_el, 'savedWalls', 'Αποθηκευμένα gallery wall'), _defineProperty(_el, 'goBackToStep', 'ΠΡΟΗΓΟΥΜΕΝΟ'), _defineProperty(_el, 'favoritesThatMatch', 'Αγαπημένα διαθέσιμα στο επιλεγμένο μέγεθος'), _defineProperty(_el, 'favoritesThatMatchMobile', 'Αγαπημένα στο επιλεγμένο μέγεθος'), _defineProperty(_el, 'noStock', 'Ορισμένα προϊόντα είναι εκτός αποθέματος.'), _defineProperty(_el, 'startTop', 'Βήμα προς βήμα'), _defineProperty(_el, 'startTitle', 'Δημιουργήστε το τέλειο gallery wall'), _defineProperty(_el, 'startText', 'Χρησιμοποιήστε το νέο μας εργαλείο για να βρείτε poster και κορνίζες που ταιριάζουν μεταξύ τους'), _defineProperty(_el, 'startButton', 'ΞΕΚΙΝΗΣΤΕ ΕΔΩ'), _defineProperty(_el, 'clickFullscreen', 'Κάντε κλικ για πλήρη οθόνη'), _defineProperty(_el, 'noArticlesMatched', "Λυπούμαστε, δεν μπορούμε να βρούμε προϊόντα σε (size) που να ταιριάζουν με την αναζήτησή σας."), _defineProperty(_el, 'breadcrumbPrints', 'Posters'), _defineProperty(_el, 'breadcrumbInsp', 'Έμπνευση'), _defineProperty(_el, 'breadcrumbInspLink', 'https://desenio.es/g/galerias-de-pared/'), _defineProperty(_el, 'breadcrumbGw', 'Δημιουργήστε το gallery wall σας'), _defineProperty(_el, 'breadcrumbGwLink', 'https://desenio.gr/g/gallery-wall/'), _defineProperty(_el, 'linkToWall', 'Ο ΣΥΝΔΕΣΜΟΣ ΤΟΥ GALLERY WALL ΣΑΣ'), _defineProperty(_el, 'copy', 'Αντιγραφή'), _defineProperty(_el, 'outOfStock', 'Δεν υπάρχει απόθεμα'), _defineProperty(_el, 'outOfStockText', 'Τα παρακάτω είδη δεν υπάρχουν σε απόθεμα, μπορείτε να τα παρακολουθήσετε για να ειδοποιηθείτε όταν επανέλθουν σε απόθεμα.'), _defineProperty(_el, 'checkoutUrl', 'https://checkout.desenio.gr'), _defineProperty(_el, 'pageUrl', 'https://desenio.gr'), _el)

    // Clone UK to US
};messages['us'] = _.cloneDeep(messages["en"]);
messages['us']['countryCode'] = 'US';
messages['us']['currencyPrefix'] = '';
messages['us']['currencySuffix'] = ' USD';
messages['us']['currencySuffixBuy'] = ' USD';
messages['us']['breadcrumbPrints'] = 'Wall art';
messages['us']['breadcrumbInsp'] = 'INSPIRATION';
messages['us']['breadcrumbInspLink'] = '/us/gallery-walls';
messages['us']['breadcrumbGw'] = 'Create your gallery wall';
messages['us']['breadcrumbGwLink'] = '/us/ak/inspiration/create-your-gallery-wall';

messages['us']['checkoutUrl'] = 'https://checkout.desenio.com';
messages['us']['pageUrl'] = 'https://desenio.com';

// Subdomains
// DEAT
messages['deat'] = _.cloneDeep(messages["de"]);
messages['deat']['countryCode'] = 'DEAT';
messages['deat']['breadcrumbPrints'] = 'Wanbilder';
messages['deat']['breadcrumbInsp'] = 'INSPIRATION';
messages['deat']['breadcrumbInspLink'] = '/at/bilderwand-inspiration-posters';
messages['deat']['breadcrumbGw'] = 'Komponiere deine Bilderwand';
messages['deat']['breadcrumbGwLink'] = '/at/ak/inspiration/komponiere-deine-bilderwand-deat';

messages['deat']['checkoutUrl'] = 'https://checkout.desenio.at';
messages['deat']['pageUrl'] = 'https://desenio.at';
// ENAU
messages['enau'] = _.cloneDeep(messages["en"]);
messages['enau']['countryCode'] = 'ENAU';
messages['enau']['currencyPrefix'] = '';
messages['enau']['currencySuffix'] = ' &dollar;';
messages['enau']['currencySuffixBuy'] = ' &dollar;';
messages['enau']['breadcrumbPrints'] = 'Wall art';
messages['enau']['breadcrumbInsp'] = 'INSPIRATION';
messages['enau']['breadcrumbInspLink'] = '/au/inspiration';
messages['enau']['breadcrumbGw'] = 'Create your gallery wall';
messages['enau']['breadcrumbGwLink'] = '/au/ak/inspiration/create-your-gallery-wall';

messages['enau']['checkoutUrl'] = 'https://checkout.desenio.com.au';
messages['enau']['pageUrl'] = 'https://desenio.com.au';

// DEBE
messages['debe'] = _.cloneDeep(messages["de"]);
messages['debe']['countryCode'] = 'DEBE';
messages['debe']['breadcrumbPrints'] = 'Wanbilder';
messages['debe']['breadcrumbInsp'] = 'INSPIRATION';
messages['debe']['breadcrumbInspLink'] = '/be/de/bilderwand-inspiration-posters';
messages['debe']['breadcrumbGw'] = 'Komponiere deine Bilderwand';
messages['debe']['breadcrumbGwLink'] = '/debe/ak/inspiration/komponiere-deine-bilderwand-debe';

messages['debe']['checkoutUrl'] = 'https://de-checkout.desenio.be';
messages['debe']['pageUrl'] = 'https://desenio.be/de-be/';

// FRBE
messages['frbe'] = _.cloneDeep(messages["fr"]);
messages['frbe']['countryCode'] = 'FRBE';
messages['frbe']['breadcrumbPrints'] = 'Tableaux';
messages['frbe']['breadcrumbInsp'] = 'INSPIRATION';
messages['frbe']['breadcrumbInspLink'] = '/be/fr/inspiration';
messages['frbe']['breadcrumbGw'] = 'Créez votre mur de cadres';
messages['frbe']['breadcrumbGwLink'] = '/frbe/ak/inspiration/creez-votre-mur-de-tableaux-frbe';

messages['frbe']['checkoutUrl'] = 'https://fr-checkout.desenio.be';
messages['frbe']['pageUrl'] = 'https://desenio.be/fr-be/';

// NLBE
messages['nlbe'] = _.cloneDeep(messages["nl"]);
messages['nlbe']['countryCode'] = 'NLBE';
messages['nlbe']['breadcrumbPrints'] = 'Posters';
messages['nlbe']['breadcrumbInsp'] = 'INSPIRATIE';
messages['nlbe']['breadcrumbInspLink'] = '/be/nl/inspiratie-poster';
messages['nlbe']['breadcrumbGw'] = 'Stel uw fotowand samen';
messages['nlbe']['breadcrumbGwLink'] = '/nlbe/ak/inspiration/stel-uw-fotowand-samen-nlbe';

messages['nlbe']['checkoutUrl'] = 'https://nl-checkout.desenio.be';
messages['nlbe']['pageUrl'] = 'https://desenio.be/nl-be/';

// DECH
messages['dech'] = _.cloneDeep(messages["de"]);
messages['dech']['countryCode'] = 'DECH';
messages['dech']['currencyPrefix'] = '';
messages['dech']['currencySuffix'] = ' CHF';
messages['dech']['currencySuffixBuy'] = ' CHF';
messages['dech']['breadcrumbPrints'] = 'Wanbilder';
messages['dech']['breadcrumbInsp'] = 'INSPIRATION';
messages['dech']['breadcrumbInspLink'] = '/ch/de/bilderwand-inspiration-posters';
messages['dech']['breadcrumbGw'] = 'Komponiere deine Bilderwand';
messages['dech']['breadcrumbGwLink'] = '/dech/ak/inspiration/komponiere-deine-bilderwand-dech';

messages['dech']['checkoutUrl'] = 'https://de-checkout.desenio.ch';
messages['dech']['pageUrl'] = 'https://desenio.ch/de-ch/';

// FRCH
messages['frch'] = _.cloneDeep(messages["fr"]);
messages['frch']['countryCode'] = 'FRCH';
messages['frch']['currencyPrefix'] = '';
messages['frch']['currencySuffix'] = ' CHF';
messages['frch']['currencySuffixBuy'] = ' CHF';
messages['frch']['breadcrumbPrints'] = 'Tableaux';
messages['frch']['breadcrumbInsp'] = 'INSPIRATION';
messages['frch']['breadcrumbInspLink'] = '/ch/fr/inspiration';
messages['frch']['breadcrumbGw'] = 'Créez votre mur de cadres';
messages['frch']['breadcrumbGwLink'] = '/frch/ak/inspiration/creez-votre-mur-de-tableaux';

messages['frch']['checkoutUrl'] = 'https://fr-checkout.desenio.ch';
messages['frch']['pageUrl'] = 'https://desenio.ch/fr-ch/';

// ITCH
messages['itch'] = _.cloneDeep(messages["it"]);
messages['itch']['countryCode'] = 'ITCH';
messages['itch']['currencyPrefix'] = '';
messages['itch']['currencySuffix'] = ' CHF';
messages['itch']['currencySuffixBuy'] = ' CHF';
messages['itch']['breadcrumbPrints'] = 'Quadri';
messages['itch']['breadcrumbInsp'] = 'ISPIRAZIONE';
messages['itch']['breadcrumbInspLink'] = '/ch/it/ispirazione';
messages['itch']['breadcrumbGw'] = 'Crea la tua galleria a parete';
messages['itch']['breadcrumbGwLink'] = '/itch/ak/inspiration/crea-la-tua-galleria-a-parete';

messages['itch']['checkoutUrl'] = 'https://it-checkout.desenio.ch';
messages['frch']['pageUrl'] = 'https://desenio.ch/it-ch/';

// ENIE
messages['enie'] = _.cloneDeep(messages["en"]);
messages['enie']['countryCode'] = 'ENIE';
messages['enie']['currencyPrefix'] = '';
messages['enie']['currencySuffix'] = ' €';
messages['enie']['currencySuffixBuy'] = ' €';
messages['enie']['breadcrumbInsp'] = 'Gallery Walls';
messages['enie']['breadcrumbInspLink'] = 'https://desenio.ie/g/gallery-walls';
messages['enie']['breadcrumbGwLink'] = 'https://gwt.desenio.ie';

messages['enie']['checkoutUrl'] = 'https://checkout.desenio.ie';
messages['enie']['pageUrl'] = 'https://desenio.ie';

if (typeof window.currentLang == 'undefined') window.currentLang = "en";

// Create VueI18n instance with options
/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: window.currentLang, // set locale
    messages: messages // set locale messages
});

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = {

	computed: {
		checkoutUrl: function checkoutUrl() {
			return this.$t('checkoutUrl') + '/checkout/?loadcart=' + this.$store.state.basketID + '&source=' + window.location.href;
		}
	}

};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = {

	computed: {

		/*--------------------------
  	Locale
  ----------------------------*/

		locale: function locale() {
			return this.$t('countryCode');
		},


		/*--------------------------
  	Completed steps
  ----------------------------*/

		steps: function steps() {

			var self = this;

			// Create steps variable 
			var steps = {
				background: false,
				pictureWall: false,
				motifs: false,
				frames: false,
				complete: true

				// Check background
			};if (self.$store.state.background) steps.background = true;

			// Check picturewall
			if (self.$store.state.pictureWall) steps.pictureWall = true;

			// Check motifs
			var motifsDone = false;
			var motifs = self.$store.state.chosenArticles;

			if (!$.isEmptyObject(motifs)) {
				var motifsDone = true;

				$.each(self.$store.state.chosenArticles, function (index, value) {
					if (!value) {
						motifsDone = false;
					}
				});
			}

			steps.motifs = motifsDone;

			// Check frames
			var frames = self.$store.state.chosenFrames;
			var framesDone = false;

			if (!$.isEmptyObject(frames)) {
				var framesDone = true;
				$.each(frames, function (index, value) {
					if (!value) framesDone = false;
				});
			}
			steps.frames = framesDone;

			$.each(steps, function (index, value) {
				if (!value) steps.complete = false;
			});

			return steps;
		},


		/*--------------------------
  	Current picker
  ----------------------------*/

		currentPicker: function currentPicker() {
			return this.$store.state.currentPicker;
		},
		currentLeftTitle: function currentLeftTitle() {
			return this.$store.state.leftTitle;
		},


		/*--------------------------
  	Device
  ----------------------------*/

		device: function device() {

			var screen_width = $(window).width();

			return {
				screen_width: screen_width,
				isTouch: 'ontouchstart' in window || navigator.msMaxTouchPoints > 0,
				isMobile: screen_width <= 812,
				isDesktop: screen_width >= 1025,
				tabletUP: screen_width >= 813
			};
		}
	},

	methods: {

		/*---------------------------------------
  	Owner of this picture wall
  ----------------------------------------*/

		checkOwner: function checkOwner() {
			var self = this;
			var found = false;
		},


		/*---------------------------------------
  	Check if articles exists
  ----------------------------------------*/

		ifArticlesExists: function ifArticlesExists() {

			var exists = false;
			var articles = this.$store.state.chosenArticles;

			if (!$.isEmptyObject(articles)) {

				$.each(articles, function (index, value) {
					if (value !== false) exists = true;
				});
			}

			return exists;
		},


		/*---------------------------------------
  	Check if article has campaign
  ----------------------------------------*/

		articleHasCampaign: function articleHasCampaign(product) {

			if (typeof product.campaignBadge != 'undefined' && product.campaignBadge) return true;

			return false;
		},


		/*---------------------------------------
  	Decide width
  ----------------------------------------*/

		pictureWallWidth: function pictureWallWidth() {

			var width = this.device.screen_width;

			if (width > 1400) return false;else if (width <= 1399 && width > 1200) {
				return 1400;
			} else if (width <= 1200 && width > 900) {
				return 1300;
			} else if (width <= 900) {
				return 1201;
			}
		}
	}

};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = {

	methods: {
		clearPictureWall: function clearPictureWall() {

			var self = this;

			// Prompt to save if needed first
			self.promtSave(function () {

				// Tell that no current wall is selected and not updated
				try {
					window.eventHub.$emit('closePickers', 'all');
					self.$store.commit('currentWallID', false);
					self.$store.commit('disablePictureWall', true);
					self.$store.commit('pictureWall', 0);
					self.$store.commit('background', false);
					self.$store.commit('pictureWallColor', {
						key: "white",
						preview: "white",
						border: "1"
					});
					self.$store.commit('currentWallField', false);
					self.$store.commit('articleFilterActive', false);
					self.$store.commit('articleFilter', false);
					self.$store.commit('articleFilterAvailable', false);
					self.$store.commit('chosenArticleFilter', false);
					self.$store.commit('chosenArticles', {});
					self.$store.commit('chosenFrames', {});
					self.$store.commit('updated', false);
					self.$store.commit('disablePictureWall', false);

					console.log("Disable?");
				} catch (e) {
					console.log(e);
				}
			});
		}
	}

};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {

	methods: {

		createImage: function createImage(returnFunction, errorFunction) {

			// Make a snapshop of the picture wall 
			var html2canvas = __webpack_require__(107);

			if ($(window).width() < 960) {
				$("#pictureWall").addClass("2x");
			}

			html2canvas($("#zoomElement"), {
				//scale: 3,
				proxy: 'https://' + window.location.hostname,
				useCORS: true,
				onrendered: function onrendered(canvas) {
					$("#pictureWall").removeClass("2x");
					var formData = new FormData();
					var value = canvas.toDataURL("image/jpeg");
					formData.append('image', value);

					$.ajax({
						url: 'https://desenio-ecommerce.com/pictureWall/image',
						data: formData,
						type: 'POST',
						contentType: false,
						processData: false,
						dataType: 'json',
						success: function success(response) {

							// If everything went OK
							if (response.status) {
								returnFunction(response);
								return true;
							}

							errorFunction(response);
						}
					});
				}
			});
		}

	}

};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = {

	methods: {
		encodeString: function encodeString(string) {

			//var encodedStr = string.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
			// return '&#'+i.charCodeAt(0)+';';
			//});

			var fixedstring = string;

			try {
				// If the string is UTF-8, this will work and not throw an error.
				fixedstring = decodeURIComponent(escape(string));
			} catch (e) {
				// If it isn't, an error will be thrown, and we can asume that we have an ISO string.
				fixedstring = string;
			}

			return fixedstring;
		},

		replaceBadCharacters: function replaceBadCharacters(string) {

			string = replaceAll(string, 'Ã¥', 'å');
			string = replaceAll(string, 'Ã¶', 'ö');
			string = replaceAll(string, 'Ã¤', 'ä');

			return string;
		}
	}

};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = {

	methods: {
		promptError: function promptError(message) {
			var self = this;

			if (typeof message == 'undefined' || !message) {
				message = self.$t('errorMessage');
			}

			window.eventHub.$emit('openModal', {
				modal: 'message',
				data: {
					title: self.$t('errorTitle'),
					message: message,
					confirmTxt: self.$t('close'),
					confirm: true,
					onConfirm: function onConfirm() {
						window.eventHub.$emit('closeModal');
					}
				}
			});
		}
	}

};

/***/ }),
/* 31 */
/***/ (function(module, exports) {



module.exports = {

	methods: {
		trackEvent: function trackEvent(event) {
			if (typeof window.gaSentEvents == 'undefined') window.gaSentEvents = {};

			if (!window.gaSentEvents[event]) {
				ga('send', 'event', 'Picture wall', event);
				ga('clientTracker.send', 'event', 'Picture wall', event);

				var countryCode = window.vueInstance.$t('countryCode').toLowerCase();
				dataLayer.push({
					'event': 'Picture Wall',
					'category': 'Picture Wall',
					'action': event,
					'label': '',
					'value': ''
				});

				var page = "/picture-wall-" + window.replaceAll(event, ' ', '-') + ".html";

				ga('set', 'page', page);
				ga('clientTracker.set', 'page', page);
				ga('send', 'pageview');
				ga('clientTracker.send', 'pageview');
				window.gaSentEvents[event] = true;
			}
		}
	}

};

/***/ }),
/* 32 */
/***/ (function(module, exports) {


module.exports = {

    methods: {
        getFilterOptionsFromField: function getFilterOptionsFromField() {
            console.log(window.vueInstance.$store.state.currentWallField);
            console.log(window.vueInstance.$store.state.currentArticleSorting);
        }
    }

};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = {

  methods: {
    getArticleImage: function getArticleImage(article) {

      var url = false;

      $.each(article.posterImages, function () {

        if (this.posterSizes.includes(article.size)) {
          url = this.URL;
        }
      });

      return window.appSettings.productImageUrl + "/" + url;
    },
    getArticleImageDB: function getArticleImageDB(article) {
      if (typeof article.images != 'undefined') return window.appSettings.productImageUrl + "/" + article.images[0].URL;
    }
  }

};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = {

	methods: {
		closePickers: function closePickers(type) {

			if (type == 'undefined') type == 'all';

			// Change state
			this.$store.commit('currentPicker', "");

			// Tell pickers to reset
			window.eventHub.$emit('clearSearch');
			window.eventHub.$emit('closePickers', type);
		},

		resetPickerData: function resetPickerData() {
			this.$store.commit('currentPicker', '');
			this.$store.commit('leftTitle', '');
		}
	}

};

/***/ }),
/* 35 */
/***/ (function(module, exports) {



module.exports = {

	methods: {
		rememberArticle: function rememberArticle(key, id) {},
		unRememberArticle: function unRememberArticle(key, id) {}
	}

};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = {

	methods: {
		promtSave: function promtSave(returnFunction, customData) {

			var self = this;

			// Force
			var force = false;

			// Standard texts
			var message = self.$t('unsavedChanges');
			var title = self.$t('wantToContinue');

			if (typeof customData != 'undefined' && typeof customData.message != 'undefined') message = customData.message;

			if (typeof customData != 'undefined' && typeof customData.title != 'undefined') title = customData.title;

			if (typeof customData != 'undefined' && typeof customData.checkPictureWall != 'undefined') {
				if (self.$store.state.pictureWall == 0) force = true;
			}

			// If updated, fire promt
			if (self.$store.state.updated && !force) {
				window.eventHub.$emit('openModal', {
					modal: 'message',
					data: {
						title: title,
						messageClass: "longtext",
						message: message,
						confirm: true,
						confirmTxt: self.$t('save'),
						declineTxt: self.$t('dontSave'),
						abortTxt: self.$t('abort'),
						primaryButton: 'confirm',

						// User wants to save, do that instead
						onConfirm: function onConfirm() {
							window.eventHub.$emit('openModal', { modal: 'save' });
						},


						// User does not want to save
						onDecline: function onDecline() {
							window.eventHub.$emit('closeModal');
							returnFunction();
						},
						onAbort: function onAbort() {
							window.eventHub.$emit('closeModal');
						}
					}
				});
			}

			// If not, just continue
			else returnFunction();
		}
	}
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = {

	methods: {
		getSavedData: function getSavedData() {},

		setSavedUrl: function setSavedUrl(id) {}
	}

};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// Get settings

module.exports = {

	methods: {
		getCdn: function getCdn() {
			return window.appSettings.cdnUrl;
		},

		getUrlNoCDN: function getUrlNoCDN() {
			return window.appSettings.getUrl();
		},

		getWGUrl: function getWGUrl() {
			return window.appSettings.getWGUrl();
		}

	}

};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(180);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  loading: {},
  isFetchingArticles: null,
  disablePictureWall: false,
  currentWallID: false,
  currentWallName: "",
  cartNoStock: [],
  updated: false,
  searchQuery: '',
  price: 0,
  pictureWall: 0,
  background: false,
  pictureWallColor: {
    key: "white",
    preview: "white",
    border: "1"
  },
  currentWallField: false,
  currentWallFieldConditions: false,
  currentWallFieldSize: false,

  articleFilterActive: false,
  articleFilter: false,
  articleFilterAvailable: false,
  chosenArticleFilter: [],
  currentArticleSorting: 'all',

  chosenArticles: {},
  chosenFrames: {},

  wallPicture: false,

  leftTitle: "",
  currentPicker: "",

  hideLeftMenu: false,

  savedWallsPickerActive: false,
  highlightPictureWallItems: false,

  currentWallURL: "",

  basketID: false,
  siteBasket: {
    qty: '0',
    sum: '0'
  },

  isOwner: true

};

var mutations = {
  cartNoStock: function cartNoStock(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'cartNoStock', data);
  },
  sendingApiRequest: function sendingApiRequest(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'isFetchingArticles', data);
  },
  updated: function updated(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'updated', data);
  },
  searchQuery: function searchQuery(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'searchQuery', data);
  },
  currentWallID: function currentWallID(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentWallID', data);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'updated', false);
  },
  currentWallName: function currentWallName(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentWallName', data);
  },
  startLoading: function startLoading(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.loading, data, true);
  },
  disablePictureWall: function disablePictureWall(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'disablePictureWall', data);
  },
  stopLoading: function stopLoading(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.loading, data, false);
  },
  resetLoading: function resetLoading(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'loading', {});
  },
  leftPanel: function leftPanel(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'leftPanel', data);
  },
  leftTitle: function leftTitle(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'leftTitle', data);
  },
  currentPicker: function currentPicker(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentPicker', data);
  },
  hideLeftMenu: function hideLeftMenu(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'hideLeftMenu', data);
  },
  articleFilterActive: function articleFilterActive(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'articleFilterActive', data);
  },
  articleFilter: function articleFilter(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'articleFilter', data);
  },
  articleFilterAvailable: function articleFilterAvailable(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'articleFilterAvailable', data);
  },
  toggleChosenArticleFilter: function toggleChosenArticleFilter(state, data) {

    // Get current filters
    var current = state.chosenArticleFilter;

    var found = false;
    var position = false;

    // Create a list of items
    if (current.length) $.each(current, function (index, value) {
      if (value.id == data.id) {
        found = true;
        position = index;
      }
    });

    if (!found) {
      current.push(data);
    } else {
      current.splice(position, 1);
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'chosenArticleFilter', current);
  },
  chosenArticleFilter: function chosenArticleFilter(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'chosenArticleFilter', data);
  },
  currentArticleSorting: function currentArticleSorting(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentArticleSorting', data);
  },
  savedWallsPickerActive: function savedWallsPickerActive(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'savedWallsPickerActive', data);
  },
  pictureWall: function pictureWall(state, data) {

    if (data) if (_typeof(data.articles) == undefined || !data.articles) data.articles = JSON.parse(data.settings);

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'pictureWall', data);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'updated', true);
  },
  wallPicture: function wallPicture(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'wallPicture', data);
  },
  background: function background(state, data) {

    // Set background
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'background', data);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'updated', true);
  },
  pictureWallColor: function pictureWallColor(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'pictureWallColor', data);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'updated', true);
  },
  resetPictureWallColor: function resetPictureWallColor(state, data) {
    var defaultColor = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.extend({}, window.appSettings.defaultBackground);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'pictureWallColor', defaultColor);
  },
  currentWallField: function currentWallField(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentWallField', data);
  },
  currentWallFieldConditions: function currentWallFieldConditions(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentWallFieldConditions', data);
  },
  currentWallFieldSize: function currentWallFieldSize(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentWallFieldSize', data);
  },
  chosenArticles: function chosenArticles(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'chosenArticles', data);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'updated', true);
  },
  chosenFrames: function chosenFrames(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'chosenFrames', data);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'updated', true);
  },
  highlightPictureWallItems: function highlightPictureWallItems(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'highlightPictureWallItems', data);
  },
  currentWallURL: function currentWallURL(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentWallURL', data);
  },
  siteBasket: function siteBasket(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'siteBasket', data);
  },
  basketID: function basketID(state, data) {
    window.vueRender(function () {
      window.vueInstance.$localStorage.set('basketID', data);
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'basketID', data);
  },
  isOwner: function isOwner(state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'isOwner', data);
  },
  initChosenArticles: function initChosenArticles(state, data) {

    // Chosen articles
    var chosenArticles = {};

    $.each(data, function () {
      chosenArticles[this.item] = false;
    });

    // Loop each field and initialize the right keys
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'chosenArticles', chosenArticles);

    // Chosen frames
    var chosenFrames = {};

    // The data here is the current picture wall fields
    $.each(data, function () {
      chosenFrames[this.item] = false;
    });

    // Loop each field and initialize the right keys
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'chosenFrames', chosenFrames);
  },
  resetChosenArticles: function resetChosenArticles(state) {
    state.chosenArticles = {};
  },


  // Set price depending on chosen articles and frames
  calculatePrice: function calculatePrice(state) {

    var self = this;
    var price = 0;

    if (state.pictureWall && state.pictureWall.articles) {

      // Chosen articles
      $.each(state.chosenArticles, function () {

        // If something is chosen
        if (typeof this.id !== "undefined") {
          var currentPrice = parseFloat(this.price);

          price += currentPrice;
        }
      });

      // Chosen frames
      $.each(state.chosenFrames, function (index, value) {

        // If something is chosen
        if (typeof value !== "undefined" && value) {

          // Add to cost
          price += parseFloat(value.price);
        }
      });
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'price', price);

    // Tell that we have a new price
    window.eventHub.$emit('priceUpdated', price);
  },


  // Normal operators
  addPrice: function addPrice(state, data) {
    state.price = state.price + data;
  },
  subtractPrice: function subtractPrice(state, data) {
    state.price = state.price - data;
  },


  // Reset
  resetPrice: function resetPrice(state, data) {
    state.price = 0;
  }
};

var actions = {
  // Test
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Misc_RotateDevice__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Misc_RotateDevice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_Misc_RotateDevice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Misc_SwipeToMinimal__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Misc_SwipeToMinimal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Misc_SwipeToMinimal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Misc_ClickFullscreen__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Misc_ClickFullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Misc_ClickFullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modals_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modals_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Modals_Modal__);
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {

  components: {
    RotateDevice: __WEBPACK_IMPORTED_MODULE_0_components_Misc_RotateDevice___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3_components_Modals_Modal___default.a,
    SwipeToMinimal: __WEBPACK_IMPORTED_MODULE_1_components_Misc_SwipeToMinimal___default.a,
    ClickFullscreen: __WEBPACK_IMPORTED_MODULE_2_components_Misc_ClickFullscreen___default.a
  },

  computed: {},

  data: function data() {
    return {
      fullscreenClick: true,
      platform: false
    };
  },

  mounted: function mounted() {

    var self = this;

    /*------------------------------------------*
      User leave promt
    --------------------------------------------*/
    window.onbeforeunload = function (e) {

      if (!window.localEnviroment && self.$store.state.updated) {
        return "You have unsaved content, do you want to leave?";
      }
    };

    /*------------------------------------------*
      Animations
    --------------------------------------------*/

    // Require animate csss
    __webpack_require__(74);

    /*------------------------------------------*
      Fastclick
    --------------------------------------------*/

    // Activate fastclick js
    var FastClick = __webpack_require__(106);
    FastClick.attach(document.body);

    /*------------------------------------------*
      Mobile screen handling
    --------------------------------------------*/

    // Detect if we have to handle IOS8+
    var platform = __webpack_require__(8);
    self.platform = platform;

    var ua = navigator.userAgent || navigator.vendor || window.opera;
    var isFacebook = ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;

    if (platform.name == 'Safari' && platform.os.family == 'iOS' && parseInt(platform.os.version, 10) >= 8 && !isFacebook) {
      setTimeout(function () {
        // Disable zoom
        document.addEventListener('touchmove', function (event) {
          if (event.scale !== 1) {
            event.preventDefault();
          }
        }, { passive: false }); // Enforce the no-zoom policy on iOS devices.

        var lastTouchEnd = 0;
        document.addEventListener('touchend', function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        }, false);
      }, 0);
    } else if (platform.name == 'Safari' && platform.os.family == 'iOS' && parseInt(platform.os.version, 10) <= 8) {
      window.noAnimations = true;
      $("body").addClass("noAnimations");
    }

    /*------------------------------------------*
      Load cart and set session
    --------------------------------------------*/

    // Check url for cart ID
    var queryStrings = new URLSearchParams(window.location.search);
    var cartID = queryStrings.get('cart');
    var sessionID = this.$localStorage.get('sessionID');

    // 

    if (typeof cartID != 'undefined' && cartID) {
      window.eventHub.$emit('loadBasket', cartID);

      // Use as session ID
      if (!sessionID) this.$localStorage.set('sessionID', cartID);
    }

    // If no cart ID is passed in url, try localStorage
    else if (this.$localStorage.get('basketID')) {
        window.eventHub.$emit('loadBasket', this.$localStorage.get('basketID'));

        // Use as session ID
        if (!sessionID) this.$localStorage.set('sessionID', this.$localStorage.get('basketID'));
      }
      // We do not have a cart ID at all, create a brand new session
      else {
          this.$localStorage.set('sessionID', Math.floor(Math.random() * Date.now()));
        }
  }
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(6);

/* harmony default export */ __webpack_exports__["default"] = {

	data: function data() {
		return {
			loading: false,
			imageUrl: this.getCdn()
		};
	},

	computed: {
		hasPictureWall: function hasPictureWall() {
			return this.$store.state.pictureWall != false;
		},
		hasArticles: function hasArticles() {
			var passed = false;

			if (!jQuery.isEmptyObject(this.$store.state.chosenArticles)) {
				$.each(this.$store.state.chosenArticles, function (index, value) {
					if (value) passed = true;
				});
			}

			return passed;
		},
		articles: function articles() {
			return this.$store.state.chosenArticles;
		},
		active: function active() {
			return this.$store.state.currentPicker == 'basket';
		}
	},

	methods: {
		getArticleUrl: function getArticleUrl(article) {
			return "/shop?funk=visa_artikel&artnr=" + article.parent;
		},
		removeProduct: function removeProduct(index) {
			var articles = this.$store.state.chosenArticles;
			articles[index] = false;
			this.$store.commit('chosenArticles', articles);
			this.checkHighlight();
		},


		close: function close() {
			this.resetPickerData();
			this.$store.commit('highlightPictureWallItems', false);
		},

		checkHighlight: function checkHighlight() {
			if (this.hasPictureWall && !this.hasArticles) this.$store.commit('highlightPictureWallItems', true);
		}
	},

	created: function created() {

		var self = this;

		// When opening the basket
		window.eventHub.$on('openBasket', function () {

			// Close if open to reload data
			self.close();

			// Close other pickers
			self.closePickers('basket');

			// Highlight articles if needed
			self.checkHighlight();

			// Open
			self.$store.commit('currentPicker', 'basket');
			self.$store.commit('leftTitle', self.$t('yourMotifs'));
		});

		// Close picker event also closes basket as it is positioned at the same place
		window.eventHub.$on('closePickers', function (type) {
			if (type != 'basket') {
				self.close();
			}
		});
	}
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(6);

/* harmony default export */ __webpack_exports__["default"] = {

	data: function data() {
		return {
			loading: false,
			active: false,
			height: 'auto',
			unpopulated: false,
			data: {
				sum: '',
				sumText: '',
				sumqty: '',
				sumSuffix: this.$t('currencySuffix'),
				sumPrefix: this.$t('currencyPrefix'),
				leftToFreePostage: ''
			},
			removeLoading: {},
			articles: []
		};
	},

	methods: {
		get: function get() {

			var self = this;

			// Clear
			var articles = [];

			// Get
			window.apiHandler.getSiteCart(function (data) {

				// Set articles
				if (data && typeof data.cart != 'undefined' && typeof data.cart.items != 'undefined' && data.cart.items.length) {
					self.articles = data.cart.items;
					self.data.sum = data.cart.total;

					self.$store.commit('siteBasket', {
						sum: Math.round(data.cart.total * 100) / 100,
						qty: data.cart.quantity
					});
				} else {
					self.articles = [];
					self.data.sum = 0;
					self.$store.commit('siteBasket', {
						sum: '0',
						qty: '0'
					});
				}
			});
		},
		changeQty: function changeQty(article, remove, e) {

			var self = this;

			if (remove) {
				var qty = 0;
				self.$set(this.removeLoading, article.id, true);
			} else {
				var select = $(e.target);
				var qty = select.val();
			}

			// Make update
			window.apiHandler.changeSiteCartQty(

			// Success
			function () {
				self.$set(self.removeLoading, article.id, false);
				self.get();
			},

			// Fail
			function () {
				self.$set(self.removeLoading, article.id, false);
			},

			// Data to end
			{
				qty: qty,
				item: article.combinationID,
				rowIndex: article.rowIndex
			});
		},
		setHeight: function setHeight() {
			// Recalc height
			if (!this.device.isDesktop) {
				this.height = parseInt($("#app").height()) - parseInt($(".rightMenu").height());
			}
		}
	},

	created: function created() {

		var self = this;

		// Swipe down
		$(".page").on('swiperight', function () {
			if (self.active) self.active = false;
		});

		// When opening the basket
		window.eventHub.$on('loadBasket', function (ID) {

			// Set basket ID
			self.$store.commit('basketID', ID);

			// Populate basket
			window.vueRender(function () {
				self.get();
			});
		});

		// When opening the basket
		window.eventHub.$on('toggleSiteBasket', function () {
			self.get();
			self.setHeight();
			self.active = !self.active;
		});

		// When closing the basket
		window.eventHub.$on('closeSiteBasket', function (e) {

			var clickedInsideBasket = $(e.target).parents(".siteBasket").length;
			var clickedIcon = $(e.target).parents(".cartContainer").length;

			if (!clickedInsideBasket && !clickedIcon) {
				self.active = false;
			}
		});

		window.eventHub.$on('openSiteBasket', function () {
			self.get();
			self.setHeight();
			self.active = true;
		});
	}
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      search: "",
      expanded: {}
    };
  },

  watch: {
    // whenever search changes this function will run
    search: function search(newSearch) {
      this.getSearch();
    }
  },

  computed: {
    active: function active() {
      return this.$store.state.articleFilterActive;
    },
    filters: function filters() {
      return this.$store.state.articleFilter;
    },
    chosenFilters: function chosenFilters() {
      return this.$store.state.chosenArticleFilter;
    },
    articleFilterAvailable: function articleFilterAvailable() {
      return this.$store.state.articleFilterAvailable;
    },
    filterIsActive: function filterIsActive() {
      return false;
    }
  },

  methods: {
    getSearch: _.debounce(function () {
      var self = this;
      window.eventHub.$emit("searchUpdated", self.search);
    }, 300 // time
    ),

    getColor: function getColor(color) {

      var style = "";

      switch (color) {
        case 'purple':
          style = "rgb(122, 35, 143)";
          break;
        case 'multi':
          style = "linear-gradient(135deg, rgb(203, 138, 19) 0%, rgb(233, 249, 138) 50%, rgb(118, 187, 184) 100%)";
          break;
        case 'brown':
          style = "rgb(116, 63, 37)";
          break;
        case 'orange':
          style = "rgb(243, 122, 41)";
          break;
        case 'copper':
          style = "linear-gradient(135deg, rgb(142, 68, 50) 0%, rgb(229, 166, 137) 40%, rgb(229, 166, 137) 50%, rgb(229, 166, 137) 60%, rgb(142, 68, 50) 100%)";
          break;

        case 'silver':
          style = "linear-gradient(135deg, rgb(161, 167, 171) 0%, rgb(221, 222, 224) 40%, rgb(221, 222, 224) 50%, rgb(221, 222, 224) 60%, rgb(161, 167, 171) 100%)";
          break;

        case 'beige':
          style = "rgb(232, 212, 193)";
          break;
        case 'gold':
          style = "linear-gradient(135deg, rgb(183, 160, 78) 0%, rgb(246, 220, 153) 40%, rgb(246, 220, 153) 50%, rgb(246, 220, 153) 60%, rgb(183, 160, 78) 100%)";
          break;
        case 'blackAndWhite':
          style = "linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 50%, rgb(255, 255, 255) 50%, rgb(255, 255, 255) 100%)";
          break;
        case 'blue':
          style = "rgb(15, 91, 153)";
          break;
        case 'turquoise':
          style = "rgb(18, 235, 200)";
          break;
        case 'black':
          style = "rgb(0, 0, 0)";
          break;
        case 'green':
          style = "rgb(101, 165, 80)";
          break;
        case 'gray':
          style = "rgb(218, 218, 218)";
          break;
        case 'red':
          style = "rgb(179, 35, 18)";
          break;
        case 'yellow':
          style = "rgb(245, 223, 12)";
          break;
        case 'red':
          style = "rgb(179, 35, 18)";
          break;
        case 'white':
          style = "rgb(255, 255, 255); border: 1px solid #dcd9d9;";
          break;
        case 'pink':
          style = "rgb(252, 196, 200)";
          break;
      }

      return "background: " + style;
    },


    pickFilter: function pickFilter(filterItem) {
      this.$store.commit("toggleChosenArticleFilter", filterItem);
      window.eventHub.$emit("filterUpdated");
    },

    checkActiveItem: function checkActiveItem(id) {
      var found = false;

      if (typeof this.chosenFilters !== "undefined") $.each(this.chosenFilters, function (index, value) {
        if (value.id == id) found = true;
      });

      return found;
    },
    useThisFilter: function useThisFilter(filter) {
      switch (filter.id) {
        case 1:
        case 4:
        case 5:
          return true;
          break;
        default:
          return false;
      }
    },
    close: function close() {
      this.$store.commit("articleFilterActive", false);
    },


    clear: function clear() {
      this.search = "";
      this.$store.commit("chosenArticleFilter", {});
      window.eventHub.$emit("filterUpdated");
    },

    toggleExpand: function toggleExpand(item) {
      if (this.expanded[item.id]) {
        this.$set(this.expanded, item.id, false);
      } else {
        this.$set(this.expanded, item.id, true);
      }
    }
  },

  mounted: function mounted() {
    var self = this;

    // When this is opened
    window.eventHub.$on("toggleArticleFilter", function (data) {
      window.eventHub.$emit("closeRightMenus", "all");
      var newState = !self.active;
      self.$store.commit("articleFilterActive", newState);
    });

    // Close picker event
    window.eventHub.$on("closeArticleFilter", function (type) {
      self.$store.commit("articleFilterActive", false);
    });

    // Close picker event
    window.eventHub.$on("clearSearch", function (type) {
      self.search = "";
    });

    // When remove a single filter
    window.eventHub.$on("removeFilterChoice", function (filterItem) {
      self.pickFilter(filterItem);
    });
  }
};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Lists_ColorList__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Lists_ColorList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_Lists_ColorList__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {

  components: {
    ColorList: __WEBPACK_IMPORTED_MODULE_0_components_Lists_ColorList___default.a
  },

  props: ['listData'],

  data: function data() {
    return {
      imageUrl: window.apiHandler.getUrl()
    };
  },

  computed: {
    currentBackgroundId: function currentBackgroundId() {

      if (this.$store.state.background) return this.$store.state.background.id;

      return -1;
    }
  },

  methods: {
    getThumb: function getThumb(file) {
      return window.appSettings.getResizedImageFromCloud(400, file, 'backgrounds/');
    },


    pickItem: function pickItem(item) {
      this.$store.commit('resetPictureWallColor');
      this.$store.commit('background', item);
      this.trackEvent('background step');
    },

    reset: function reset() {
      this.$store.commit('resetChosenArticles');
    }

  },

  mounted: function mounted() {}

};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      colors: false,
      ready: false
    };
  },

  props: ['backgroundData'],

  computed: {
    currentColor: function currentColor() {
      return this.$store.state.pictureWallColor;
    }
  },

  methods: {

    getColors: function getColors() {

      var self = this;

      // API returns the data after ajax loading
      window.apiHandler['colors'](function (data) {

        // Set data
        self.$set(self, 'colors', data);

        // Set ready
        self.ready = true;
      });
    },

    init: function init() {

      // Initialize slider
      __webpack_require__(5);

      var sliderElement = $("#colorSliderElement");

      sliderElement.slick({
        infinite: false,
        dots: false,
        slidesToShow: 11,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        }]
      });
    },

    pickItem: function pickItem(item) {
      this.$store.commit('pictureWallColor', item);
    },

    backgroundHasColor: function backgroundHasColor(color) {
      if (typeof this.backgroundData.colors[color.key] != 'undefined') return true;

      return false;
    }

  },

  mounted: function mounted() {
    this.getColors();
  }

};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      imageUrl: window.apiHandler.getWGUrl(),
      ids: {}
    };
  },

  props: ['listData'],

  methods: {

    pickItem: function pickItem(item) {

      var self = this;

      // Prompt to save if needed first
      self.promtSave(function () {

        // Start picturewall loading
        self.$store.commit('startLoading', 'pictureWall');

        // Update vuex state to pick pictureWall
        self.$store.commit('pictureWall', item);

        // Reset vuex state price
        self.$store.commit('resetPrice');

        // Init choseable articles
        self.$store.commit('initChosenArticles', self.$store.state.pictureWall.articles);

        // Clear current wall ID
        self.$store.commit('currentWallID', false);

        // Emit event that tells a new picture wall has been selected
        window.eventHub.$emit('newPictureWall', item);

        // Close loading
        self.$store.commit('stopLoading', 'pictureWall');
      }, {
        checkPictureWall: true
      });

      self.trackEvent('picture wall step');
    },

    reset: function reset() {
      this.$store.commit('resetChosenArticles');
    }

  },

  mounted: function mounted() {}

};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

  data: function data() {
    return {
      hidden: true,
      screenfull: false
    };
  },

  methods: {
    fullscreen: function fullscreen() {
      this.screenfull.request();
      this.hidden = true;
    }
  },

  mounted: function mounted() {

    var self = this;

    /*------------------------------------------	*
       Screenfull
     --------------------------------------------*/
    var platform = __webpack_require__(8);
    var screenfull = __webpack_require__(114);
    this.screenfull = screenfull;

    if (screenfull.enabled && self.device.isMobile) {

      self.hidden = false;

      self.screenfull.on("change", function (event) {

        if (self.screenfull.isFullscreen) {
          // Fullscreen has been turned on
        } else {
          self.hidden = false;
        }
      });
    }
  }
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },

  props: ['identifier', 'loading', 'classes', 'inline', 'fadeIn', 'fadeOut'],

  computed: {
    identifierLoading: function identifierLoading() {
      return this.$store.state.loading[this.identifier];
    }
  }

};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      name: "",
      active: false
    };
  },

  methods: {
    setName: function setName(e) {

      var Cookies = __webpack_require__(1);

      if (this.name) {
        Cookies.set('beta_name', this.name, { expires: 999, path: '/' });
        this.active = false;
      } else {
        alert("Var god fyll i ditt namn.");
      }

      e.preventDefault();
      return false;
    }
  },

  mounted: function mounted() {

    var Cookies = __webpack_require__(1);

    var name = Cookies.get('beta_name');

    if (typeof name == 'undefined') {
      this.active = true;
    }
  }
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },

  computed: {
    nextStepText: function nextStepText() {

      if (this.currentPicker == 'frames') {
        return this.$t('done');
      } else if ($(window).width() <= 812) {
        return this.$t('moveOn');
      } else {
        return this.$t('saveAndMoveOn');
      }
    },
    nextStepActive: function nextStepActive() {

      var currentPicker = this.currentPicker;

      switch (currentPicker) {

        case "backgrounds":
          return this.steps.background;
        case "pictureWalls":
          return this.steps.pictureWall;
        case "basket":
        case "articles":
          return true;
        case "frames":
          return true;
        default:
          break;
      }
    },
    currentPickerNumber: function currentPickerNumber() {
      if (this.currentPicker) {

        switch (this.currentPicker) {

          case 'backgrounds':
            return 1;
          case 'pictureWalls':
            return 2;
          case 'basket':case 'articles':
            return 3;
          case 'frames':
            return 4;

        }
      }
    }
  },

  methods: {

    /*------------------------------------------------------------------
       Go to next step
     ------------------------------------------------------------------*/

    goToNext: function goToNext() {

      var self = this;

      self.$store.commit('hideLeftMenu', true);

      // Go to next step depending on current picker
      var currentPicker = self.currentPicker;

      switch (currentPicker) {

        case "backgrounds":
          self.openPicker('pictureWalls');
          break;
        case "pictureWalls":
          self.openBasket();
          break;
        case "basket":
        case "articles":

          // If we should move to frames
          if (self.steps.motifs) {
            self.openFramePicker();
          }
          // If we should move to next article
          else {

              $.each(self.$store.state.chosenArticles, function (index, value) {
                if (value == false) {
                  var position = parseInt(index) - 1;
                  window.eventHub.$emit('clickPictureWallArticle', self.$store.state.pictureWall.articles[position]);
                }
              });
            }
          break;
        case "frames":
          window.eventHub.$emit('closePickers', 'picker');
          break;
        default:
          window.eventHub.$emit('closePickers', 'picker');
          break;

      }

      setTimeout(function () {
        self.$store.commit('hideLeftMenu', false);
      }, 300);
    },


    /*--------------------------------------------------
      Go to previous step
    --------------------------------------------------*/

    goToPrev: function goToPrev() {

      var self = this;

      self.$store.commit('hideLeftMenu', true);

      switch (self.currentPicker) {
        case 'pictureWalls':
          window.eventHub.$emit('openPicker', 'backgrounds');
          break;
        case 'basket':
        case 'articles':
          window.eventHub.$emit('openPicker', 'pictureWalls');
          break;
        case 'frames':
          window.eventHub.$emit('openBasket');
          break;
      }

      setTimeout(function () {
        self.$store.commit('hideLeftMenu', false);
      }, 300);
    },
    openPicker: function openPicker(type) {

      // Open picker
      window.eventHub.$emit('openPicker', type);
    },
    openBasket: function openBasket() {
      window.eventHub.$emit('openBasket');
    },
    openFramePicker: function openFramePicker() {
      window.eventHub.$emit('openFramePicker');
    }
  }

};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      closed: false
    };
  },

  props: ['identifier', 'title', 'text', 'position', 'showOnce', 'clickHide'],

  methods: {
    close: function close() {

      var self = this;

      // Set cookie
      var Cookies = __webpack_require__(1);
      Cookies.set('hide_purchase_now_' + self.identifier, true, { expires: 1, path: '/' });

      // Close
      self.closed = true;
    }
  },

  mounted: function mounted() {

    var self = this;

    var Cookies = __webpack_require__(1);
    var isHidden = Cookies.get('hide_purchase_now_' + self.identifier);

    if (typeof isHidden != 'undefined' && isHidden) self.closed = true;

    // Hide of only should show once
    if (typeof self.showOnce != 'undefined' && self.showOnce) Cookies.set('hide_purchase_now_' + self.identifier, true, { expires: 1, path: '/' });

    var clicked = false;

    if (typeof self.clickHide != 'undefined' && self.clickHide) $(document).on("click", function () {

      if (!clicked) {
        clicked = true;
      } else {
        self.close();
      }
    });
  }
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      identifier: "",
      numAnim: false
    };
  },

  props: ['currencySuffixVersion'],

  computed: {
    price: function price() {
      var price = parseFloat(this.$store.state.price);
      return price;
    }
  },

  methods: {
    parsePrice: function parsePrice(price) {

      if (price % 1 != 0) return price.toFixed(2);else return price.toFixed(0);
    },
    setPrice: function setPrice() {
      var self = this;
      //const CountUp = require('countup.js');
      self.numAnim = new CountUp(this.identifier, 0, self.$store.state.price, 0, 2.5, {
        useEasing: true,
        useGrouping: true,
        separator: ' ',
        decimal: '.'
      });
      self.numAnim.start();
    },
    updatePrice: function updatePrice() {
      if (this.numAnim && typeof this.numAnim.update != 'undefined') this.numAnim.update(this.$store.state.price);
    },
    getID: function getID() {
      var S4 = function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      };
      return "_" + (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }
  },

  mounted: function mounted() {

    var self = this;
    self.identifier = self.getID();
  }
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      active: false
    };
  },

  methods: {},

  mounted: function mounted() {

    // On show

  }
};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

  data: function data() {
    return {
      hidden: false
    };
  },

  mounted: function mounted() {

    var self = this;
    setTimeout(function () {
      if (!window.noAnimations) {
        setInterval(function () {
          self.hidden = true;
          setTimeout(function () {
            self.hidden = false;
          }, 100);
        }, 3500);
      }
    }, 100);
  }
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },

  computed: {
    progress: function progress() {

      // Steps come from mixin checks.js
      var steps = Object.keys(this.steps).length - 1;
      var completed = 0;

      if (this.steps.background) completed++;

      if (this.steps.pictureWall) completed++;

      if (this.steps.motifs) completed++;

      if (this.steps.frames) completed++;

      return completed * 100 / steps;
    }
  }

};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

// DEPRECATED
/* harmony default export */ __webpack_exports__["default"] = {

  data: function data() {
    return {
      hidden: false
    };
  },

  mounted: function mounted() {

    var self = this;
  }
};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      left: 0,
      top: 0,
      maxWidth: 211,
      active: false
    };
  },

  props: ['trigger', 'message', 'identifier'],

  computed: {
    loading: function loading() {
      return this.$store.state.loading[this.identifier];
    }
  },

  methods: {
    show: function show() {

      // Get and set position
      var position = $(this.identifier).offset();

      this.left = position.left + 10;
      this.top = position.top + 25;

      // Active
      this.active = true;
    },
    close: function close() {
      this.active = false;
    }
  },

  mounted: function mounted() {

    var self = this;

    var elementToReactTo = $(self.identifier);

    if (self.trigger == "click") {
      elementToReactTo.on("click", function () {
        self.show();
      });
    }

    if (self.trigger == "hover") {
      elementToReactTo.on("mouseover", function () {
        self.show();
      });
    }
  }
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },

  methods: {},

  mounted: function mounted() {

    var self = this;

    // Redirect after some time
    setTimeout(function () {
      window.eventHub.$emit('closeModal');
      window.location.href = window.appSettings.getUrl() + "/cgi-bin/ibutik/AIR_ibutik.fcgi?funk=bestall_steg1&KCO=Y";
    }, 1500);
  }

};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },

  props: ['messageData'],

  methods: {
    confirm: function confirm() {
      if (typeof this.messageData.onConfirm == 'function') this.messageData.onConfirm();
    },
    decline: function decline() {
      if (typeof this.messageData.onDecline == 'function') this.messageData.onDecline();
    },
    abort: function abort() {
      if (typeof this.messageData.onAbort == 'function') this.messageData.onAbort();
    }
  },

  mounted: function mounted() {}

};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

	computed: {
		stockArticles: function stockArticles() {
			return window.vueInstance.$store.state.cartNoStock;
		}
	},

	methods: {
		watchProduct: function watchProduct(article) {

			window.apiHandler['specificArticles'](function (data) {

				if (data && data.products && typeof data.products[0] != 'undefined') {
					window.open("https://desenio.co.uk/p/" + data.products[0].URL, '_blank').focus();
				}
			}, {
				articles: [article.productID]
			});
		}
	}

};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      name: '',
      saved: false,
      saving: false,
      updating: false,
      newName: "",
      currentName: false
    };
  },

  props: ['listData'],

  computed: {
    price: function price() {
      return this.$store.state.price;
    },
    isOwner: function isOwner() {
      return this.$store.state.isOwner;
    }
  },

  methods: {

    save: function save(e) {

      var self = this;

      // Start loading
      self.$store.commit('startLoading', 'save');

      this.createImage(function (response) {

        // Save and pass data
        window.apiHandler.save(function (data) {

          if (data.status) {

            // If everything was successful
            self.saved = true;
            self.$store.commit('updated', false);

            // Send event
            self.trackEvent('saved a wall');

            // Close after 1 second
            setTimeout(function () {
              window.eventHub.$emit('closeModal');
            }, 900);
          }
          // If error occured
          else {
              alert("An unepected problem occured, please try again later or contact support.");
            }
        }, {
          name: self.name,
          picture: response.filename
        });
      }, function () {

        // Could not save right now
        self.$store.commit('stopLoading', 'save');
      });

      e.preventDefault();
      return false;
    },

    updateSave: function updateSave(e) {

      var self = this;

      // Start loading
      self.$store.commit('startLoading', 'save');

      self.createImage(function (response) {

        // Save and pass data
        window.apiHandler.updateSave(function (data) {

          if (data.status) {

            // If everything was successful
            self.saved = true;
            self.$store.commit('updated', false);

            // Close after 1 second
            setTimeout(function () {
              window.eventHub.$emit('closeModal');
            }, 900);
          }
          // If error occured
          else {
              alert("An unepected problem occured, please try again later or contact support.");
            }
        }, {
          name: $("#updateName").val(),
          picture: response.filename
        });
      });

      e.preventDefault();
      return false;
    },

    showSave: function showSave() {
      this.updating = false;
      this.saving = true;
    },


    buy: function buy() {
      window.apiHandler.buy(function (data) {});
    }

  },

  mounted: function mounted() {

    var self = this;

    // Decide if saving or updating
    if (self.$store.state.currentWallID && self.isOwner) {

      self.updating = true;
      window.vueRender(function () {
        self.currentName = self.$store.state.currentWallName;
        $("#updateName").val(self.$store.state.currentWallName);
      });
    } else {
      this.saving = true;
    }
  }

};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      copied: false
    };
  },

  props: ['messageData'],

  computed: {
    currentWallUrl: function currentWallUrl() {
      var url = window.location.href;
      var arr = url.split("/");
      var domain = arr[0] + "//" + arr[2];
      return domain + this.$store.state.currentWallURL;
    }
  },

  methods: {
    getImage: function getImage() {
      return window.appSettings.imageCloudUrl + this.$store.state.wallPicture;
    },
    getUrl: function getUrl() {
      var url = window.location.href;
      url = url.substring(0, url.indexOf('#')) + "#";
      return url + "?saved_id=" + this.$store.state.currentWallID + "&c_id=" + this.$store.state.pictureWall.configurator_id;
    },
    copyLink: function copyLink() {
      var copyTextField = $("#shareLinkToCopy");
      copyTextField.select();
      document.execCommand('copy');
      this.copied = true;
    },
    share: function share(method) {

      var self = this;
      var link = "";
      var image = self.getImage();

      switch (method) {

        case 'fb':
          link = "https://www.facebook.com/sharer.php?u=" + self.currentWallUrl;
          break;
        case 'instagram':
          link = "https://www.facebook.com/sharer.php?u=" + self.currentWallUrl;
          break;
        case 'pinterest':
          link = "http://pinterest.com/pin/create/button/?url=" + encodeURI(self.currentWallUrl);+"&media=" + encodeURI(image);
          break;
        case 'twitter':
          link = "http://twitter.com/share?=" + self.currentWallUrl + "&hashtags=desenio";
          break;
        case 'email':
          link = "mailto:?body=" + self.currentWallUrl;
          break;

      }

      window.open(link, '_blank');
    }
  },

  mounted: function mounted() {}

};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Modals_Content_AddedToCart__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Modals_Content_AddedToCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_Modals_Content_AddedToCart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modals_Content_Save__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modals_Content_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Modals_Content_Save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Modals_Content_Message__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Modals_Content_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Modals_Content_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modals_Content_Share__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modals_Content_Share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Modals_Content_Share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Modals_Content_NoStock__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Modals_Content_NoStock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Modals_Content_NoStock__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {

  components: {
    ModalAddedToCart: __WEBPACK_IMPORTED_MODULE_0_components_Modals_Content_AddedToCart___default.a,
    ModalSave: __WEBPACK_IMPORTED_MODULE_1_components_Modals_Content_Save___default.a,
    ModalMessage: __WEBPACK_IMPORTED_MODULE_2_components_Modals_Content_Message___default.a,
    ModalShare: __WEBPACK_IMPORTED_MODULE_3_components_Modals_Content_Share___default.a,
    ModalNoStock: __WEBPACK_IMPORTED_MODULE_4_components_Modals_Content_NoStock___default.a
  },

  data: function data() {
    return {
      currentModal: false,
      active: false,
      heigth: "auto",
      modalData: ""
    };
  },

  methods: {

    open: function open(data) {

      var self = this;

      this.currentModal = data.modal;

      if (data.heigth) {
        this.heigth = data.heigth;
      }

      if (data.data) {
        this.modalData = data.data;
      }

      this.active = true;

      // Set dynamic height
      window.vueRender(function () {

        $("#modalContent img").bind("onload", function () {
          self.setHeight();
        });

        self.setHeight();
      });
    },

    setHeight: function setHeight() {
      if ($(window).width() > 812) {
        var modalContent = $("#modalContent");
        var height = modalContent.innerHeight() + 100;
        var marginTop = $(window).height() / 2 - height / 2;
        modalContent.css("margin-top", marginTop);
      }
    },


    reset: function reset() {
      this.heigth = "auto";
      this.active = false;
    },

    close: function close() {
      this.active = false;
      $("#brim-treadmill").show();
    }

  },

  mounted: function mounted() {

    var self = this;

    window.eventHub.$on('openModal', function (data) {
      self.reset();
      self.open(data);
    });

    window.eventHub.$on('closeModal', function (data) {
      self.reset();
      self.close();
    });
  }

};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _computed;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(6);

/* harmony default export */ __webpack_exports__["default"] = {

	data: function data() {
		return {
			loading: false,
			active: false,
			articles: false,
			lazyDone: false,
			stopLazy: false,
			lazyLoading: false,
			savedArticlesFetched: false,
			offset: 0,
			page: 1,
			limit: 30,
			savedArticles: {},
			sortingActive: false,
			lastConditions: false,
			imageUrl: this.getCdn(),
			noArticles: false,
			search: "",
			filter: {}
		};
	},

	computed: (_computed = {
		filterActive: function filterActive() {
			return this.$store.state.articleFilterActive;
		},
		currentSize: function currentSize() {
			return this.$store.state.currentWallFieldSize;
		},
		currentConditions: function currentConditions() {
			return this.$store.state.currentWallFieldConditions;
		}
	}, _defineProperty(_computed, "filterActive", function filterActive() {
		return this.$store.state.articleFilterActive;
	}), _defineProperty(_computed, "filterAvailable", function filterAvailable() {
		return this.$store.state.articleFilter != false;
	}), _defineProperty(_computed, "chosenFilters", function chosenFilters() {
		return this.$store.state.chosenArticleFilter;
	}), _defineProperty(_computed, "currentArticleSorting", function currentArticleSorting() {
		return this.$store.state.currentArticleSorting;
	}), _computed),

	methods: {

		getWGArticles: function getWGArticles(returnFunction, options) {

			var self = this;

			self.noArticles = false;

			// If options
			if (typeof options != 'undefined') {

				// Reset offset
				if (options.resetOffset) self.page = 1;

				// Show loading cover
				if (options.loading) self.loading = true;
			}

			window.apiHandler['articlesWGR'](function (data) {

				// Reset lazydone
				if (!options.dontResetLazyDone) self.lazyDone = false;

				// Emit event that tells that articles are loaded
				window.eventHub.$emit('loadedArticles');

				// Return function
				returnFunction(data);

				// Stop lazyblocker and loading
				self.stopLazy = false;
				self.loading = false;

				// Wait some time before we are showing the no articles text
				// It will also only show if there actually are no articles
				setTimeout(function () {
					self.noArticles = true;
				}, 400);
			}, {
				page: self.page
			});
		},

		filterOutUnwantedArticles: function filterOutUnwantedArticles(item) {

			// Needs to be a poster
			if (item.systemCode != 'poster') return false;

			// Extra check, no poster packs 
			if (item.articleNumber.indexOf('SET') != -1) return false;

			return true;
		},
		save: function save(id, e) {
			this.rememberArticle('favorites', id);
			this.getSavedArticles();
			e.stopPropagation();
		},
		unSave: function unSave(id, e) {
			this.unRememberArticle('favorites', id);
			this.getSavedArticles();
			e.stopPropagation();
		},


		getSearch: function getSearch() {

			var self = this;

			// Get articles
			self.getWGArticles(function (data) {

				if (!_.isEmpty(data.products)) {

					if (data.products.items.length < self.limit) {
						self.lazyDone = true;
					}

					self.$set(self, 'articles', data.products.items);
				} else {
					self.$set(self, 'articles', false);
					self.lazyDone = false;
				}
			}, {
				resetOffset: true,
				loading: true
			});
		},

		checkLazy: function checkLazy(e) {

			var self = this;

			var container = $(e.target);

			var scrollTop = container.scrollTop(); // Current scroll position
			var innerHeight = container.innerHeight(); // Inner height of the element
			var scrollHeight = container[0].scrollHeight; // Height of the content of the element
			var offset = 650; // The offset we want to use

			var currentScroll = scrollTop + (innerHeight + offset);

			if (currentScroll >= scrollHeight) {

				if (!this.stopLazy && !self.lazyDone) {
					this.lazyload();
				}
			}
		},

		lazyload: function lazyload(data) {

			var self = this;

			if (!self.lazyLoading) {

				// Flag lazyloading ongoing
				self.lazyLoading = true;

				// Disable lazy if we have no articles at all
				if (typeof self.articles == 'undefined') {
					self.lazyDone = true;
					return false;
				}

				// Make sure we fetch the next page
				self.page++;

				// Get articles
				self.getWGArticles(function (data) {

					var articleArray = self.articles;

					// If there are articles
					if (typeof data.products != 'undefined' && data.products.items && !_.isEmpty(data.products.items)) {

						// Populate article list with new items
						articleArray.push.apply(articleArray, data.products.items);
					}
					// If not stop lazy
					else {
							self.lazyDone = true;
						}

					self.lazyLoading = false;
				}, {
					setFilter: false,
					dontResetLazyDone: true,
					page: self.page
				});
			}
		},

		pickItem: function pickItem(item) {

			var currentWallField = this.$store.state.currentWallField;
			var chosenArticles = this.$store.state.chosenArticles;
			var self = this;

			window.apiHandler['specificArticles'](function (data) {

				if (data && data.products && typeof data.products[0] != 'undefined') {
					$.each(data.products[0].combinations, function (index, value) {

						if (value.size == self.currentSize) {

							value.posterImages = data.products[0].posterImages;

							chosenArticles[currentWallField] = value;
							self.rememberArticle('chosen', item.productID);
							self.$store.commit('chosenArticles', chosenArticles);
							self.$store.commit('calculatePrice');
							self.trackEvent('article step');
						}
					});
				}
			}, {
				articles: [item.id]
			});
		},

		toggleFilter: function toggleFilter() {
			window.eventHub.$emit('toggleArticleFilter');
		},

		scrollUp: function scrollUp() {
			$("#articleScroller").scrollTop(0);
		},

		close: function close(resetWallfield) {
			this.active = false;
			this.articles = false;
			this.lazyDone = false;
			this.stopLazy = false;
			this.lazyLoading = false;
			this.lastSize = false;
			this.lastFormat = false;
			this.resetPickerData();

			if (resetWallfield) this.$store.commit('currentWallField', false);

			// Clear filter
			this.$store.commit('chosenArticleFilter', []);

			this.scrollUp();

			window.eventHub.$emit('closeArticleFilter');
		},

		getImage: function getImage(item) {

			var image = false;

			if (typeof item.images[0] != 'undefined' && item.images[0].URL) return window.appSettings.productImageUrl + "/" + item.images[0].URL;
		},
		removeFilterChoice: function removeFilterChoice(filterChoice) {
			window.eventHub.$emit('removeFilterChoice', filterChoice);
		},
		getSavedArticles: function getSavedArticles() {

			var saved = this.$localStorage.get('rememberArticles_favorites', false);
			var savedRelative = {};

			if (saved) {
				$.each(saved.split(","), function (index, value) {
					savedRelative[value] = true;
				});
			}

			this.$set(this, 'savedArticles', savedRelative);
			this.$set(this, 'savedArticlesFetched', true);
		},
		setSort: function setSort(sorting) {
			this.$store.commit('currentArticleSorting', sorting);
			this.sortingActive = false;

			if (this.filterActive) {
				this.toggleFilter();
			}
		}
	},

	created: function created() {

		this.savedArticlesFetched = false;
		var self = this;

		// When user clicked pictureWall
		window.eventHub.$on('clickedPictureWallItem', function () {
			if (self.currentPicker != 'frames') {
				window.eventHub.$emit('openArticlePicker');
			}
		});

		// When opening the picker
		window.eventHub.$on('openArticlePicker', function () {

			// Should open test
			var shouldOpen = true;

			// If picker is already active, we shall check if the conditions has changed or not
			if (self.active) if (self.lastConditions && self.lastConditions == self.currentConditions) {
				shouldOpen = false;
			}

			if (shouldOpen) {

				// Set size
				self.lastConditions = self.currentConditions;

				// Close if open to reload data
				self.close(false);

				// Activate picker
				self.active = true;

				// Close
				self.closePickers('articlePicker');

				// Open
				self.$store.commit('currentPicker', 'articles');
				self.$store.commit('leftTitle', self.$t('yourMotifs'));

				// Get articles
				self.getWGArticles(function (data) {

					if (!_.isEmpty(data.products)) {

						if (data.products.items.length < self.limit) {
							self.lazyDone = true;
						}

						self.$set(self, 'articles', data.products.items);
					} else {
						self.$set(self, 'articles', false);
						self.lazyDone = false;
					}
				}, {
					resetOffset: true,
					loading: true
				});
			}
			// If we should not open, make a flash instead
			else {

					self.loading = true;

					setTimeout(function () {
						self.loading = false;
					}, 200);
				}
		});

		// When a new filter option has been selected
		window.eventHub.$on('filterUpdated', function () {

			self.getWGArticles(function (data) {

				if (!_.isEmpty(data.products)) {

					if (data.products.items.length < self.limit) {
						self.lazyDone = true;
					}

					self.$set(self, 'articles', data.products.items);
				} else {
					self.$set(self, 'articles', false);
					self.lazyDone = false;
				}
			}, {
				resetOffset: true,
				loading: true
			});
		});

		// Search updated event
		window.eventHub.$on('searchUpdated', function (searchQuery) {
			self.search = searchQuery;
			self.$store.commit('searchQuery', searchQuery);
			self.getSearch();
		});

		// Close picker event
		window.eventHub.$on('closePickers', function (type) {
			if (type != 'articlePicker') self.close(true);
		});

		if (typeof window.bindedSortingClose == 'undefined') {
			$(document).on("click", function (e) {

				var clickedInsideSorting = $(e.target).parents(".sortButton").length;
				var clickedSortingButton = $(e.target).hasClass("sortButton");

				if (!clickedInsideSorting && !clickedSortingButton) {
					self.sortingActive = false;
				}
			});

			window.bindedSortingClose = true;
		}
	}
};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

	data: function data() {
		return {
			active: false,
			frames: false,
			currentField: 0,
			slidersInit: false,
			centerScroller: false,
			heightTries: 0,
			several: true,
			wgURL: window.appSettings.wgURL
		};
	},

	props: ['listData'],

	computed: {
		articles: function articles() {
			// Get data
			var currentWall = this.$store.state.pictureWall;

			// Check if article data exists
			if (_typeof(this.$store.state.pictureWall.articles) != undefined && this.$store.state.pictureWall.articles) {

				// Parse JSON
				return this.$store.state.pictureWall.articles;
			}

			// Return if empty
			return [];
		},
		chosenArticles: function chosenArticles() {
			return this.$store.state.chosenArticles;
		},
		loading: function loading() {
			return this.$store.state.loading.framesPicker;
		}
	},

	methods: {
		get: function get() {

			var self = this;

			self.currentField = 0;
			self.$store.commit('startLoading', 'framesPicker');

			// API returns the data after ajax loading
			window.apiHandler.frameswG(function (data) {

				// Set data
				self.$set(self, 'frames', data);

				// Init sliders
				window.vueRender(function () {
					self.initSliders();
				});

				// Stop loading
				self.$store.commit('stopLoading', 'framesPicker');
			});
		},


		initSliders: function initSliders() {
			var self = this;

			// Import plugins
			__webpack_require__(5);
			__webpack_require__(109);

			// The element that will be used for our centerScroller
			self.centerScroller = $("#frameArticleSlider");

			if (self.centerScroller.hasClass("slick-initialized")) {
				self.centerScroller.slick('unslick');
				self.centerScroller.unbind();
			}

			var slidesToShow = 3;
			self.several = true;

			if (Object.keys(self.chosenArticles).length == 2) {
				slidesToShow = 1;
				self.several = false;
			}

			self.centerScroller.slick({

				arrows: true,
				centerMode: true,
				centerPadding: '9px',
				slidesToShow: slidesToShow,
				responsive: [{
					breakpoint: 1532,
					settings: {
						centerPadding: '7px'
					}
				}, {
					breakpoint: 1332,
					settings: {
						centerMode: false,
						slidesToShow: 1
					}
				}]
			});

			// Add change slide on click functionality
			self.centerScroller.on("click", '.slick-slide', function () {
				self.pickCenterSlider($(this).attr("data-slick-index"));
			});

			// Keep track of change
			self.centerScroller.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				self.currentField = nextSlide;
			});

			// Check height
			self.setHeightScroller();
		},

		setHeightScroller: function setHeightScroller() {

			var self = this;

			var highestSlide = 0;
			$("#frameArticleSlider").find(".slick-slide").each(function () {
				var height = $(this).height();

				if (height > highestSlide) highestSlide = height;
			});

			if (highestSlide < 50 && self.heightTries < 150) {
				setTimeout(function () {
					self.heightTries = self.heightTries + 1;
					self.setHeightScroller();
				}, 100);
			} else {
				$("#frameArticleSlider").height(parseInt(highestSlide) * 1.2);
			}
		},
		pickCenterSlider: function pickCenterSlider(index) {
			this.centerScroller.slick('slickGoTo', index);
		},


		pickFrame: function pickFrame(name, frame) {

			var self = this;

			var fieldsToPick = [];
			var chosenFrames = self.$store.state.chosenFrames;

			// If all
			if (self.currentField == 0) {
				$.each(self.articles, function (index, value) {
					fieldsToPick.push(index + 1);
				});
			}
			// If only specific
			else {
					fieldsToPick.push(self.currentField);
				}

			$.each(fieldsToPick, function (index, value) {

				// Get size for this particular field
				var size = self.$store.state.pictureWall.articles[index].size;

				chosenFrames[value] = self.frames.framesPerSize[size][name];

				self.$store.commit('chosenFrames', chosenFrames);
			});

			// Update price
			this.$store.commit('calculatePrice');

			this.trackEvent('frame step');
		},

		deleteFrames: function deleteFrames(frame) {

			var self = this;

			var fieldsToPick = [];
			var chosenFrames = self.$store.state.chosenFrames;

			// If all
			if (self.currentField == 0) {
				$.each(self.articles, function (index, value) {
					fieldsToPick.push(index + 1);
				});
			}
			// If only specific
			else {
					fieldsToPick.push(self.currentField);
				}

			$.each(fieldsToPick, function () {
				chosenFrames[this] = false;
				self.$store.commit('chosenFrames', chosenFrames);
			});

			// Update price
			this.$store.commit('calculatePrice');
		},

		getFrameField: function getFrameField(index) {

			return true;
		},

		getArticleFieldID: function getArticleFieldID(itemNumber) {
			return itemNumber;
		},

		close: function close() {
			this.active = false;
			this.$store.commit('leftTitle', '');
		}

	},

	created: function created() {

		var self = this;

		// When user clicked pictureWall
		window.eventHub.$on('clickedPictureWallItem', function () {

			if (self.currentPicker == 'frames') {
				var currentWallField = self.$store.state.currentWallField;
				self.pickCenterSlider(currentWallField);
			}
		});

		// When we want to open frame picker
		window.eventHub.$on('openFramePicker', function () {

			if (!self.active) {
				self.closePickers('framePicker');
				self.active = true;
				self.$store.commit('currentPicker', 'frames');
				self.$store.commit('leftTitle', self.$i18n.t("frames"));
				self.get();
			} else self.close();
		});

		// Close picker event
		window.eventHub.$on('closePickers', function (type) {
			if (type != 'framePicker') self.close();
		});
	}
};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Lists_PicturewallList__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Lists_PicturewallList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_Lists_PicturewallList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Lists_BackgroundList__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Lists_BackgroundList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Lists_BackgroundList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {

  components: {
    PictureWallList: __WEBPACK_IMPORTED_MODULE_0_components_Lists_PicturewallList___default.a,
    BackgroundList: __WEBPACK_IMPORTED_MODULE_1_components_Lists_BackgroundList___default.a
  },

  data: function data() {
    return {
      active: false,
      data: false,
      showList: false,
      error: false
    };
  },

  computed: {
    type: function type() {
      return this.$store.state.currentPicker;
    }
  },

  methods: {

    get: function get() {

      var self = this;

      // Start loading
      self.$store.commit('startLoading', 'picker');

      // Get data from API if exists
      if (window.apiHandler[self.type]) {

        // API returns the data after ajax loading
        window.apiHandler[self.type](function (data) {

          // Set data
          self.$set(self, 'data', data);

          // Stop loading
          self.$store.commit('stopLoading', 'picker');

          // Activate picker
          self.$set(self, 'active', true);
          self.$set(self, 'showList', true);
        });
      }
      // Function does not exist in API
      else {
          self.$set(self, 'error', true);
        }
    },

    close: function close() {
      this.$set(this, 'active', false);
      this.$set(this, 'showList', false);
      this.resetPickerData();
    },

    pickedItem: function pickedItem(pickData) {
      this.$emit('pick', pickData);
    }

  },

  created: function created() {
    var self = this;

    // When this picker is opened
    window.eventHub.$on('openPicker', function (data) {

      var type = data.toString();

      // Close if already open
      if (self.active && self.type == type && type != 'articles') {
        self.close();
        return true;
      }

      // Else just close current
      self.close();

      // Wait until vue has rendered
      window.vueRender(function () {

        self.closePickers('picker');
        self.$store.commit('currentPicker', type);
        self.$store.commit('leftTitle', self.$t(type));
        self.get();
      });
    });

    // Close picker event
    window.eventHub.$on('closePickers', function (type) {
      if (type != 'picker') self.close();
    });
  }

};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

	data: function data() {
		return {
			loading: false,
			savedWalls: false,
			frames: frames,
			itemsInRow: 0,
			imageUrl: window.appSettings.imageCloudUrl + "/c_fill,h_119,w_265",
			filter: {}
		};
	},

	computed: {
		active: function active() {
			return this.$store.state.savedWallsPickerActive;
		},


		currentPictureWallArticles: function currentPictureWallArticles() {
			return JSON.parse(this.$store.state.pictureWall.articles);
		}

	},

	methods: {

		get: function get(returnFunction) {

			var self = this;
			var walls = [];

			window.apiHandler.getSavedWalls(function (data) {

				if (data && data.length) {

					$.each(data, function (index, wall) {
						wall.settings = JSON.parse(wall.settings);
						walls.push(wall);
					});

					self.savedWalls = walls;
				} else self.savedWalls = [];

				self.initSlider();

				if (typeof returnFunction != 'undefined') returnFunction();
			});
		},

		initSlider: function initSlider() {

			var savedWallsScroller = $("#savedWallsScroller");

			// Require slider
			__webpack_require__(5);

			var self = this;

			// Define slide lengths
			var largeDesktopItems = 6;
			var desktopItems = 5;
			var tabletItems = 4;
			var mobileItems = 3;

			// Tell components which one we use
			var screenWidth = $(window).width();
			if (screenWidth <= 813) self.itemsInRow = mobileItems;
			if (screenWidth > 813 && screenWidth <= 1024) self.itemsInRow = tabletItems;
			if (screenWidth > 1204) self.itemsInRow = desktopItems;
			if (screenWidth > 1500) self.itemsInRow = largeDesktopItems;

			window.vueRender(function () {
				$("#savedWallsScroller").slick({
					infinite: false,
					arrows: true,
					dots: false,
					slidesToShow: largeDesktopItems,
					slidesToScroll: largeDesktopItems,
					responsive: [{
						breakpoint: 1600,
						settings: {
							slidesToShow: desktopItems,
							slidesToScroll: desktopItems
						}
					}, {
						breakpoint: 1025,
						settings: {
							slidesToShow: tabletItems,
							slidesToScroll: tabletItems
						}
					}, {
						breakpoint: 813,
						settings: {
							slidesToShow: mobileItems,
							slidesToScroll: mobileItems
						}
					}]
				}).slick('refresh');
			});
		},

		pickItem: function pickItem(item) {

			var self = this;

			// Prompt to save if needed first
			self.promtSave(function () {

				// Start loading
				self.$store.commit('startLoading', 'pickWall' + item.id);

				// Hide left menus
				window.eventHub.$emit('closePickers');

				if (!item.id) {
					self.promptError();
					self.$store.commit('stopLoading', 'pickWall' + item.id);
					return false;
				}

				// Pick background
				self.$store.commit('resetPictureWallColor');
				self.$store.commit('background', item.settings.background);

				// And color
				self.$store.commit('pictureWallColor', item.settings.pictureWallColor);

				// Create pictureWall object
				var pictureWallObject = {
					articles: item.settings.articles,
					name: item.settings.name,
					image: item.settings.picture
				};

				self.$store.commit('pictureWall', pictureWallObject);

				// Init choseable articles
				self.$store.commit('initChosenArticles', pictureWallObject.articles);

				// Get article data from API
				var idsToFetchFromAPi = item.settings.skus.concat(item.settings.frames);

				window.apiHandler.specificArticles(function (data) {

					// Create picked article array
					var chosenArticles = {};
					var chosenFrames = {};
					$.each(pictureWallObject.articles, function (index, pictureWallField) {

						var id = index + 1;
						var currentSize = pictureWallField.size;

						// If we have an article
						if (typeof item.settings.skus[index] != 'undefined') {
							var idToSearchFor = item.settings.skus[index];

							$.each(data.products, function (index, product) {
								if (product.id == idToSearchFor) {
									$.each(product.combinations, function (index, combination) {
										if (combination.size == currentSize) {
											combination.posterImages = product.posterImages;
											chosenArticles[id] = combination;
										}
									});
								}
							});
						}
						// If we have no article
						else chosenArticles[id] = false;

						// Frames
						if (typeof item.settings.frames[index] != 'undefined') {

							var idToSearchFor = item.settings.frames[index];
							$.each(data.products, function (index, product) {
								if (product.id == idToSearchFor) {
									chosenFrames[id] = product;
								}
							});
						} else chosenFrames[id] = false;
					});

					self.$store.commit('chosenArticles', chosenArticles);

					// Calculate price
					setTimeout(function () {

						self.$store.commit('chosenFrames', chosenFrames);

						// Calculate price
						setTimeout(function () {
							self.$store.commit('calculatePrice');
						}, 5);

						// Save current wall save ID and tell no changed has been made
						self.$store.commit('currentWallID', {
							id: item.id,
							identifier: item.identifier
						});
						self.$store.commit('currentWallName', item.settings.name);
						self.$store.commit('wallPicture', item.settings.picture);
						self.$store.commit('updated', false);
						self.setSavedUrl(item.id);
						self.$store.commit('stopLoading', 'pickWall' + item.id);

						// Emit event that tells a new picture wall has been selected
						window.eventHub.$emit('newPictureWall', pictureWallObject);
					}, 20);
				}, {
					articles: idsToFetchFromAPi
				});
			});

			self.trackEvent('picked saved wall');
		},

		deleteItem: function deleteItem(item, event, index) {

			var self = this;

			window.eventHub.$emit('openModal', {
				modal: 'message',
				data: {
					title: self.$t('removeTitle'),
					messageClass: "longtext",
					message: self.$t('removePromt'),
					confirm: true,
					confirmTxt: self.$t('remove'),
					declineTxt: self.$t('close'),
					primaryButton: 'decline',
					onConfirm: function onConfirm() {

						window.apiHandler.removeSave(function (data) {

							if (data.status) {
								var slickIndex = $(event.target).parents(".item").attr("data-slick-index");
								$("#savedWallsScroller").slick('slickRemove', slickIndex).slick('refresh');
								window.eventHub.$emit('closeModal');

								return true;
							}

							// Tell error if failed
							self.promptError(self.$t("couldNotRemove"));
						}, {
							id: item.saved_id
						});
					},
					onDecline: function onDecline() {
						window.eventHub.$emit('closeModal');
					}
				}
			});

			event.stopPropagation();
		},

		getFrame: function getFrame(id) {
			var self = this;

			var frame = false;

			$.each(this.frames, function () {
				if (this.id == id) frame = this;
			});

			return frame;
		},

		getImage: function getImage(item) {
			return this.imageUrl + item.settings.picture;
		},

		open: function open() {
			this.$store.commit('savedWallsPickerActive', true);
			this.get();
		},

		close: function close() {
			__webpack_require__(5);
			$("#savedWallsScroller").slick('unslick');
			this.$store.commit('savedWallsPickerActive', false);
			this.savedWalls = false;
		},

		getArticleFieldID: function getArticleFieldID(itemNumber) {
			var index = itemNumber - 1;
			return this.$store.state.pictureWall.fields[index].field_id;
		}

	},

	created: function created() {

		var self = this;

		window.eventHub.$on('toggleSavedWalls', function () {

			window.eventHub.$emit('closeArticleFilter');
			window.eventHub.$emit('closeRightMenus', 'savedWalls');

			// Close if open to reload data
			if (self.active === true) self.close();else self.open();
		});

		window.eventHub.$on('refreshSavedWalls', function () {
			if (self.active === true) self.open();
		});

		// Close picker event
		window.eventHub.$on('closeRightMenus', function (type) {
			if (type != 'savedWalls') self.close();
		});

		// When we are picking a saved wall with events
		window.eventHub.$on('pickSavedWall', function (item) {

			self.get(function () {
				$.each(self.savedWalls, function (index, wall) {

					if (wall.id == item.id) self.pickItem(wall);
				});
			});
		});
	}
};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_PictureWall_Welcome__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_PictureWall_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_PictureWall_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Misc_NotificationTooltip__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Misc_NotificationTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Misc_NotificationTooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {

  components: {
    Welcome: __WEBPACK_IMPORTED_MODULE_0_components_PictureWall_Welcome___default.a,
    NotificationTooltip: __WEBPACK_IMPORTED_MODULE_1_components_Misc_NotificationTooltip___default.a
  },

  data: function data() {
    return {
      panZoomActive: false,
      hideImage: false,
      activeBG: '/backgrounds/10-blue.jpg',
      activeOverlay: false,
      imageUrl: this.getWGUrl(),
      pictureWallActive: true
    };
  },

  computed: {
    showWelcome: function showWelcome() {

      var show = true;

      $.each(this.steps, function (index, value) {
        if (value) show = false;
      });

      return show;
    },
    highlightPictureWallItems: function highlightPictureWallItems() {
      return this.$store.state.highlightPictureWallItems;
    },
    currentPictureWall: function currentPictureWall() {

      var self = this;

      // Get data
      var currentWall = self.$store.state.pictureWall;

      // Return
      return currentWall;
    },


    // Background
    background: function background() {

      var self = this;
      var background = self.$store.state.background;
      var color = self.$store.state.pictureWallColor;

      // Handle background image
      if (typeof background.colors != 'undefined' && background) {
        // Get urls
        // Check required width
        var requiredWidth = self.pictureWallWidth();
        var image = background.colors[color.key];

        if (!requiredWidth) var url = self.imageUrl + "/backgrounds/" + image;

        // If transformed image use cloudinary to get correct size
        else var url = window.appSettings.getResizedImageFromCloud(requiredWidth, image, 'backgrounds/');

        if (self.currentPicker == 'backgrounds') self.$store.commit('startLoading', 'mainPictureWall');

        // Preload image before changing
        var image = new Image();
        image.onload = function () {
          self.activeBG = url;
          self.$store.commit('stopLoading', 'mainPictureWall');
        };
        image.src = url;

        // Handle overlay
        overlay = false;
        if (background.id == 10) {

          var fileName = background.id + "-overlay.png";

          if (!requiredWidth) var overlay = self.imageUrl + "/backgrounds/" + fileName;

          // If transformed image use cloudinary to get correct size
          else var overlay = window.appSettings.getResizedImageFromCloud(requiredWidth, fileName, 'backgrounds/');
        }

        self.activeOverlay = overlay;

        // Remove loading failsafe
        setTimeout(function () {
          self.$store.commit('stopLoading', 'mainPictureWall');
        }, 3000);

        return url;
      }

      self.activeBG = self.imageUrl + '/backgrounds/10-blue.jpg';

      if (typeof self.$store.state.pictureWall.articles != 'undefined') {
        self.activeOverlay = self.imageUrl + '/backgrounds/10-overlay.png';
      }

      return false;
    },


    // Decide left position depending on background
    leftWallPosition: function leftWallPosition() {

      var background = this.$store.state.background;
      var left = 0;

      if (background && background.id) {

        if (background.id == "6") {

          var screen = $(window).width();

          // Mobile
          if (screen <= 780) {
            left = "-26%";
          }

          // Desktop
          else {
              left = "-16%";
            }
        }

        if (background.id == "7") {
          left = "-9%";
        }
      }

      return left;
    },
    currentPictureWallField: function currentPictureWallField() {
      return this.$store.state.currentWallField;
    },
    chosenArticles: function chosenArticles() {
      return this.$store.state.chosenArticles;
    },
    chosenFrames: function chosenFrames() {
      return this.$store.state.chosenFrames;
    },
    pictureWallColor: function pictureWallColor() {
      return this.$store.state.pictureWallColor;
    }
  },

  methods: {
    closeTopPickers: function closeTopPickers() {
      window.eventHub.$emit('closeRightMenus', 'all');
    },
    initZoom: function initZoom() {

      var panzoom = __webpack_require__(110);

      var zoomElement = $("#zoomElement");

      if (this.panZoomActive) {
        zoomElement.panzoom("destroy");
      }

      zoomElement.panzoom({
        contain: 'invert',
        cursor: "default",
        maxScale: 1,
        minScale: 1
      });

      zoomElement.parent().on('mousewheel.focal', function (e) {
        e.preventDefault();
        var delta = e.delta || e.originalEvent.wheelDelta;
        var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
        zoomElement.panzoom('zoom', zoomOut, {
          increment: 0.1
          //focal: { clientX: e.clientX, clientY: e.clientY }
        });
      });

      this.panZoomActive = true;
    },


    initDrag: function initDrag() {

      var self = this;
      var interact = __webpack_require__(108);

      // Unset any current interacts
      interact('#draggableContainer').unset();
      $("#draggableContainer .item").unbind();

      // Remove any transforms
      $("#draggableContainer").css({ transform: "translate(0px, 0px)" });

      // target elements with the "draggable" class
      window.vueRender(function () {
        interact('#draggableContainer').draggable({

          // enable inertial throwing
          inertia: true,

          // keep the element within the area of it's parent
          restrict: {
            restriction: "parent",
            endOnly: true,
            //elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            elementRect: { top: 0.10, left: 0.10, bottom: 0.90, right: 0.90 }
          },
          // enable autoScroll
          autoScroll: true,

          // call this function on every dragmove event
          onmove: self.dragMoveListener,
          // call this function on every dragend event
          onend: function onend(event) {}

        });

        interact(document).on('down', function (event) {
          var interaction = event.interaction;
          var canGesture = interaction.target && interaction.target.options.gesture.enabled;
          var maxAllowedPointers = canGesture ? 2 : 1;

          while (interaction.pointers.length > maxAllowedPointers) {
            interaction.removePointer(interaction.pointers[0]);
          }
        });

        // Bind click
        interact("#draggableContainer .item").on('tap', function (event) {
          var element = $(event.target);
          if (!element.hasClass("item")) element = element.closest(".item");
          var index = element.data("item-index");
          self.clickedItem(self.currentPictureWall.articles[index]);
          event.preventDefault();
        }, true /* useCapture */);
      });
    },

    dragMoveListener: function dragMoveListener(event) {
      var target = event.target,

      // keep the dragged position in the data-x/data-y attributes
      x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
          y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

      // translate the element
      target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

      // update the posiion attributes
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    },

    clickedItem: function clickedItem(article) {

      var format = "portrait";

      if (typeof article.format != 'undefined') format = article.format;

      var conditions = article.size + format;

      // Update vuex store with current picture wall field and conditions
      this.$store.commit('currentWallField', article.item);
      this.$store.commit('currentWallFieldConditions', conditions);
      this.$store.commit('currentWallFieldSize', article.size);

      // Open picker for pickarticle
      window.eventHub.$emit('clickedPictureWallItem');
    },


    getArticleIndex: function getArticleIndex(itemNumber) {

      if (itemNumber == 0) return itemNumber;

      return itemNumber - 1;
    },

    getArticleFieldID: function getArticleFieldID(itemNumber) {
      return itemNumber;
    },

    checkArticle: function checkArticle(index) {
      if (this.$store.state.chosenArticles[index]) return true;

      return false;
    },

    getFrameImage: function getFrameImage(article) {

      var fieldID = this.getArticleFieldID(article.item);
      var size = article.size;
      var articleNumber = this.chosenFrames[fieldID].articleNumber;

      // Check if landscape
      var landscape = "";
      if (this.checkLandScape(article)) {
        landscape = "-landscape";
      }

      return window.appSettings.productImageUrl + "/zoom/" + articleNumber + landscape + ".png";
    },


    checkLandScape: function checkLandScape(item) {

      if (typeof item.format != 'undefined' && item.format == 'landscape') return true;

      return false;
    }

  },

  mounted: function mounted() {

    var self = this;

    // When a new picture wall has been selected
    window.eventHub.$on('newPictureWall', function (data) {
      self.initDrag();
    });

    // When to open article picker
    window.eventHub.$on('clickPictureWallArticle', function (article) {
      self.clickedItem(article);
    });
  }
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

  data: function data() {
    return {
      wgURL: window.appSettings.wgURL
    };
  },

  methods: {
    start: function start() {
      window.eventHub.$emit('openPicker', 'backgrounds');
    },
    welcomeBG: function welcomeBG() {

      var requiredWidth = this.pictureWallWidth();

      if (!requiredWidth) var url = this.wgURL + '/general/welcome-bg.jpg';

      // If transformed image use cloudinary to get correct size
      else var url = window.appSettings.getResizedImageFromCloud(requiredWidth, 'welcome-bg.jpg?v=1', 'backgrounds/');

      return url;
    }
  }

};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_PictureWall_PictureWall__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_PictureWall_PictureWall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_PictureWall_PictureWall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Picker_Picker__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Picker_Picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Picker_Picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Picker_FramePicker__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Picker_FramePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Picker_FramePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Picker_ArticlePicker__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Picker_ArticlePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Picker_ArticlePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Picker_SavedWallsPicker__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Picker_SavedWallsPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Picker_SavedWallsPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Misc_Tooltip__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Misc_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Misc_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Filter_ArticleFilterWG__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Filter_ArticleFilterWG___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Filter_ArticleFilterWG__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Misc_PriceNotifier__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Misc_PriceNotifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Misc_PriceNotifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Basket_Basket__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Basket_Basket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Basket_Basket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Misc_LoginTest__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Misc_LoginTest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Misc_LoginTest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Misc_StepProgressBar__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Misc_StepProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Misc_StepProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Misc_NextStep__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Misc_NextStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Misc_NextStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Basket_SiteBasket__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Basket_SiteBasket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_Basket_SiteBasket__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    PictureWall: __WEBPACK_IMPORTED_MODULE_0_components_PictureWall_PictureWall___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_1_components_Picker_Picker___default.a,
    FramePicker: __WEBPACK_IMPORTED_MODULE_2_components_Picker_FramePicker___default.a,
    ArticlePicker: __WEBPACK_IMPORTED_MODULE_3_components_Picker_ArticlePicker___default.a,
    SavedWallsPicker: __WEBPACK_IMPORTED_MODULE_4_components_Picker_SavedWallsPicker___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_5_components_Misc_Tooltip___default.a,
    ArticleFilterWg: __WEBPACK_IMPORTED_MODULE_6_components_Filter_ArticleFilterWG___default.a,
    Basket: __WEBPACK_IMPORTED_MODULE_8_components_Basket_Basket___default.a,
    LoginTest: __WEBPACK_IMPORTED_MODULE_9_components_Misc_LoginTest___default.a,
    StepProgressBar: __WEBPACK_IMPORTED_MODULE_10_components_Misc_StepProgressBar___default.a,
    NextStep: __WEBPACK_IMPORTED_MODULE_11_components_Misc_NextStep___default.a,
    SiteBasket: __WEBPACK_IMPORTED_MODULE_12_components_Basket_SiteBasket___default.a
  },

  data: function data() {
    return {
      menuActive: 0,
      mobileBottomMenuActive: 0,
      buyActive: false,
      buyButtonActive: true,
      wgURL: window.appSettings.wgURL
    };
  },

  computed: {
    pkr: function pkr() {
      return this.$store.state.currentPicker;
    },
    siteBasketQty: function siteBasketQty() {
      return this.$store.state.siteBasket.qty;
    },
    siteBasketSum: function siteBasketSum() {
      return this.$t('currencyPrefix') + this.$store.state.siteBasket.sum + this.$t('currencySuffixBuy');
    },
    price: function price() {
      return this.$store.state.price;
    },
    disablePictureWall: function disablePictureWall() {
      return this.$store.state.disablePictureWall;
    },
    savedWallsPickerActive: function savedWallsPickerActive() {
      return this.$store.state.savedWallsPickerActive;
    },
    showMenu: function showMenu() {
      return !this.currentPicker;
    },
    buyLoading: function buyLoading() {
      if (isset(his.$store.state.loading['buyButton'])) return this.$store.state.loading['buyButton'];
      return false;
    },
    hideLeftMenu: function hideLeftMenu() {
      return this.$store.state.hideLeftMenu;
    }
  },

  methods: {

    /*-----------------------------------------------
      Go to Desenios homepage
    -----------------------------------------------*/

    goToDesenio: function goToDesenio() {

      var self = this;

      this.promtSave(function () {
        window.location = self.$t('pageUrl');
      });
    },


    /*-----------------------------------------------
      Open/toggle pickers, using events
    -----------------------------------------------*/

    openPicker: function openPicker(type) {

      // Open picker
      window.eventHub.$emit('openPicker', type);
    },
    openFramePicker: function openFramePicker() {

      // Open picker
      window.eventHub.$emit('openFramePicker');
    },
    toggleSavedWallsPicker: function toggleSavedWallsPicker() {
      window.eventHub.$emit('toggleSavedWalls');
    },


    /*--------------------------------------------------
      Open basket (resides in left panel) using events
    --------------------------------------------------*/

    toggleSiteBasket: function toggleSiteBasket() {
      window.eventHub.$emit('toggleSiteBasket');
    },
    closeSiteBasket: function closeSiteBasket(e) {
      window.eventHub.$emit('closeSiteBasket', e);
    },
    openBasket: function openBasket() {
      window.eventHub.$emit('openBasket');
    },


    /*------------------------------------------------------------------
      Functions for bottom right menu, open modals and menus, buy etc
    ------------------------------------------------------------------*/

    toggleMobileMenu: function toggleMobileMenu() {
      this.mobileBottomMenuActive = !this.mobileBottomMenuActive;
      window.eventHub.$emit('closeRightMenus', 'mobileMenu');
      window.eventHub.$emit('toggleMobileMenu');
    },
    resetPictureWall: function resetPictureWall() {
      this.clearPictureWall();
      this.buyButtonActive = true;
    },
    openSave: function openSave() {

      var self = this;

      if (!self.ifArticlesExists()) {
        window.eventHub.$emit('openModal', {
          modal: 'message',
          data: {
            title: self.$t('errorTitle'),
            message: self.$t('needsArticlesSave'),
            confirmTxt: self.$t('close'),
            confirm: true,
            onConfirm: function onConfirm() {
              window.eventHub.$emit('closeModal');
            }
          }
        });

        return false;
      }

      window.eventHub.$emit('openModal', { modal: 'save' });
    },
    share: function share() {

      var self = this;

      // Check if we have something to share

      if (!self.ifArticlesExists()) {
        window.eventHub.$emit('openModal', {
          modal: 'message',
          data: {
            title: self.$t('errorTitle'),
            message: self.$t('needsArticlesShare'),
            confirmTxt: self.$t('close'),
            confirm: true,
            onConfirm: function onConfirm() {
              window.eventHub.$emit('closeModal');
            }
          }
        });

        return false;
      }

      // Prompt to save if needed first
      self.promtSave(function () {

        // If still not saved, abort
        if (self.$store.state.updated) return false;

        // Open share modal
        window.eventHub.$emit('openModal', { modal: 'share' });
      }, {
        title: self.$t('shareSaveTitle'),
        message: self.$t('shareSaveText')
      });
    },


    // Buy function
    buy: function buy() {

      var self = this;
      var utc = new Date().toJSON().slice(0, 10).replace(/-/g, '-');

      if (self.buyActive) {
        return false;
      }

      // Prevent double click and fallback
      self.buyActive = true;
      setTimeout(function () {
        self.buyActive = false;
      }, 5000);

      self.$store.commit('startLoading', 'buyButton');

      if (!self.$store.state.updated) {
        self.makeBuy();
        return true;
      }

      this.buyButtonActive = false;

      // Create image if saving
      self.createImage(function (response) {

        // Save and pass data
        window.apiHandler.save(function (data) {

          if (data.status) {

            // Save the current ID if user is going back
            var Cookies = __webpack_require__(1);
            Cookies.set('cartSave', {
              'id': data.savedWall.id,
              'identifier': data.savedWall.identifier
            }, { expires: 999, path: '/' });

            // Do buy
            self.makeBuy();

            self.trackEvent('added to cart step');
          }
          // If error occured
          else {
              self.promptError();
            }

          self.buyButtonActive = true;
        }, {
          name: self.$t('addedToCartDate', { date: utc }),
          picture: response.filename
        });
      });
    },
    makeBuy: function makeBuy() {
      var self = this;
      self.$store.commit('stopLoading', 'buyButton');
      window.apiHandler.buy(function (data) {
        window.eventHub.$emit('closeRightMenus', 'all');
        window.eventHub.$emit('openSiteBasket');
        self.$store.commit('stopLoading', 'buyButton');
        setTimeout(function () {
          self.buyActive = false;
        }, 1700);
      });
    },
    checkStock: function checkStock() {

      var self = this;

      var articles = window.apiHandler.buildChosenArticles({ includeFrames: true });

      var foundCopper = false;
      var foundSilver = false;

      var message = "";

      if (message) {

        window.eventHub.$emit('openModal', {
          modal: 'message',
          data: {
            title: self.$t('noStock'),
            message: message,
            confirmTxt: self.$t('close'),
            confirm: true,
            messageClass: "longtext",
            onConfirm: function onConfirm() {
              window.eventHub.$emit('closeModal');
            }
          }
        });
      }
    }
  },

  mounted: function mounted() {

    var self = this;

    // Close mobile menu if right menus should be closed
    window.eventHub.$on('closeRightMenus', function (type) {
      if (type != 'mobileMenu') self.mobileBottomMenuActive = false;
    });

    // When showing error outside of vue
    window.eventHub.$on('promptError', function (message) {
      self.promptError(message);
    });

    // When to set url
    window.eventHub.$on('setSavedUrl', function (id) {
      self.setSavedUrl(id);
    });

    // If we should load a saved wall by url
    var savedData = self.getSavedData();

    if (savedData) {
      savedData.checkOwner = true;
      window.eventHub.$emit('pickSavedWall', savedData);
    }

    // If we should load a saved wall after purchase
    var Cookies = __webpack_require__(1);
    var cartSave = Cookies.get('cartSave');

    if (typeof cartSave != 'undefined') {

      cartSave = JSON.parse(cartSave);

      if (cartSave.id && cartSave.identifier) {
        window.eventHub.$emit('pickSavedWall', cartSave);
        Cookies.remove('cartSave');
        window.eventHub.$emit('closeModal');
      }
    }

    window.addEventListener('orientationchange', function () {
      this.screen_width;
    });
  }
};

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(102)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(75)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(77)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(148),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(82)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(83)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(101)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(100)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(78)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(85)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  "data-v-4c26fcb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(81)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(152),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(176),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(76)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(79)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(175),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      siteBasket: true, active: _vm.active
    },
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "innerCart"
  }, [(!_vm.articles.length) ? _c('div', [_c('div', {
    staticClass: "emptyText"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("emptyBasket")) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "checkout black adapted button full-width",
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("close")) + "\n\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.articles.length) ? _c('div', {
    staticClass: "full-height"
  }, [_c('div', {
    staticClass: "hide-for-desktop"
  }, [_c('a', {
    attrs: {
      "href": "/cgi-bin/ibutik/AIR_ibutik.fcgi?funk=bestall_steg1"
    }
  }, [_c('div', {
    staticClass: "checkout black adapted button full-width"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("checkout")) + "\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "topSummary title hide-for-desktop float-left full-width large-spacing-top large-spacing-bottom"
  }, [_c('div', {
    staticClass: "totalPrice spacing-bottom float-left full-width"
  }, [_c('span', {
    staticClass: "txt float-left medium-large-text price-font"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("total")) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "cart-totalprice float-right"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
    }
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.data.sum) + "\n\t\t\t\t\t\t"), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencySuffix'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "freeShipping float-left full-width small-text"
  })]), _vm._v(" "), _c('div', {
    staticClass: "siteBasketArticles"
  }, _vm._l((_vm.articles), function(article) {
    return _c('div', {
      key: article.id,
      staticClass: "articleRow"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImageDB(article)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "information"
    }, [_c('div', {
      staticClass: "name ellipsis title"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(article.title) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('div', {
      class: {
        originalPrice: true, oldPrice: article.campaignPrice
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(article.price) + "\n\t\t\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]), _vm._v(" "), (article.campaignPrice) ? _c('div', {
      class: {
        newPrice: true
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(article.campaignPrice) + "\n\t\t\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "qty style-forms"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (article.quantity),
        expression: "article.quantity"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(article, "quantity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.changeQty(article, false, $event)
        }]
      }
    }, _vm._l((10), function(i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": i
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(i) + "\n\t\t\t\t\t\t\t\t")])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.changeQty(article, true, $event)
        }
      }
    }, [(_vm.removeLoading[article.id]) ? _c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    }) : _vm._e(), _vm._v(" "), (!_vm.removeLoading[article.id]) ? _c('i', {
      staticClass: "fa fa-trash"
    }) : _vm._e()])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "bottomSummary title show-for-desktop float-left full-width"
  }, [_c('div', {
    staticClass: "totalPrice float-left full-width"
  }, [_c('span', {
    staticClass: "txt float-left normal-text price-font"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("total")))]), _vm._v(" "), _c('span', {
    staticClass: "cart-totalprice float-right price-font"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.data.sumPrefix) + _vm._s(Math.round(_vm.data.sum * 100) / 100) + _vm._s(_vm.data.sumSuffix) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.checkoutUrl
    }
  }, [_c('div', {
    staticClass: "checkout black adapted button full-width"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("checkout")) + "\n\t\t\t\t\t")])])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      picker: true, active: _vm.active
    }
  }, [(_vm.showList && _vm.active) ? _c('div', {
    staticClass: "full-height pickerListContainer"
  }, [(_vm.type == 'pictureWalls') ? _c('picture-wall-list', {
    attrs: {
      "list-data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'backgrounds') ? _c('background-list', {
    attrs: {
      "list-data": _vm.data
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listing backgroundList"
  }, _vm._l((_vm.listData), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item full smooth hoverFade"
    }, [_c('div', {
      staticClass: "image hover-fade smooth pointer",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getThumb(item.preview)
      }
    })]), _vm._v(" "), (_vm.currentBackgroundId == item.id) ? _c('color-list', {
      attrs: {
        "background-data": item
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      invisible: !_vm.progress
    },
    attrs: {
      "id": "stepProgressBar"
    }
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      width: _vm.progress + '%'
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pictureWall"
    },
    on: {
      "click": _vm.closeTopPickers
    }
  }, [_c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "identifier": "mainPictureWall"
    }
  }), _vm._v(" "), (_vm.pictureWallActive) ? _c('div', {
    class: {
      outer: true, opacityHide: _vm.hideImage
    },
    style: ({
      backgroundImage: 'url(' + _vm.activeBG + ')'
    }),
    attrs: {
      "id": "zoomElement"
    }
  }, [(_vm.activeOverlay) ? _c('div', {
    staticClass: "overlayBG",
    style: ({
      backgroundImage: 'url(' + _vm.activeOverlay + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.currentPictureWall) ? _c('div', {
    staticClass: "articlesContainer",
    style: ({
      left: _vm.leftWallPosition
    }),
    attrs: {
      "id": "draggableContainer"
    }
  }, _vm._l((_vm.currentPictureWall.articles), function(article, index) {
    return _c('div', {
      key: index,
      class: {
        blink: _vm.highlightPictureWallItems, item: true, active: _vm.currentPictureWallField == _vm.getArticleFieldID(article.item), hasFrame: _vm.chosenFrames[_vm.getArticleFieldID(article.item)], hasArticle: _vm.chosenArticles[_vm.getArticleFieldID(article.item)], landscape: _vm.checkLandScape(article)
      },
      style: ({
        top: article.top + '%',
        left: article.left + '%'
      }),
      attrs: {
        "data-size": article.size,
        "data-position": index,
        "data-item-index": index
      }
    }, [(!_vm.chosenArticles[_vm.getArticleFieldID(article.item)]) ? _c('div', {
      staticClass: "inner"
    }, [_vm._v("\n            " + _vm._s(article.size) + "\n          ")]) : _c('div', {
      staticClass: "chosenArticle",
      style: ({
        background: 'url(' + _vm.getArticleImage(_vm.chosenArticles[index + 1]) + ')'
      })
    }), _vm._v(" "), (_vm.chosenFrames[_vm.getArticleFieldID(article.item)]) ? _c('div', {
      staticClass: "frame"
    }, [_c('img', {
      attrs: {
        "src": _vm.getFrameImage(article)
      }
    })]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.showWelcome) ? _c('welcome') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentPicker == 'articles') ? _c('notification-tooltip', {
    key: "buyHere",
    attrs: {
      "click-hide": "true",
      "position": "middle",
      "identifier": "heartInfo",
      "show-once": true,
      "title": "heartInfoTitle",
      "text": "heartInfo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.steps.complete && _vm.currentPicker == '') ? _c('notification-tooltip', {
    attrs: {
      "position": "buyButton",
      "title": "purchaseNowTitle",
      "text": "purchaseNow",
      "identifier": "buyHere"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.background
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "loginContainer"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tBygg din tavelvägg beta\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(" \n\t\tVälkommen till betaverisonen utav bygg din tavelvägg, var god skriv in ditt namn nedan. \n\t")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.setName
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.setName
    }
  }, [_vm._v(" SKICKA ")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "submit"
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addedToCartModal"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.$t('waresAddedToCart')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }, [_c('loader', {
    attrs: {
      "loading": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message raleway"
  }, [_vm._v(" " + _vm._s(_vm.$t('proceedingToCheckout')) + "   ")])])
},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    staticClass: "dataList colorList"
  }, [_c('div', {
    attrs: {
      "id": "colorSliderElement"
    }
  }, _vm._l((_vm.colors), function(item) {
    return (_vm.backgroundHasColor(item)) ? _c('div', {
      staticClass: "item hover-fade smooth pointer",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      class: {
        color: true
      },
      style: ({
        background: item.preview,
        border: item.border
      })
    }, [(_vm.currentColor.key == item.key) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e()])]) : _vm._e()
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listing pictureWallList smooth"
  }, [_c('div', {
    attrs: {
      "id": "wallSliderElement"
    }
  }, _vm._l((_vm.listData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item hoverFade",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.imageUrl + '/' + item.image_path
      }
    })])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "custom",
      "enter-active-class": _vm.fadeIn,
      "leave-active-class": _vm.fadeOut
    }
  }, [(_vm.loading || _vm.identifierLoading) ? _c('div', {
    class: {
      loadContainer: true, inline: _vm.inline
    }
  }, [(_vm.identifier && _vm.identifierLoading) ? _c('div', {
    class: 'loader ' + _vm.classes
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    class: 'loader ' + _vm.classes
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipeDeviceOverlay"
  }, [(!_vm.hidden) ? _c('div', {
    staticClass: "iconContainer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.$t('swipeUp')))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "modalContainer"
  }, [_c('div', {
    class: {
      modal: true, autoHeight: _vm.heigth == 'auto'
    },
    style: ({
      heigth: _vm.heigth
    }),
    attrs: {
      "id": "modalContent"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.currentModal == 'save') ? _c('modal-save') : _vm._e(), _vm._v(" "), (_vm.currentModal == 'addedToCart') ? _c('modal-added-to-cart') : _vm._e(), _vm._v(" "), (_vm.currentModal == 'message') ? _c('modal-message', {
    attrs: {
      "message-data": _vm.modalData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentModal == 'share') ? _c('modal-share') : _vm._e(), _vm._v(" "), (_vm.currentModal == 'noStock') ? _c('modal-no-stock') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modalBG",
    on: {
      "click": _vm.close
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "name": "fade"
    }
  }, [_c('div', {
    attrs: {
      "id": "priceNotifier"
    }
  }, [_vm._v("\n \t\tPriset har uppdaterats\n \t")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "name": "fade"
    }
  }, [(_vm.active) ? _c('div', {
    ref: "tooltip",
    class: {
      tooptip: true
    },
    style: ({
      top: _vm.top + 'px',
      left: _vm.left + _vm.maxWidth + 'px',
      maxWidth: _vm.maxWidth + 'px'
    }),
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" \n\t \t   " + _vm._s(_vm.message) + " \n\t     "), _c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saveModal"
  }, [(_vm.saving) ? _c('div', {
    staticClass: "saveContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('saveBasket')))]), _vm._v(" "), _c('div', {
    staticClass: "saveForm"
  }, [_c('form', {
    on: {
      "submit": _vm.save
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('name')) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.save
    }
  }, [(_vm.saved) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "inline": true,
      "classes": "",
      "identifier": "save"
    }
  }), _vm._v("\n    \t\t\t\t" + _vm._s(_vm.$t('save')) + "\n    \t\t\t")], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "submit"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.updating) ? _c('div', {
    staticClass: "updateContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('saveBasket')))]), _vm._v(" "), _c('div', {
    staticClass: "message raleway"
  }, [_vm._v(" " + _vm._s(_vm.$t('updateOrnew', {
    name: _vm.currentName
  })) + " ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.updateSave
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "updateButtons text-center"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.updateSave
    }
  }, [(_vm.saved) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "inline": true,
      "classes": "",
      "identifier": "save"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('update')) + "\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.showSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('createNew')) + "  ")])]), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "submit"
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "updateName"
  }, [_c('input', {
    attrs: {
      "id": "updateName",
      "type": "text"
    }
  })])
}]}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      articlePicker: true, flipToggle: true, active: _vm.active
    }
  }, [_c('div', {
    staticClass: "filterPanel"
  }, [_c('div', {
    class: {
      filterButton: true, disabled: _vm.currentArticleSorting != 'all'
    },
    on: {
      "click": _vm.toggleFilter
    }
  }, [(!_vm.filterActive) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('showFilter')) + "  "), _c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), _vm._v(" "), (_vm.filterActive) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('hideFilter')) + "  "), _c('i', {
    staticClass: "icon-close bold"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "filterButton sortButton"
  }, [_c('div', {
    staticClass: "currentSorting",
    on: {
      "click": function($event) {
        _vm.sortingActive = !_vm.sortingActive
      }
    }
  }, [(_vm.currentArticleSorting == 'all') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('allProducts')) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "listing articleList",
    attrs: {
      "id": "articleScroller"
    },
    on: {
      "scroll": _vm.checkLazy
    }
  }, [(_vm.chosenFilters && _vm.currentArticleSorting == 'all') ? _c('div', {
    staticClass: "filterChoices"
  }, _vm._l((_vm.chosenFilters), function(filter) {
    return _c('div', {
      staticClass: "chosenFilter hover-fade",
      on: {
        "click": function($event) {
          _vm.removeFilterChoice(filter)
        }
      }
    }, [_vm._v(" \n\t\t\t \t" + _vm._s(filter.title) + "\n\t\t\t")])
  })) : _vm._e(), _vm._v(" "), (_vm.articles) ? _c('div', [(_vm.currentArticleSorting == 'favorites') ? _c('div', {
    staticClass: "favMatch"
  }, [(_vm.device.isMobile) ? _c('span', [_vm._v("\n  \t\t\t\t\t" + _vm._s(_vm.$t('favoritesThatMatchMobile')) + "\n  \t\t\t\t")]) : _c('span', [_vm._v("\n  \t\t\t\t\t" + _vm._s(_vm.$t('favoritesThatMatch')) + "\n  \t\t\t\t")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.articles), function(item) {
    return (_vm.filterOutUnwantedArticles(item)) ? _c('div', {
      staticClass: "item small-full medium-half large-third smooth"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "image",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "imgInner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImage(item)
      }
    })])]), _vm._v(" "), _c('div', {
      class: {
        tags: true, active: _vm.articleHasCampaign(item)
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.campaignBadge))])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.price) + "\n\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    class: {
      lazyLoading: true, active: !_vm.lazyDone
    }
  }, [_c('loader', {
    attrs: {
      "loading": true
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.articles && _vm.noArticles && !_vm.loading) ? _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('noArticlesMatched', {
        size: _vm.currentSize
      }))
    }
  }) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "classes": "cover dimmer",
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shareModal"
  }, [_c('div', {
    staticClass: "shareImage"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImage()
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('shareTitle')) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      basket: true, flipToggle: true, active: _vm.active
    }
  }, [(!_vm.hasPictureWall) ? _c('div', {
    staticClass: "title tiny-heading"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t("needsPictureWall")) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.hasPictureWall) ? _c('div', {
    staticClass: "title tiny-heading"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t("clickToPickMotif")) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.hasArticles) ? _c('div', {
    staticClass: "chosenArticles"
  }, _vm._l((_vm.articles), function(article, index) {
    return (article) ? _c('div', {
      key: index,
      staticClass: "article"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImage(article)
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "name ellipsis"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('div', {
      class: {
        originalPrice: true, oldPrice: article.campaignPrice
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(article.price) + "\n\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]), _vm._v(" "), (article.campaignPrice) ? _c('div', {
      class: {
        newPrice: true
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(article.campaignPrice) + "\n\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('currencySuffix'))
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.removeProduct(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rotateDeviceOverlay"
  }, [(!_vm.hidden) ? _c('div', {
    staticClass: "iconContainer"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("turnDevice")))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone"
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])
}]}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      savedWallsPicker: true, active: _vm.active, noSlickNav: _vm.itemsInRow >= _vm.savedWalls.length
    }
  }, [(_vm.savedWalls && _vm.savedWalls.length) ? _c('div', {
    staticClass: "listing",
    attrs: {
      "id": "savedWallsScroller"
    }
  }, _vm._l((_vm.savedWalls), function(item, index) {
    return _c('div', {
      staticClass: "item hover-fade",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "image relative",
      style: ({
        backgroundImage: 'url(' + _vm.getImage(item) + ')'
      })
    }, [_c('loader', {
      attrs: {
        "classes": "cover dimmer",
        "fade-in": "fadeIn",
        "fade-out": "fadeOut",
        "identifier": 'pickWall' + item.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(item.settings.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "remove smooth",
      on: {
        "click": function($event) {
          _vm.deleteItem(item, $event, index)
        }
      }
    }, [_c('loader', {
      attrs: {
        "inline": true,
        "classes": "",
        "identifier": 'deleteSave' + item.id
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash"
    })], 1)], 1)])])
  })) : _vm._e(), _vm._v(" "), (!_vm.savedWalls.length && !_vm.loading) ? _c('div', {
    staticClass: "noSaves"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('noSavedWalls')) + " ")])])]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "classes": "cover dimmer",
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appContainer",
    on: {
      "click": function($event) {
        _vm.closeSiteBasket($event)
      }
    }
  }, [_c('div', {
    staticClass: "page"
  }, [(!_vm.disablePictureWall) ? _c('div', {
    staticClass: "rightSection u-pull-right"
  }, [_c('site-basket'), _vm._v(" "), _c('div', {
    staticClass: "rightMenu"
  }, [_c('saved-walls-picker', {
    ref: "savedWalls"
  }), _vm._v(" "), _c('div', {
    staticClass: "button mobileBottomMenuToggle",
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [(!_vm.mobileBottomMenuActive) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v(" "), (_vm.mobileBottomMenuActive) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.$t('menu')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.toggleSavedWallsPicker
    }
  }, [(!_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-down hide-for-mobile"
  }) : _vm._e(), _vm._v(" "), (_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-up hide-for-mobile"
  }) : _vm._e(), _vm._v(" "), (!_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-up show-for-mobile-inline"
  }) : _vm._e(), _vm._v(" "), (_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-down show-for-mobile-inline"
  }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.$t('savedWalls')) + "\n            ")]), _vm._v(" "), _c('div', {
    class: {
      mobileBottomMenuItems: true, active: _vm.mobileBottomMenuActive
    }
  }, [_c('div', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.price <= 0
    },
    on: {
      "click": _vm.openSave
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('save')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.share
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" " + _vm._s(_vm.$t('share')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.resetPictureWall
    }
  }, [_c('i', {
    staticClass: "icon-picture-wall"
  }), _vm._v("  " + _vm._s(_vm.$t('createNew')) + " ")]), _vm._v(" "), (_vm.locale == 'sv') ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.wgURL + '/general/Desenio-picture-wall.pdf'
    }
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "buyRightContainer u-pull-right"
  }, [_c('div', {
    staticClass: "cartContainer u-pull-left",
    on: {
      "click": _vm.toggleSiteBasket
    }
  }, [_c('div', {
    staticClass: "qty"
  }, [_vm._v(" " + _vm._s(_vm.siteBasketQty) + " ")]), _vm._v(" "), _c('i', {
    staticClass: "cart-icon"
  })]), _vm._v(" "), (!_vm.device.isMobile) ? _c('a', {
    attrs: {
      "href": _vm.checkoutUrl
    }
  }, [_c('div', {
    staticClass: "fullButton u-pull-right text-center cta black"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('toCheckout')) + " "), _c('div', {
    staticClass: "basketSum",
    domProps: {
      "innerHTML": _vm._s(_vm.siteBasketSum)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fullButton u-pull-right text-center cta black addToCartMobile",
    on: {
      "click": _vm.buy
    }
  }, [_c('loader', {
    attrs: {
      "classes": "",
      "inline": true,
      "identifier": "buyButton"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "largePhone"
  }, [_vm._v(" " + _vm._s(_vm.$t('addToCart')) + " "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "smallPhone"
  }, [_vm._v(" " + _vm._s(_vm.$t('addToCartSmall')) + " "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basketSum"
  }, [_c('price', {
    attrs: {
      "inline": true
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs hide-for-mobile"
  }, [_c('a', {
    attrs: {
      "href": _vm.$t('pageUrl')
    }
  }, [_vm._v(_vm._s(_vm.$t('breadcrumbPrints')) + " /")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$t('breadcrumbInspLink')
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('breadcrumbInsp')) + " /")]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": _vm.$t('breadcrumbGwLink')
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('breadcrumbGw')))])])], 1), _vm._v(" "), _c('article-filter-wg'), _vm._v(" "), _c('picture-wall', {
    ref: "pictureWall"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      leftSection: true, rightBorder: true, floatLeft: true, invisible: _vm.hideLeftMenu
    }
  }, [(_vm.currentPicker) ? _c('div', {
    staticClass: "closePicker hide-for-mobile"
  }, [_c('div', {
    staticClass: "inner",
    on: {
      "click": function($event) {
        _vm.closePickers('all')
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      logo: true, hideOnMobile: _vm.currentLeftTitle
    }
  }, [_c('img', {
    attrs: {
      "src": "https://checkout.desenio.se/frontend/view_desktop/design/logos/desenio-logo-black.svg"
    },
    on: {
      "click": _vm.goToDesenio
    }
  })]), _vm._v(" "), (_vm.currentPicker) ? _c('div', {
    staticClass: "topPanel relative row"
  }, [_c('div', {
    staticClass: "name tiny-heading u-pull-left"
  }, [_vm._v(" " + _vm._s(_vm.currentLeftTitle) + " ")])]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "classes": "cover dimmer",
      "identifier": "picker"
    }
  }), _vm._v(" "), _c('picker'), _vm._v(" "), _c('frame-picker'), _vm._v(" "), _c('article-picker'), _vm._v(" "), _c('basket'), _vm._v(" "), _c('div', {
    staticClass: "bottomActions"
  }, [(_vm.currentPicker) ? _c('next-step') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leftMenu",
    class: {
      active: _vm.showMenu
    }
  }, [_c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.background
    },
    on: {
      "click": function($event) {
        _vm.openPicker('backgrounds')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "name raleway"
  }, [_vm._v(" " + _vm._s(_vm.$t('pick')) + " " + _vm._s(_vm.$tc('background', 1)))])]), _vm._v(" "), _c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.pictureWall
    },
    on: {
      "click": function($event) {
        _vm.openPicker('pictureWalls')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "name raleway"
  }, [_vm._v(_vm._s(_vm.$t('pick')) + " " + _vm._s(_vm.$tc('picturewall', 1)))])]), _vm._v(" "), _c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.motifs
    },
    attrs: {
      "id": "pickMotifs"
    },
    on: {
      "click": _vm.openBasket
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('span', {
    staticClass: "name raleway"
  }, [_vm._v(_vm._s(_vm.$t('pick')) + " " + _vm._s(_vm.$tc('motifs', 1)))])]), _vm._v(" "), _c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.frames
    },
    on: {
      "click": _vm.openFramePicker
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('frameYourMotifs')) + " ")])])]), _vm._v(" "), (!_vm.currentPicker) ? _c('div', {
    staticClass: "buyLeft"
  }, [_c('price'), _vm._v(" "), (_vm.buyButtonActive) ? _c('div', [_c('div', {
    staticClass: "button cta adapted buyButtonLeft hoverFade",
    on: {
      "click": _vm.buy
    }
  }, [_c('loader', {
    attrs: {
      "classes": "",
      "inline": true,
      "identifier": "buyButton"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('addToCart')) + "\n            "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "button cta adapted buyButtonLeft",
    staticStyle: {
      "background-color": "#888",
      "border": "none"
    }
  }, [_c('loader', {
    attrs: {
      "classes": "",
      "inline": true,
      "identifier": "buyButton"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('addToCart')) + "\n            "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })], 1)])], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" Ritningar ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-pictures"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("1 "), _c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-picture-wall"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("2 "), _c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-article"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("3 "), _c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-frame"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("4 "), _c('i', {
    staticClass: "fa fa-check"
  })])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.closed) ? _c('div', {
    class: {
      notificationTooltip: true, buyButton: _vm.position && _vm.position == 'buyButton', middle: _vm.position && _vm.position == 'middle'
    }
  }, [_c('span', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.title))
    }
  }, [_vm._v(" {!  !} ")]), _vm._v(" "), _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.text))
    }
  }, [_vm._v(" {!  !} ")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "priceContainer"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": _vm.identifier
    }
  }, [_vm._v(_vm._s(_vm.parsePrice(_vm.price)))]), _vm._v(" "), (!_vm.currencySuffixVersion || _vm.currencySuffixVersion == '1') ? _c('span', {
    staticClass: "prefix",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencySuffix'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currencySuffixVersion && _vm.currencySuffixVersion == '2') ? _c('span', {
    staticClass: "prefix",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencySuffixBuy'))
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      framePicker: true, active: _vm.active, relative: true
    }
  }, [(!_vm.loading && _vm.frames && _vm.steps.pictureWall) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      articleContainer: true, several: _vm.several
    }
  }, [_c('div', {
    staticClass: "centerSlider",
    attrs: {
      "id": "frameArticleSlider"
    }
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-field": "all"
    }
  }, [_c('div', {
    staticClass: "productShell"
  }, [_c('img', {
    attrs: {
      "src": _vm.wgURL + '/general/dummy-article.jpg'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t('allArticles')) + " ")])])]), _vm._v(" "), _vm._l((_vm.articles), function(article, index) {
    return (_vm.getFrameField(index)) ? _c('div', {
      key: index,
      staticClass: "item",
      attrs: {
        "data-field": index
      }
    }, [(!_vm.chosenArticles[_vm.getArticleFieldID(article.item)]) ? _c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "productShell"
    }, [_c('img', {
      attrs: {
        "src": _vm.wgURL + '/general/dummy-article.jpg'
      }
    })])]) : _c('div', {
      staticClass: "chosenArticle"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImage(_vm.chosenArticles[index + 1])
      }
    })])])]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.active) ? _c('div', {
    staticClass: "framesContainer",
    attrs: {
      "id": "bottomFrameContainer"
    }
  }, [_c('div', {
    staticClass: "listing",
    attrs: {
      "id": "frameSlider"
    }
  }, [_c('div', {
    staticClass: "frameItem item third deleteFrameItem show-for-mobile-inline activePop",
    on: {
      "click": function($event) {
        _vm.deleteFrames(_vm.frame)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.frames['list']), function(frame, name) {
    return _c('div', {
      key: frame.id,
      staticClass: "frameItem item third smooth activePop",
      on: {
        "click": function($event) {
          _vm.pickFrame(name, frame)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImageDB(frame)
      }
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hide-for-mobile",
    attrs: {
      "id": "removeFramesContainer"
    },
    on: {
      "click": _vm.deleteFrames
    }
  }, [_c('div', {
    staticClass: "button",
    attrs: {
      "id": "removeFrames"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" " + _vm._s(_vm.$t('removeFrame')) + "\n\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), (!_vm.steps.pictureWall) ? _c('div', {
    staticClass: "noPictureWall"
  }, [_vm._v("\n\t\t\t " + _vm._s(_vm.$t('choosePictureWallBeforeFrames')) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "classes": "cover dimmer",
      "identifier": "framesPicker"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deleteFrameItemPic"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messageModal"
  }, [(_vm.messageData.title) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.messageData.title) + " ")]) : _vm._e(), _vm._v(" "), (_vm.messageData.message) ? _c('div', {
    staticClass: "message raleway",
    domProps: {
      "innerHTML": _vm._s(_vm.messageData.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.messageData.confirm) ? _c('div', {
    staticClass: "confirmButtons text-center"
  }, [(_vm.messageData.confirmTxt) ? _c('div', {
    class: {
      button: true, primaryButton: _vm.messageData.primaryButton == 'confirm'
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" " + _vm._s(_vm.messageData.confirmTxt) + " ")]) : _vm._e(), _vm._v(" "), (_vm.messageData.declineTxt) ? _c('div', {
    class: {
      button: true, primaryButton: _vm.messageData.primaryButton == 'decline'
    },
    on: {
      "click": _vm.decline
    }
  }, [_vm._v(" " + _vm._s(_vm.messageData.declineTxt) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.messageData.abortTxt) ? _c('div', {
    class: {
      button: true, primaryButton: _vm.messageData.primaryButton == 'abort'
    },
    on: {
      "click": _vm.abort
    }
  }, [_vm._v(" " + _vm._s(_vm.messageData.abortTxt) + "  ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nextStepContainer"
  }, [_c('div', {
    class: {
      nextStep: true, notActive: !_vm.nextStepActive
    },
    on: {
      "click": _vm.goToNext
    }
  }, [_c('div', {
    staticClass: "button adapted black u-full-width",
    domProps: {
      "innerHTML": _vm._s(_vm.nextStepText)
    }
  })]), _vm._v(" "), (_vm.currentPicker != 'backgrounds') ? _c('div', {
    staticClass: "close button hide-for-mobile adapted",
    on: {
      "click": _vm.goToPrev
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('goBackToStep')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "closePickers button adapted show-for-mobile",
    on: {
      "click": _vm.closePickers
    }
  }, [_c('i', {
    staticClass: "icon-close"
  }), _vm._v(" " + _vm._s(_vm.$t('close')) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hidden) ? _c('div', {
    staticClass: "clickFullscreenOverlay",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('div', {
    staticClass: "iconContainer"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('clickFullscreen')) + " "), _c('i', {
    staticClass: "fa fa-expand"
  })])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('rotate-device'), _vm._v(" "), _c('click-fullscreen'), _vm._v(" "), _c('modal'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      flipToggle: true, active: _vm.active
    },
    attrs: {
      "id": "filter"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    class: {
      clearFilter: true,
        button: true,
        adapted: true,
        tiny: true,
        disabled: !_vm.filterIsActive,
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("clearFilter")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "mobileInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filterOptions"
  }, _vm._l((_vm.filters), function(filterItem) {
    return (_vm.useThisFilter(filterItem)) ? _c('div', {
      key: filterItem.id,
      staticClass: "filterOption"
    }, [_c('div', {
      staticClass: "filterOption bold"
    }, [_vm._v(_vm._s(filterItem.title))]), _vm._v(" "), _vm._l((filterItem.items), function(item) {
      return _c('div', {
        key: item.id,
        class: {
          filterItem: true, disabled: item.numberOfProducts == 0, active: _vm.checkActiveItem(item.id)
        },
        on: {
          "click": function($event) {
            _vm.pickFilter(item)
          }
        }
      }, [_vm._v("\n              " + _vm._s(item.title) + "\n\n              "), _vm._v(" "), (filterItem.id == 1) ? _c('div', {
        staticClass: "colorItem",
        style: (_vm.getColor(item.systemCode))
      }) : _vm._e()])
    })], 2) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.welcomeBG() + ')'
    }),
    attrs: {
      "id": "welcome"
    }
  }, [(!_vm.currentPicker) ? _c('div', {
    staticClass: "startPanel"
  }, [_c('div', {
    staticClass: "topHeading"
  }, [_vm._v(_vm._s(_vm.$t("startTop")))]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.$t("startTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("startText")) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "startButton button white adapted",
    on: {
      "click": _vm.start
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("startButton")) + "\n\t\t")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outofStockModal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('outOfStock')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "message raleway",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('outOfStockText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "articles"
  }, _vm._l((_vm.stockArticles), function(article) {
    return (_vm.stockArticles) ? _c('div', {
      staticClass: "article"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImage(article)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "button small watch",
      on: {
        "click": function($event) {
          _vm.watchProduct(article)
        }
      }
    }, [_vm._v(" Bevaka ")])]) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Misc_Loader_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Misc_Loader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Misc_Loader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modals_Modal_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modals_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Modals_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Misc_Price_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Misc_Price_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Misc_Price_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_localstorage__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_localstorage__);




// enable progressive web app support (with offline-plugin)
if (true) {
	__webpack_require__(17);
}

// Custom global variables
window.localEnviroment = window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("dev.desenio") > -1;
window.appSettings = __webpack_require__(18);
window.modulesPath = '../../../build/modules/';
window.eventHub = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]();
window.$ = window.jQuery = __webpack_require__(3);

// Detect swipe
__webpack_require__(19);

// Global functions
__webpack_require__(14);

// API
__webpack_require__(11);

// FIlter mapping handler
__webpack_require__(13);

// Import global components




// Use global components
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('loader', __WEBPACK_IMPORTED_MODULE_3__components_Misc_Loader_vue___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('modals', __WEBPACK_IMPORTED_MODULE_4__components_Modals_Modal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('price', __WEBPACK_IMPORTED_MODULE_5__components_Misc_Price_vue___default.a);

var customMixins = __webpack_require__(15);

if (customMixins.length) {
	for (var i in customMixins) {
		__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].mixin(customMixins[i]);
	}
}

// PLugin

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_localstorage___default.a);

// MOUNT VUE
window.vueInstance = __WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ajax-loader.c5cd7f53.gif";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slick.ced611da.eot";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slick.d41f55a7.ttf";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slick.b7c9e1e4.woff";

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" standalone=\"no\"?>\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg xmlns=\"http://www.w3.org/2000/svg\">\n<metadata>Generated by Fontastic.me</metadata>\n<defs>\n<font id=\"slick\" horiz-adv-x=\"512\">\n<font-face font-family=\"slick\" units-per-em=\"512\" ascent=\"480\" descent=\"-32\"/>\n<missing-glyph horiz-adv-x=\"512\" />\n\n<glyph unicode=\"&#8594;\" d=\"M241 113l130 130c4 4 6 8 6 13 0 5-2 9-6 13l-130 130c-3 3-7 5-12 5-5 0-10-2-13-5l-29-30c-4-3-6-7-6-12 0-5 2-10 6-13l87-88-87-88c-4-3-6-8-6-13 0-5 2-9 6-12l29-30c3-3 8-5 13-5 5 0 9 2 12 5z m234 143c0-40-9-77-29-110-20-34-46-60-80-80-33-20-70-29-110-29-40 0-77 9-110 29-34 20-60 46-80 80-20 33-29 70-29 110 0 40 9 77 29 110 20 34 46 60 80 80 33 20 70 29 110 29 40 0 77-9 110-29 34-20 60-46 80-80 20-33 29-70 29-110z\"/>\n<glyph unicode=\"&#8592;\" d=\"M296 113l29 30c4 3 6 7 6 12 0 5-2 10-6 13l-87 88 87 88c4 3 6 8 6 13 0 5-2 9-6 12l-29 30c-3 3-8 5-13 5-5 0-9-2-12-5l-130-130c-4-4-6-8-6-13 0-5 2-9 6-13l130-130c3-3 7-5 12-5 5 0 10 2 13 5z m179 143c0-40-9-77-29-110-20-34-46-60-80-80-33-20-70-29-110-29-40 0-77 9-110 29-34 20-60 46-80 80-20 33-29 70-29 110 0 40 9 77 29 110 20 34 46 60 80 80 33 20 70 29 110 29 40 0 77-9 110-29 34-20 60-46 80-80 20-33 29-70 29-110z\"/>\n<glyph unicode=\"&#8226;\" d=\"M475 256c0-40-9-77-29-110-20-34-46-60-80-80-33-20-70-29-110-29-40 0-77 9-110 29-34 20-60 46-80 80-20 33-29 70-29 110 0 40 9 77 29 110 20 34 46 60 80 80 33 20 70 29 110 29 40 0 77-9 110-29 34-20 60-46 80-80 20-33 29-70 29-110z\"/>\n<glyph unicode=\"&#97;\" d=\"M475 439l0-128c0-5-1-9-5-13-4-4-8-5-13-5l-128 0c-8 0-13 3-17 11-3 7-2 14 4 20l40 39c-28 26-62 39-100 39-20 0-39-4-57-11-18-8-33-18-46-32-14-13-24-28-32-46-7-18-11-37-11-57 0-20 4-39 11-57 8-18 18-33 32-46 13-14 28-24 46-32 18-7 37-11 57-11 23 0 44 5 64 15 20 9 38 23 51 42 2 1 4 3 7 3 3 0 5-1 7-3l39-39c2-2 3-3 3-6 0-2-1-4-2-6-21-25-46-45-76-59-29-14-60-20-93-20-30 0-58 5-85 17-27 12-51 27-70 47-20 19-35 43-47 70-12 27-17 55-17 85 0 30 5 58 17 85 12 27 27 51 47 70 19 20 43 35 70 47 27 12 55 17 85 17 28 0 55-5 81-15 26-11 50-26 70-45l37 37c6 6 12 7 20 4 8-4 11-9 11-17z\"/>\n</font></defs></svg>\n"

/***/ })
],[181]);


// WEBPACK FOOTER //
// client.f12ca617.js